const localizations = {
  'button.cancel': '취소',
  'button.delete': '삭제',
  'button.close': '닫기',
  'button.select': '선택',
  'button.selected': '선택됨',
  'button.save-changes': '변경 사항 저장',
  'button.yes-delete': '예, 삭제합니다',
  'button.reset': '재설정',
  'button.reload': '다시 로드',
  'button.to-dashboard': '대시보드 페이지로 돌아가기',
  'button.to-navigation': '탐색 페이지로 돌아가기',
  'button.back': '돌아가기',
  'button.login': '로그인 페이지로',
  'code-preview.copied': '복사됨',
  'code-preview.copy': '코드 복사',
  'app.contact-integrator.notification': '이러한 기능을 사용해야 하는 경우 통합 관리자에게 문의하세요.',
  'app.multi-select.countries.selected': '{number}/{total}개 국가 선택함',
  'app.multi-select.unselect': '모두 선택 해제',
  'app.multi-select.search': '검색',
  'app.multi-select.empty': '아무것도 찾을 수 없음',

  'app.success.title': '성공했습니다!',

  'app.error.title': '오류',
  'app.error.submit-form': '양식을 제출하는 동안 오류가 발생했습니다.',
  'app.error.page.label': '전체 페이지를 로드할 수 없음',
  'app.error.page.text': '프로젝트 페이지의 일부를 로드할 수 없습니다. <br></br>탐색 페이지로 돌아갑니다.',
  'app.error.page.footer': '<doc>문서</doc> • <help>도움말</help> • <chat>문의하기</chat>',
  'app.error.statistic.tooltip': '이 데이터를 가져오는 동안 문제가 발생했습니다. 나중에 다시 시도하세요.',
  'app.error.user-groups.tooltip': '사용자 그룹을 가져오는 동안 문제가 발생했습니다. 나중에 다시 시도하세요.',
  'app.error.000-000': '문제가 발생했습니다.',
  /* Checklist errors */
  'app.error.011-001': '체크리스트를 가져오지 못했습니다.',
  'app.error.011-002': '체크리스트 포인트를 생성하지 못했습니다.',
  'app.error.011-003': '체크리스트 포인트를 삭제하지 못했습니다.',
  'app.error.011-004': '체크리스트 포인트를 확인으로 표시하는 잘못된 요청입니다.',
  'app.error.011-005': '잘못된 프로젝트 체크리스트 진행 요청입니다.',
  /* User storage errors */
  'app.error.008-001': '암호 없는 로그인 URL이 구성되지 않았습니다.',
  'app.error.008-002': '사용자 확인 URL이 구성되지 않았습니다.',
  'app.error.008-003': '새 사용자 URL이 구성되지 않았습니다.',
  'app.error.008-004': '암호 재설정 URL이 구성되지 않았습니다.',
  'app.error.008-005': 'PlayFab 제목 ID가 유효하지 않습니다.',
  'app.error.008-006': 'PlayFab API 키가 유효하지 않습니다.',
  'app.error.008-007': '유효하지 않은 이메일 URL로 외부 계정 ID를 가져왔습니다.',
  'app.error.008-008': '유효하지 않은 API 응답입니다. \"accountID\" 응답 본문 매개변수에 사용자 ID가 포함되어야 합니다.',
  'app.error.008-009': '사용자 정의 저장소 설정에 유효하지 않은 URL이 있습니다.',
  'app.error.008-010': '질문 페이지 URL이 구성되지 않았습니다.',
  'app.error.008-011': '새 암호 설정 페이지 URL이 구성되지 않았습니다.',
  'app.error.008-012': '선택 가능한 값의 형식이 유효하지 않습니다.',
  'app.error.008-013': '동의 페이지 URL이 구성되지 않았거나 유효하지 않습니다.',
  'app.error.008-014': 'Okta 통합이 완료되지 않았습니다.',
  'app.error.008-015': 'SAML 통합이 완료되지 않았습니다.',
  'app.error.008-016': 'Firebase API 키를 설정하지 않았습니다.',
  /* Custom SMS provider */
  'app.error.012-001': '잘못된 사용자 정의 SMS 서비스 제공업체 관리 요청입니다.',
  'app.error.012-002': '이 이름을 갖는 서비스 제공업체가 이미 존재합니다.',
  'app.error.012-003': '사용자 정의 서비스 제공업체를 찾을 수 없습니다.',
  'app.error.012-004': '주어진 매개 변수로 서비스 제공업체를 생성할 수 없습니다.',
  /* MFA*/
  'app.error.003-055': '잘못된 MFA URL 값입니다. 다른 URL을 입력해주세요.',
  /* Custom email template */
  'app.error.003-070': '사용자 정의 이메일 템플릿에 대한 사용자 정의 변수가 이메일의 기본 엑솔라 변수와 동일합니다.',
  'app.error.003-071': '사용자 정의 이메일 템플릿을 찾을 수 없습니다.',
  'app.error.003-072': '잘못된 요청의 사용자 정의 이메일 템플릿입니다.',
  'app.error.003-073': '사용자 정의 이메일 템플릿에 알 수 없는 오류가 있습니다. 다시 시도하세요.',
  'app.error.003-074': '이 template_id을(를) 갖는 템플릿이 이 로그인 프로젝트에 이미 존재합니다.',
  'app.error.003-075': '먼저 영어 로케일용 이메일 템플릿을 생성해야 합니다.',
  'app.error.003-076': '다른 로케일용 템플릿이 있는 경우 영어 로케일용 사용자 정의 이메일 템플릿을 삭제할 수 없습니다.',
  'app.error.003-077': '이 로케일용 사용자 정의 템플릿이 이 로그인 프로젝트에 이미 있습니다.',
  'app.error.003-078': '이 로케일용 사용자 정의 템플릿이 이 로그인 프로젝트에 존재하지 않습니다.',
  'app.error.003-079': '이 유형은 SMS 템플릿에 금지되어 있습니다.',
  'app.error.003-080': '사용자 정의 템플릿을 찾을 수 없습니다.',
  'app.error.003-081': '템플릿에 코드용 태그가 포함되어 있지 않습니다.',
  'app.error.003-082': '템플릿 크기가 너무 큽니다. 더 짧은 텍스트를 사용하세요.',
  'app.error.003-083': '잘못된 로케일입니다.',
  /* Webhooks */
  'app.error.004-001': '이벤트 작업을 찾을 수 없습니다.',
  'app.error.004-002': '이벤트의 최대 웹훅 개수(3)를 이미 구성했습니다.',
  'app.error.004-003': '지정된 URL에 대한 웹훅이 지정된 이벤트 유형에 대해 이미 구성되어 있습니다.',
  'app.error.004-004': '지정된 URL은 금지되어 있습니다.',
  /* Project errors */
  'app.error.003-019': '프로젝트를 찾을 수 없습니다.',
  'app.error.003-024': '이 로그인 프로젝트의 암호 재설정이 비활성화되었습니다.',
  'app.error.003-022': '이 로그인 프로젝트가 잘못 구성되어있습니다.',
  'app.error.003-021': '이 로그인 프로젝트의 인증이 비활성화되었습니다.',
  'app.error.003-102': '패스키를 유일한 로그인 방식으로 사용할 수 없습니다. 다른 로그인 방식을 하나 이상 활성화해 두세요.',
  'app.error.003-023': '이 로그인 프로젝트의 등록이 비활성화되었습니다.',
  'app.error.003-064': "그림자 로그인 프로젝트는 1개를 초과해 보유할 수 없습니다.",
  'app.error.002-071': '로그인 프로젝트 수량 제한을 초과했습니다.',
  /* Server errors */
  'app.error.000-001': '내부 서버 오류입니다.',
  'app.error.003-061': '오브젝트를 찾을 수 없습니다.',
  'app.error.010-004': '서비스를 일시적으로 사용할 수 없습니다.',
  'app.error.010-050': '기한을 초과했습니다.',
  /* Social errors */
  'app.error.002-065': '이 작업은 기본 소셜 제공 업체 앱에 허용되지 않습니다.',
  'app.error.010-037': '소셜 제공 업체를 찾을 수 없습니다.',
  'app.error.010-043': '잘못된 소셜 네트워크 자격 증명입니다.',
  'app.error.010-044': '소셜 프로필을 찾을 수 없습니다.',
  'app.error.010-006': "연결을 해제할 수 없습니다. 사용자가 로그인할 수 있는 유일한 방법입니다.",
  /* User errors */
  'app.error.002-054': '허용된 검색 시도 횟수를 초과했습니다. 다음 요청 전에 1초 동안 기다리세요.',
  'app.error.002-056': '잘못된 전화 번호입니다.',
  'app.error.003-007': '사용자 계정이 확인되지 않았습니다.',
  'app.error.003-004': '지정된 이메일 주소를 갖는 사용자가 이미 존재합니다.',
  'app.error.003-012': '명시된 전화번호를 사용하는 사용자가 이미 존재합니다.',
  'app.error.003-008': '사용자 계정이 확인되지 않았습니다.',
  'app.error.003-009': '잘못된 사용자 검색 요청입니다.',
  'app.error.003-010': '사용자가 이 이메일 주소를 이미 확인했습니다.',
  'app.error.009-005': "사용자 내보내기 한도에 도달했습니다. 나중에 다시 시도하세요.",
  /* Validation errors */
  'app.error.002-038': '설정 상태는 유효한 JSON 문자열이어야 합니다.',
  'app.error.002-039': '유효성 검사 설정을 저장할 수 없습니다. 나중에 다시 시도하세요.',
  'app.error.002-041': '주어진 매개 변수로 필드를 생성하지 못했습니다.',
  'app.error.002-042': '이 API 메소드로 이름이 지정된 필드를 변경할 수 없습니다.',
  'app.error.002-047': '아래의 연결 해제 버튼을 클릭합니다. 그런 다음 Mailchimp ID를 사용하고 대상을 선택한 다음 다시 시도해 주세요.',
  'app.error.002-048': '아래의 연결 해제 버튼을 클릭합니다. 그런 다음 Mailchimp ID를 사용하고 대상을 선택한 다음 다시 시도해 주세요.',
  /* Attributes errors */
  'app.error.060-001': '사용자 특성이 현재 JSON 스키마와 일치하지 않습니다.',
  'app.error.060-002': '특성이 중복됩니다.',
  'app.error.060-003': '전달된 특성의 형식이 잘못되었습니다.',
  'app.error.060-004': 'JSON 스키마가 잘못되었거나 정의된 속성의 중첩 수준이 1보다 높습니다.',
  /* Role errors */
  'app.error.010-049': "이 페이지에 대한 액세스 권한이 없습니다. 프로젝트 관리자에게 문의하세요.",
  /* Token errors */
  'app.error.999-999': "다시 로그인해 보세요.",
  /* Custom OAuth 2.0 error */
  'app.error.013-003': "이 이름으로 된 사용자 정의 ID 공급자가 다른 프로젝트에 이미 존재합니다. 다른 이름을 사용해 주세요.",

  'app.error-title.mailchimp-not-found': 'Mailchimp 고객을 찾을 수 없음',

  'app.validation.required': '이 필드는 필수입니다.',
  'app.validation.characters': '최대 길이: {number}자',
  'app.validation.characters.min': '최소 길이: {minNumber}자',
  'app.validation.characters-only-hyphen-underscore': '문자와 숫자를 사용해 주세요. 하이픈과 밑줄도 사용할 수 있지만, 시작이나 끝 부분에 사용할 수 없으며, 서로 붙여서 사용할 수도 없습니다.',
  'app.validation.url-invalid': '잘못된 URL',
  'app.validation.url-duplicate': "중복된 URL을 추가할 수 없습니다",
  'app.validation.value-invalid': '잘못된 값',
  'app.validation.value-less': '{number}을(를) 초과하는 값',
  'app.validation.value-more': '{number} 미만의 값',
  'app.validation.phone-invalid': '잘못된 형식의 전화 번호',
  'app.validation.not-project-name': '유효하지 않은 프로젝트 이름',
  'app.validation.mailchimp-key-length': '36자 또는 37자로 된 API 키를 입력하세요.',
  'app.validation.old-widget-version-incorrect': 'CSS 버전({cssVersion})은 다음 위젯 버전({widgetVersion})과 일치해야 합니다. CSS 버전을 {widgetVersion}로 변경하십시오.',
  'app.validation.json-schema': '스키마가 유효한 JSON 개체가 아닙니다.',
  "app.validation.color.hex": "색상은 유효한 HEX 값이어야 합니다.",
  "app.validation.logo_url.required": "로고 이미지는 필수입니다.",
  "app.validation.logo_url.upload-error": "이미지를 업로드할 수 없습니다. 다시 시도해주세요.",
  "app.validation.logo_url.size-error": "300KB 미만 크기의 이미지 업로드",
  "app.validation.custom_style.upload-error": "CSS 파일을 업로드할 수 없습니다. 다시 시도해 주세요.",
  "app.validation.duplicate.valid-url": "URL이 이미 존재합니다. 동일한 URL을 두 번 추가하지 마세요.",
  "app.validation.cors-origin-only": "CORS 출처에는 URL 경로가 포함될 수 없습니다.",

  'form.select.country-name.AD': '안도라',
  'form.select.country-name.AE': '아랍에미리트',
  'form.select.country-name.AF': '아프가니스탄',
  'form.select.country-name.AG': '앤티가바부다',
  'form.select.country-name.AI': '앵귈라',
  'form.select.country-name.AL': '알바니아',
  'form.select.country-name.AM': '아르메니아',
  'form.select.country-name.AO': '앙골라',
  'form.select.country-name.AQ': '남극대륙',
  'form.select.country-name.AR': '아르헨티나',
  'form.select.country-name.AS': '미국령 사모아',
  'form.select.country-name.AT': '오스트리아',
  'form.select.country-name.AU': '호주',
  'form.select.country-name.AW': '아루바',
  'form.select.country-name.AX': '올란드 제도',
  'form.select.country-name.AZ': '아제르바이잔',
  'form.select.country-name.BA': '보스니아헤르체고비나',
  'form.select.country-name.BB': '바베이도스',
  'form.select.country-name.BD': '방글라데시',
  'form.select.country-name.BE': '벨기에',
  'form.select.country-name.BF': '부르키나파소',
  'form.select.country-name.BG': '불가리아',
  'form.select.country-name.BH': '바레인',
  'form.select.country-name.BI': '부룬디',
  'form.select.country-name.BJ': '베냉',
  'form.select.country-name.BL': '생바르텔레미',
  'form.select.country-name.BM': '버뮤다제도',
  'form.select.country-name.BN': '브루나이',
  'form.select.country-name.BO': '볼리비아',
  'form.select.country-name.BQ': '보네르, 신트외스타티위스',
  'form.select.country-name.BR': '브라질',
  'form.select.country-name.BS': '바하마',
  'form.select.country-name.BT': '부탄',
  'form.select.country-name.BV': '부베 섬',
  'form.select.country-name.BW': '보츠와나',
  'form.select.country-name.BY': '벨라루스',
  'form.select.country-name.BZ': '벨리즈',
  'form.select.country-name.CA': '캐나다',
  'form.select.country-name.CC': '코코스 제도',
  'form.select.country-name.CD': '콩고 민주 공화국',
  'form.select.country-name.CF': '중앙아프리카공화국',
  'form.select.country-name.CG': '콩고',
  'form.select.country-name.CH': '스위스',
  'form.select.country-name.CI': "코트디부아르",
  'form.select.country-name.CK': '쿡제도',
  'form.select.country-name.CL': '칠레',
  'form.select.country-name.CM': '카메룬',
  'form.select.country-name.CN': '중국',
  'form.select.country-name.CO': '콜롬비아',
  'form.select.country-name.CR': '코스타리카',
  'form.select.country-name.CU': '쿠바',
  'form.select.country-name.CV': '카보베르데',
  'form.select.country-name.CW': '퀴라소',
  'form.select.country-name.CX': '크리스마스 섬',
  'form.select.country-name.CY': '키프로스',
  'form.select.country-name.CZ': '체코 공화국',
  'form.select.country-name.DE': '독일',
  'form.select.country-name.DJ': '지부티',
  'form.select.country-name.DK': '덴마크',
  'form.select.country-name.DM': '도미니카',
  'form.select.country-name.DO': '도미니카공화국',
  'form.select.country-name.DZ': '알제리',
  'form.select.country-name.EC': '에콰도르',
  'form.select.country-name.EE': '에스토니아',
  'form.select.country-name.EG': '이집트',
  'form.select.country-name.EH': '서사하라',
  'form.select.country-name.ER': '에리트레아',
  'form.select.country-name.ES': '스페인',
  'form.select.country-name.ET': '에티오피아',
  'form.select.country-name.FI': '핀란드',
  'form.select.country-name.FJ': '피지',
  'form.select.country-name.FK': '포클랜드 제도',
  'form.select.country-name.FM': '미크로네시아 연방',
  'form.select.country-name.FO': '페로 제도',
  'form.select.country-name.FR': '프랑스',
  'form.select.country-name.GA': '가봉',
  'form.select.country-name.GB': '영국',
  'form.select.country-name.GD': '그레나다',
  'form.select.country-name.GE': '조지아',
  'form.select.country-name.GF': '프랑스령 기아나',
  'form.select.country-name.GG': '건지',
  'form.select.country-name.GH': '가나',
  'form.select.country-name.GI': '지브롤터',
  'form.select.country-name.GL': '그린란드',
  'form.select.country-name.GM': '감비아',
  'form.select.country-name.GN': '기니',
  'form.select.country-name.GP': '과들루프',
  'form.select.country-name.GQ': '적도기니',
  'form.select.country-name.GR': '그리스',
  'form.select.country-name.GS': '사우스조지아 사우스샌드위치 제도',
  'form.select.country-name.GT': '과테말라',
  'form.select.country-name.GU': '괌',
  'form.select.country-name.GW': '기니비사우',
  'form.select.country-name.GY': '가이아나',
  'form.select.country-name.HK': '홍콩',
  'form.select.country-name.HM': '허드 맥도널드 제도',
  'form.select.country-name.HN': '온두라스',
  'form.select.country-name.HR': '크로아티아',
  'form.select.country-name.HT': '아이티',
  'form.select.country-name.HU': '헝가리',
  'form.select.country-name.ID': '인도네시아',
  'form.select.country-name.IE': '아일랜드',
  'form.select.country-name.IL': '이스라엘',
  'form.select.country-name.IM': '맨 섬',
  'form.select.country-name.IN': '인도',
  'form.select.country-name.IO': '영국령인도양식민지',
  'form.select.country-name.IQ': '이라크',
  'form.select.country-name.IR': '이란',
  'form.select.country-name.IS': '아이슬란드',
  'form.select.country-name.IT': '이탈리아',
  'form.select.country-name.JE': '저지섬',
  'form.select.country-name.JM': '자메이카',
  'form.select.country-name.JO': '요르단',
  'form.select.country-name.JP': '일본',
  'form.select.country-name.KE': '케냐',
  'form.select.country-name.KG': '키르기스스탄',
  'form.select.country-name.KH': '캄보디아',
  'form.select.country-name.KI': '키리바시',
  'form.select.country-name.KM': '코모로',
  'form.select.country-name.KN': '세인트키츠네비스',
  'form.select.country-name.KP': '북한',
  'form.select.country-name.KR': '한국',
  'form.select.country-name.KW': '쿠웨이트',
  'form.select.country-name.KY': '케이맨 제',
  'form.select.country-name.KZ': '카자흐스탄',
  'form.select.country-name.LA': '라오스',
  'form.select.country-name.LB': '레바논',
  'form.select.country-name.LC': '세인트루시아',
  'form.select.country-name.LI': '리히텐슈타인',
  'form.select.country-name.LK': '스리랑카',
  'form.select.country-name.LR': '라이베리아',
  'form.select.country-name.LS': '레소토',
  'form.select.country-name.LT': '리투아니아',
  'form.select.country-name.LU': '룩셈부르크',
  'form.select.country-name.LV': '라트비아',
  'form.select.country-name.LY': '리비아',
  'form.select.country-name.MA': '모로코',
  'form.select.country-name.MC': '모나코',
  'form.select.country-name.MD': '몰도바',
  'form.select.country-name.ME': '몬테네그로',
  'form.select.country-name.MF': '세인트마틴 섬',
  'form.select.country-name.MG': '마다가스카르',
  'form.select.country-name.MH': '마셜 제도 공화국',
  'form.select.country-name.MK': '마케도니아',
  'form.select.country-name.ML': '말리',
  'form.select.country-name.MM': '미얀마',
  'form.select.country-name.MN': '몽골',
  'form.select.country-name.MO': '마카오',
  'form.select.country-name.MP': '북마리아나제도',
  'form.select.country-name.MQ': '마르티니크',
  'form.select.country-name.MR': '모리타니',
  'form.select.country-name.MS': '몬세라트',
  'form.select.country-name.MT': '몰타',
  'form.select.country-name.MU': '모리셔스',
  'form.select.country-name.MV': '몰디브',
  'form.select.country-name.MW': '말라위',
  'form.select.country-name.MX': '멕시코',
  'form.select.country-name.MY': '말레이시아',
  'form.select.country-name.MZ': '모잠비크',
  'form.select.country-name.NA': '나미비아',
  'form.select.country-name.NC': '뉴칼레도니아',
  'form.select.country-name.NE': '니제르',
  'form.select.country-name.NF': '노퍽 섬',
  'form.select.country-name.NG': '나이지리아',
  'form.select.country-name.NI': '니카라과',
  'form.select.country-name.NL': '네덜란드',
  'form.select.country-name.NO': '노르웨이',
  'form.select.country-name.NP': '네팔',
  'form.select.country-name.NR': '나우루',
  'form.select.country-name.NU': '니우에',
  'form.select.country-name.NZ': '뉴질랜드',
  'form.select.country-name.OM': '오만',
  'form.select.country-name.PA': '파나마',
  'form.select.country-name.PE': '페루',
  'form.select.country-name.PF': '프랑스령 폴리네시아',
  'form.select.country-name.PG': '파푸아뉴기니',
  'form.select.country-name.PH': '필리핀',
  'form.select.country-name.PK': '파키스탄',
  'form.select.country-name.PL': '폴란드',
  'form.select.country-name.PM': '생피에르 미클롱',
  'form.select.country-name.PN': '핏케언 제도',
  'form.select.country-name.PR': '푸에르토리코',
  'form.select.country-name.PS': '파레스타인',
  'form.select.country-name.PT': '포르투갈',
  'form.select.country-name.PW': '팔라우',
  'form.select.country-name.PY': '파라과이',
  'form.select.country-name.QA': '카타르',
  'form.select.country-name.RE': '레위니옹 섬',
  'form.select.country-name.RO': '루마니아',
  'form.select.country-name.RS': '세르비아',
  'form.select.country-name.RU': '러시아',
  'form.select.country-name.RW': '르완다',
  'form.select.country-name.SA': '사우디 아라비아',
  'form.select.country-name.SB': '솔로몬 제도',
  'form.select.country-name.SC': '세이셀',
  'form.select.country-name.SD': '수단',
  'form.select.country-name.SE': '스웨덴',
  'form.select.country-name.SG': '싱가포르',
  'form.select.country-name.SH': '세인트 헬레나, 어센션 및 트리스탄 다 쿠나 제도',
  'form.select.country-name.SI': '슬로베니아',
  'form.select.country-name.SJ': '스발바르 얀마옌 제도',
  'form.select.country-name.SK': '슬로바키아',
  'form.select.country-name.SL': '시에라리온',
  'form.select.country-name.SM': '산마리노',
  'form.select.country-name.SN': '세네갈',
  'form.select.country-name.SO': '소말리아',
  'form.select.country-name.SR': '수리남',
  'form.select.country-name.SS': '남수단',
  'form.select.country-name.ST': '상투메프린시페',
  'form.select.country-name.SV': '엘살바도르',
  'form.select.country-name.SX': '신트마르턴',
  'form.select.country-name.SY': '시리아',
  'form.select.country-name.SZ': '에스와티니',
  'form.select.country-name.TC': '터크스 케이커스 제도',
  'form.select.country-name.TD': '차드',
  'form.select.country-name.TF': '프랑스령 남부와 남극지역',
  'form.select.country-name.TG': '토고',
  'form.select.country-name.TH': '태국',
  'form.select.country-name.TJ': '타지키스탄',
  'form.select.country-name.TK': '토켈라우 제도',
  'form.select.country-name.TL': '동티모르',
  'form.select.country-name.TM': '투르크메니스탄',
  'form.select.country-name.TN': '튀니지 공화국',
  'form.select.country-name.TO': '통가',
  'form.select.country-name.TR': '터기',
  'form.select.country-name.TT': '트리니다드토바고',
  'form.select.country-name.TV': '투발루',
  'form.select.country-name.TW': '대만',
  'form.select.country-name.TZ': '탄자니아',
  'form.select.country-name.UA': '우크라이나',
  'form.select.country-name.UG': '우간다',
  'form.select.country-name.UM': '미국령 군소 제도',
  'form.select.country-name.US': '미국',
  'form.select.country-name.UY': '우루과이',
  'form.select.country-name.UZ': '우즈베키스탄',
  'form.select.country-name.VA': '바티칸 시국',
  'form.select.country-name.VC': '세인트빈센트 그레나딘',
  'form.select.country-name.VE': '베네수엘라',
  'form.select.country-name.VG': '영국령 버진 아일랜드',
  'form.select.country-name.VI': '미국령 버진아일랜드',
  'form.select.country-name.VN': '베트남',
  'form.select.country-name.VU': '바누아투',
  'form.select.country-name.WF': '윌리스푸티나제도',
  'form.select.country-name.WS': '사모아',
  'form.select.country-name.YE': '예멘',
  'form.select.country-name.YT': '마요트 섬',
  'form.select.country-name.ZA': '남아프리카공화국',
  'form.select.country-name.ZM': '잠비아',
  'form.select.country-name.ZW': '짐바브웨',
  'form.select.country-name.AN': '앤틸리스 제도',
  'form.select.country-name.XK': '코소보',
  'form.select.country-name.XX': '자동 감지됨',

  'form.language.ar': '아랍어',
  'form.language.bg': '불가리아어',
  'form.language.cn': '중국어(간체)',
  'form.language.cs': '체코어',
  'form.language.de': '독일어',
  'form.language.en': '영어',
  'form.language.es': '스페인어',
  'form.language.fr': '프랑스어',
  'form.language.he': '히브리어',
  'form.language.hu': '헝가리어',
  'form.language.it': '이탈리아어',
  'form.language.ja': '일본어',
  'form.language.ko': '한국어',
  'form.language.pl': '폴란드어',
  'form.language.pt': '포르투칼어',
  'form.language.ro': '로마니아어',
  'form.language.ru': '러시아어',
  'form.language.th': '태국어',
  'form.language.tr': '터키어',
  'form.language.zh_TW': '중국어(번체)',
  'form.language.vi': '베트남어',
  'form.language.zh_CN': '중국어(간체)',

  'agreement.not-signed.notification': '사용자 정의 설정은 제품 라이선스 계약에 서명한 후에 사용할 수 있습니다. 서명하려면 <a>계약서</a>로 이동합니다.',

  'statistics.label': '통계',

  'analytics.selectors.date.placeholder': '날짜 선택',
  'analytics.selectors.all-logins.title': '로그인 이름',
  'analytics.selectors.all-logins.placeholder': '모든 로그인 프로젝트',
  'analytics.selectors.all-countries.title': '국가',
  'analytics.selectors.all-countries.placeholder': '모든 국가',
  'analytics.charts.empty.title': '사용 가능한 데이터가 충분하지 않습니다',
  'analytics.charts.empty.description': '이 그래프를 생성하려면 더 많은 데이터가 필요합니다.',
  'analytics.charts.loading': '로딩하는 중...',
  'analytics.charts.failed.title': '로딩 실패',
  'analytics.charts.failed.description': '연결을 확인하고 다시 시도하십시오.',
  'analytics.charts.failed.refresh': '그래프 새로 고침',
  'analytics.charts.active-users': '현재 사용자',
  'analytics.charts.active-users.legend': '일간 활성 사용자',
  'analytics.charts.active-users.plot': '일간 활성 사용자',
  'analytics.charts.active-users.total': '총 합계',
  'analytics.charts.active-users.label': '선택한 기간 전 {days, number}{days, plural, one {일} other {일}}과 비교 시',
  'analytics.charts.auth-methods': '인증 방식',
  'analytics.charts.auth-methods.legend': '인증 수',
  'analytics.charts.countries': '국가별 인증',
  'analytics.charts.countries.title': '현재 사용자',

  'welcome-modal.title': '새로워진 로그인 경험에 오신 것을 환영합니다',
  'welcome-modal.subtitle': '새롭게 단장한 인터페이스를 갖춘 최고의 로그인을 사용해보세요.',
  'welcome-modal.update-list.login-method': '로그인 방법을 선택하고 해당 설정을 지정합니다',
  'welcome-modal.update-list.checklist': '지침이 포함된 체크리스트 및 콘텐츠 종속 블록으로 로그인 구성 속도 향상',
  'welcome-modal.update-list.try-login': '시작하기 전에 자신의 로그인 프로젝트 및 모든 연결을 테스트',
  'welcome-modal.footer.try-new': '새로워진 로그인으로 이동하기',
  'welcome-modal.help-research.title': '로그인을 개선할 수 있도록 도와주세요',
  'welcome-modal.help-research.description': '사용성 테스트에 참여하거나 새로워진 로그인에 대한 피드백을 제공하려면 <a>login@xsolla.com</a>으로 연락주세요.',

  'change-version.notification.back-old': '이전 버전의 로그인은 2022년 3월에 새 버전으로 업데이트됩니다. 새 버전이나 {link}을(를) 확인해 보세요.',
  'change-version.notification.back-old.link': '필요한 경우 기존 버전으로 돌아가세요',
  'change-version.notification.check-new': '이전 버전의 로그인은 2022년 3월에 새 버전으로 업데이트됩니다. {link}',
  'change-version.notification.check-new.link': '새로운 버전을 확인해 보세요.',

  'dashboard.label': '대시보드',
  'dashboard.new-login': '새 로그인 프로젝트',
  'dashboard.new-login.master': '표준 로그인 프로젝트 생성',
  'dashboard.new-login.shadow': '그림자 로그인 프로젝트 생성',
  'dashboard.new-login.shadow.description': '플랫폼 계정 저장에 사용할 로그인 프로젝트',
  'dashboard.new-login.babka-login': '새로운 OAuth 2.0 클라이언트',
  'dashboard.login-card.loginId': '로그인 ID',
  'dashboard.login-card.publishertId': '프로젝트 ID',
  'dashboard.login-card.date': '변경된 {date}',
  'dashboard.login-card.copy': '복사 ID',
  'dashboard.login-card.copied': '복사됨',
  'dashboard.login-card.statistics.users': '총 사용자',
  'dashboard.login-card.statistics.mau': 'MAU',
  'dashboard.login-card.statistics.mau.help': '지난 30일 동안의 이 로그인 프로젝트의 고유한 활성 사용자 수.',
  'dashboard.login-card.statistics.new-users': '신규 사용자',
  'dashboard.login-card.statistics.new-users.help': '지난 30일 동안의 이 로그인 프로젝트의 새 사용자 수.',
  'dashboard.login-card.button': '구성',
  'dashboard.login-card.steps.button': '다음 단계',
  'dashboard.login-card.steps.label': '다음 로그인 통합 단계',
  'dashboard.login-card.steps.completed': '완료한 단계',
  'dashboard.help.label': '모든 단계 도움 받기',
  'dashboard.help.faq.label': 'FAQ',
  'dashboard.help.faq.text': '일반적인 엑솔라 로그인 질문에 대한 답변을 확인해보세요.',
  'dashboard.help.documentation.label': '개발 설명서',
  'dashboard.help.documentation.text': '로그인 통합 가이드 및 예시를 살펴보세요.',
  'dashboard.help.ask.label': '연락처',
  'dashboard.help.ask.text-contact': '도움이 필요하세요? <a>통합팀에 문의해 주세요.</a>',
  'dashboard.help.ask.text-feedback': '남기실 의견이 있으세요? <a>피드백을 남겨 주세요</a>',
  'dashboard.connections.label': '연결',
  'dashboard.connections.website': '웹 사이트',
  'dashboard.connections.launcher': '런처',
  'dashboard.connections.show-all': '모두 표시',
  'dashboard.connections.hide-all': '모두 숨기기 ',
  'dashboard.connections.add': '웹 사이트 추가',
  'dashboard.connections.save': '저장',
  'dashboard.connections.info': '이 로그인 프로젝트에 런처를 연결하려면 <a>계정의 런처 섹션으로 이동하세요</a>.',

  // https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=9121%3A38854
  'try-login.modal.title': '위젯을 확인하시겠습니까?',
  'try-login.modal.text': '위젯이 올바르게 작동하는지 확인하려면 이 로그인 프로젝트의 첫 번째 사용자로 로그인하여 테스트를 진행해야 합니다. 기본 계정을 사용하거나 테스트 사용자 계정을 생성할 수 있습니다.',
  'try-login.modal.button.later': '나중에 확인',
  'try-login.modal.button.now': '예, 확인하겠습니다',
  'try-login.checklist.title': '위젯을 확인하세요',
  'try-login.checklist.text': '기본 또는 테스트 계정으로 로그인하여 위젯이 올바르게 작동하는지 확인할 수 있습니다.',
  'try-login.checklist.button': '지금 확인하기',
  'try-login.success.title': '이 로그인 프로젝트는 올바르게 작동합니다.',
  'try-login.success.features.label': '다음 기능 확인하기:',
  'try-login.success.support.label': '지원 받기',
  'try-login.success.support.integration': '간단 통합 알아보기',
  'try-login.success.support.help': '도움말 센터 살펴보기',
  'try-login.error.title': '문제가 발생했습니다',
  'try-login.error.text': '오류 코드: {code}',
  'try-login.error.social': '현재 로그인 위젯은 테스트 모드에서 소셜 로그인을 지원하지 않습니다. <a>프로덕션 모드에서 소셜 로그인을 시도해 보세요</a>.',

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=2224%3A58397 */
  'users.settings.all-users': '모든 사용자', // TODO для задаче по добавлению выборки забаниных/активных пользователей
  'users.settings.back': '<b>사용자 데이터베이스</b>로 돌아가기',
  'users.settings.general-info.label': '일반 정보',
  'users.settings.general-info.external': 'External ID',
  'users.settings.general-info.server-customer': 'Server Customer ID',
  'users.settings.general-info.nickname': '별칭 {nickname}',
  'users.settings.general-info.reset-pass': '암호 재설정',
  'users.settings.general-info.ban-user': '사용자 차단',
  'users.settings.general-info.unban-user': '사용자 차단 해제',
  'users.settings.general-info.registred': '등록 날짜',
  'users.settings.general-info.show-login-history': '로그인 기록 표시',
  'users.settings.general-info.hide-login-history': '로그인 기록 숨기기',
  'users.settings.general-info.data-fetching-error': '로그인 기록 데이터를 가져오는 중 오류가 발생했습니다.',
  'users.settings.general-info.no-login-history': '로그인 기록이 없음',
  'users.settings.general-info.table.date': '날짜',
  'users.settings.general-info.table.country': '국가',
  'users.settings.general-info.table.city': '도시',
  'users.settings.general-info.table.ip-address': 'IP 주소',
  'users.settings.group.label': '그룹',
  'users.settings.group.input-label': '그룹',
  'users.settings.group.select.add': '그룹 추가',
  'users.settings.contact-info.label': '연락처 정보',
  'users.settings.contact-info.primary-email.label': '기본 이메일',
  'users.settings.contact-info.primary-email.resend': '확인 이메일 재전송',
  'users.settings.contact-info.primary-email.resend.sucesss': '확인 이메일이 전송되었습니다.',
  'users.settings.contact-info.primary-phone.label': '전화 번호',
  'users.settings.contact-info.primary-email.checkbox': '새 기본 이메일 주소에 대한 확인 이메일 건너뛰기',
  'users.settings.additional-info.label': '추가 정보',
  'users.settings.additional-info.country': '국가',
  'users.settings.additional-info.age': '나이',
  'users.settings.email.validation.invalid': '유효하지 않은 이메일 주소 형식입니다.',
  'users.settings.phone.validation.min': '최소 길이: 8자.',
  'users.settings.phone.validation.max': '최대 길이: 14자.',
  'users.settings.delete-user.button': '사용자 계정 삭제',
  'users.settings.delete-user.subtitle': '삭제된 사용자 계정은 복원할 수 없습니다.',
  'users.settings.delete-user.alert.title': '사용자 계정을 삭제하시겠습니까?',
  'users.settings.delete-user.alert.subtitle': '삭제된 사용자 계정은 복원할 수 없습니다.',
  'users.settings.delete-user.alert.checked-understand': '예, 알고 있습니다',
  'users.settings.update-email.modal.title': '이 이메일 주소 사용자를 변경하시겠습니까?',
  'users.settings.update-email.modal.subtitle': 'ID {id}의 사용자가 이 이메일 주소를 사용하고 있습니다. 사용자를 변경하면 이전 사용자의 계정이 더 이상 이 이메일 주소에 연결되지 않습니다.',
  'users.settings.update-email.modal.checkbox': '이해합니다',
  'users.settings.update-email.modal.submit': '예, 변경합니다.',
  'users.settings.general-info.login-type.device': '장치',
  'users.settings.general-info.login-type.email': '비밀번호 없는 이메일',
  'users.settings.general-info.login-type.firebase': 'Firebase',
  'users.settings.general-info.login-type.import': '수입',
  'users.settings.general-info.login-type.phone': '비밀번호 없는 전화',
  'users.settings.general-info.login-type.playfab': 'Playfab',
  'users.settings.general-info.login-type.proxy': '프록시',
  'users.settings.general-info.login-type.server_custom_id': '서버 사용자 정의 ID',
  'users.settings.general-info.login-type.social': '사회적인',
  'users.settings.general-info.login-type.xsolla_login': '이메일 / 비밀번호',
  'users.settings.general-info.login-type': '인증 유형',
  'users.settings.general-info.social-profile.provider_name': '소셜 네트워크',
  'users.settings.general-info.social-profile.social_id': '사회적 ID',
  'users.settings.general-info.social-profile.created_at': '생성된 날짜',
  'users.settings.general-info.social-profile.remove': '제거',
  'users.settings.general-info.social-profile.remove.modal.title': '소셜 제공업체 연결을 해제하시겠습니까?',
  'users.settings.general-info.social-profile.remove.modal.subtitle': '사용자 {userId}에서 {provider} 연결을 해제하시겠습니까? 사용자가 이 제공업체를 다시 연결하기 전까지 이 제공업체로 로그인할 수 없습니다.',
  'users.settings.general-info.social-profile.remove.modal.submit': '예, 연결 해제',

  'users.header-block.mailchimp.pill.title': 'Mailchimp',
  'users.header-block.mailchimp.pill.dropdown.title': 'Mailchimp 통합',
  'users.header-block.mailchimp.pill.dropdown.subtitle': '자동으로 Mailchimp Audience에게 로그인 사용자를 내보내도록 설정합니다.',
  'users.header-block.mailchimp.pill.dropdown.connect': '연결',

  'users.list-block.table.no-data.title': '사용자 없음',
  'users.list-block.table.no-data.subtitle': '모든 등록된 사용자가 여기에 표시됩니다.',
  'users.list-block.table.error.title': '검색 매개변수 변경',
  'users.list-block.table.error.subtitle': "이 검색 매개변수로는 검색 결과를 표시할 수 없습니다. 사용자 목록을 보려면 해당 매개변수를 변경해 주세요.",
  'users.list-block.table.id-username': 'ID/사용자 이름',
  'users.list-block.table.contacts': '연락처 정보',
  'users.list-block.table.contacts.help': '확인 대기 중',
  'users.list-block.table.group': '그룹',
  'users.list-block.table.activity': '활동',
  'users.list-block.table.attributes': '특성',
  'users.list-block.navigation.manage-groups': '사용자 그룹 관리',
  'users.list-block.navigation.export-users': '사용자 내보내기',
  'users.list-block.search-user.button': '검색',
  'users.list-block.search-user.input-placeholder': '사용자 검색',
  'users.list-block.select-group.select.placeholder': '그룹 선택',
  'users.list-block.number-user': '{number, plural, one {#명의 사용자가 검색됨} other {#명의 사용자가 검색됨}}',
  'users.list-block.table.settings.ban': '사용 금지',
  'users.list-block.table.settings.view': '프로필 보기',
  'users.list-block.table.last-activity': '마지막 로그인: <br></br> {date}',
  'users.list-block.select-mode.all': '모든 사용자',
  'users.list-block.select-mode.ban': '금지된 사용자',
  'users.list-block.select-mode.active': '현재 사용자',
  'users.list-block.table.settings.unban': '차단 목록에서 삭제',
  'users.list-block.table.settings.delete': '삭제',
  'users.list-block.table.ban-date': '차단됨: <br></br> {date}',
  'users.list-block.table.ban-info-row.title': '세부 정보',
  'users.list-block.table.ban-info-row.date': '차단 기간:',
  'users.list-block.table.ban-info-row.date.permanent': '영구 차단',
  'users.list-block.table.ban-info-row.reason': '사용 금지 이유',
  'users.list-block.table.ban-modal.title': '이 사용자를 차단하시겠습니까?',
  'users.list-block.table.ban-modal.subtitle': '차단된 사용자는 지정된 날짜 또는 차단을 해제할 때까지 로그인할 수 없습니다.',
  'users.list-block.table.ban-modal.profile.title': '사용자 프로필',
  'users.list-block.table.ban-modal.profile.external-id': 'External ID {id}',
  'users.list-block.table.ban-modal.profile.register-date': '{date}에 등록함',
  'users.list-block.table.ban-modal.period.label': '차단 기간',
  'users.list-block.table.ban-modal.period.separator': '시간:',
  'users.list-block.table.ban-modal.permanent': '영구 차단',
  'users.list-block.table.ban-modal.reason.label': '사용 금지 이유',
  'users.list-block.table.ban-modal.reason.description': '예시: 귀하의 계정은 {{ban reason}}의 사유로 {{unban date}}까지 차단됩니다. 차단 해제를 요청하려면 {{ban reason}}에 문의해 주세요.',
  'users.list-block.table.ban-modal.reason.submit.ban': '예, 사용자를 차단합니다.',
  'users.list-block.table.ban-modal.reason.submit.unban': '사용자 차단 해제',
  'users.list-block.select-search-by': '다음으로 검색',
  'users.list-block.select-search-by.email': '이메일 주소',
  'users.list-block.select-search-by.phone': '전화 번호',
  'users.list-block.select-search-by.id': 'ID',
  'users.list-block.select-search-by.socialId': '소셜 네트워크 ID',
  'users.list-block.select-search-by.username': '사용자 이름',
  'users.list-block.select-search-by.nickname': '별명',
  'users.list-block.select-search-by.customId': '서버 사용자 정의 ID',

  'users.export.title': '사용자 내보내기',
  'users.export.subtitle': '로그인 사용자 내보내기에 사용할 이메일 주소를 지정하세요.',
  'users.export.subtitle-archive': 'Windows에서 7-Zip으로 압축을 해제하는 것이 좋습니다.',
  'users.export.notification': '비밀 키인 아카이브 암호를 찾으려면 <a>JWT 서명 페이지</a>를 확인하세요.',
  'users.export.email': '이메일 주소',
  'users.export.button': '내보내기',
  'users.export.success.label': '내보내기 요청을 전송함',
  'users.export.success.sublabel': '몇 분 안에 지정된 이메일 주소로 사용자와 아카이브 항목을 보내 드리겠습니다.',

  'users.attributes.table.description.title': '특성 이름',
  'users.attributes.table.description.tooltip': 'JSON 스키마 파일의 <b>description</b> 필드입니다.',
  'users.attributes.table.key.title': '키 이름',
  'users.attributes.table.key.tooltip': 'JSON 스키마 파일의 <b>properties</b> 개체 키 필드입니다.',
  'users.attributes.table.type.title': '유형',
  'users.attributes.table.type.tooltip': 'JSON 스키마 파일의 <b>type</b> 필드입니다.',
  'users.attributes.table.access.title': '액세스',
  'users.attributes.table.access.tooltip': '특성에 해당하는 <b>액세스 유형</b>을 표시합니다.',
  'users.attributes.table.readonly.title': '읽기 전용',
  'users.attributes.table.readonly.tooltip': '사용자는 <b>읽기 전용</b> 속성을 업데이트할 수 없습니다.',
  'users.attributes.table.value.title': '값',
  'users.attributes.table.value.tooltip': '특성 값입니다.',
  'users.attributes.table.permission.title': '허가',
  'users.attributes.table.permission.tooltip': '특성에 대한 <b>타사</b> 액세스 상태입니다.',
  'users.attributes.table.access.private': '비공개',
  'users.attributes.table.access.public': '공개',
  'users.attributes.table.schema-link': '<a>사용자 특성 설정</a>에서 특성 스키마를 변경할 수 있습니다.',
  'users.attributes.table.empty.title': '특성을 찾을 수 없음',
  'users.attributes.table.empty.subtitle': '이 사용자에 해당하는 JSON 스키마를 업로드하지 않았거나 특성을 추가하지 않았습니다.',
  'users.attributes.table.search.placeholder': '특성 검색',
  'users.attributes.table.search.empty.title': '특성을 찾을 수 없음',
  'users.attributes.table.search.empty.subtitle': '검색 필드 내용을 삭제하여 사용 가능한 특성을 모두 표시',
  'users.attributes.table.save-value': '저장',
  'users.attributes.table.type-error': '{type} 유형 값 입력.',
  'users.attributes.table.publisher-project-id.title': '퍼블리셔 프로젝트 ID',
  'users.attributes.table.publisher-project-id.description': '퍼블리셔 프로젝트 ID는 선택한 퍼블리셔 프로젝트의 ID입니다.',

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=6203%3A100097 */
  'check-list.main-links.title': '로그인 가이드 살펴보기',
  'check-list.main-links.subtitle': '기본 로그인 설정 구성',
  'check-list.main-links.documentation': '문서화',
  'check-list.main-links.faq': 'FAQ',

  'check-list.head-element.title': '로그인 설정 체크리스트',
  'check-list.login-method.title': '로그인 방법',
  'check-list.login-method.subtitle': '기본 로그인 방법 설정',
  'check-list.selected_login_method.title': '로그인 방법 선택',
  'check-list.selected_login_method.tooltip': '인증 방법을 선택하여 필요한 로그인 및 가입 기능을 제공합니다.',
  'check-list.set_callback_url.title': '콜백 URL 설정',
  'check-list.set_callback_url.tooltip': '사용자를 필요한 페이지로 리디렉션하는 URL를 설정합니다.',
  'check-list.rest-steps.not-required': '아래 단계는 필수는 아니지만 성공적으로 로그인을 설정하려면 설정하는 것이 좋습니다.',
  'check-list.secure.title': '보안',
  'check-list.secure.subtitle': '기본 보안 설정',
  'check-list.set_up_oauth.title': 'OAuth 2.0 설정',
  'check-list.set_up_oauth.tooltip': '보호된 데이터에 대한 액세스 권한을 사용자가 타사 웹 사이트 또는 애플리케이션에 부여하도록 허용합니다.',
  'check-list.copy_secret_key.title': '비밀 키 저장 및 보호',
  'check-list.copy_secret_key.tooltip': '비밀 키를 복사하여 코드에 구현합니다.',
  'check-list.authentication.title': '인증',
  'check-list.authentication.subtitle': '기본 인증 설정',
  'check-list.connected_social.title': '소셜 네트워크 추가',
  'check-list.connected_social.tooltip': '사용자가 로그인할 수 있도록 소셜 네트워크를 구성합니다.',
  'check-list.miscellaneous_data.title': '다양한 데이터 양식 설정',
  'check-list.miscellaneous_data.tooltip': '추가 양식으로 사용자 데이터를 수집합니다.',
  'check-list.user-data-base.title': '사용자 데이터베이스',
  'check-list.user-data-base.subtitle': '기본 사용자 데이터베이스 설정',
  'check-list.set_up_storage.title': '사용자 데이터 저장소 설정',
  'check-list.set_up_storage.tooltip': '사용자 데이터 저장소를 설정하고 사용자 자격 증명을 관리합니다.',
  'check-list.supplementary_info.title': '보조 사용자 정보 양식 설정',
  'check-list.supplementary_info.tooltip': '사용자에 대한 보조 정보를 얻기 위해 데이터 양식을 추가합니다.',
  'check-list.customization.title': '사용자 정의',
  'check-list.customization.subtitle': '기본 사용자 정의 설정',
  'check-list.widget_customization.title': '위젯 사용자 정의',
  'check-list.widget_customization.tooltip': '로그인 위젯을 인식할 수 있도록 위젯 UI를 사용자 정의합니다.',

  /* Navigation page */
  'navigation.main-alert': '편집 아이콘을 클릭하여 로그인 프로젝트의 이름을 변경합니다. 로그인 프로젝트 이름은 사용자에게 전송하는 이메일 및 메시지에서 사용됩니다.',
  'navigation.delete-project': '프로젝트를 삭제',
  'navigation.save.project-name': '저장',
  'navigation.authentication-method.label': '로그인 방법',
  'navigation.authentication-method.configure.button': '구성',
  'navigation.authentication-method.alert': '로그인 방법을 클릭하여 콜백 URL을 설정한 다음 로그인 방법 설정을 엽니다. 저장한 설정을 이용하여 로그인 방법을 변경할 수 있습니다.',
  'navigation.authentication-method.classic-widget.title': '클래식 로그인',
  'navigation.authentication-method.classic-widget.subtitle': '개선된 비주얼, 흐름, 기능으로 소셜 로그인을 포함하여 더 나은 최종 사용자 경험을 선사합니다. <a>더 자세한 내용은 로그인 설명서를 참조하세요.</a>',
  'navigation.authentication-method.passwordless-widget.title': '암호 없는 로그인',
  'navigation.authentication-method.passwordless-widget.subtitle': '암호를 사용하지 않고 사용자가 이메일 주소, 전화번호 또는 소셜 네트워크를 통해 로그인할 수 있습니다. <a>더 자세한 내용은 로그인 설명서를 참조하세요.</a>',
  'navigation.authentication-method.social-widget.title': '소셜 로그인',
  'navigation.authentication-method.social-widget.subtitle': '소셜 네트워크를 통해 사용자가 로그인할 수 있습니다. <a>더 자세한 내용은 로그인 설명서를 참조하세요.</a>',
  'navigation.authentication-method.example-project.modal': '지금 보시는 것은 미리 보기일 뿐입니다. 클릭하여 저장하세요!',
  'navigation.settings.secure.label': '보안',
  'navigation.settings.secure.oauth2.title': 'OAuth 2.0',
  'navigation.settings.secure.oauth2.subtitle': '사용자가 자신의 자격 증명을 공개하지 않고 웹사이트를 통해 데이터에 제한된 액세스를 부여할 수 있게 합니다.',
  'navigation.settings.secure.signature.title': 'JWT 서명',
  'navigation.settings.secure.signature.subtitle': 'JSON 웹 토큰(JWT) 서명 확인에 사용될 키를 선택합니다.',
  'navigation.settings.secure.multi-factor.title': '다단계 인증 정책',
  'navigation.settings.secure.multi-factor.subtitle': '권한이 없는 액세스를 방지하려면 사용자가 로그인 동안에 추가 단계를 완료해야 합니다.',
  'navigation.settings.user-db.label': '사용자 데이터베이스',
  'navigation.settings.user-db.storage.title': '저장소',
  'navigation.settings.user-db.storage.subtitle': '데이터베이스 연결이 이메일 주소 또는 사용자 이름 및 암호를 이용하여 사용자 인증을 할 수 있게 합니다.',
  'navigation.settings.user-db.user-info.title': '추가 사용자 정보',
  'navigation.settings.user-db.user-info.subtitle': '사용자 데이터를 수집할 추가 양식을 제시합니다. 이를 사용하여 추가 사용자 데이터를 데이터베이스에 추가하세요.',
  'navigation.settings.user-db.user-attributes.title': '사용자 특성 스키마',
  'navigation.settings.user-db.user-attributes.subtitle': '사용자의 특성 스키마를 다운로드하고 검색합니다.',
  'navigation.settings.user-db.users.title': '사용자',
  'navigation.settings.user-db.users.subtitle': '사용자 이메일 주소 변경, 암호 재설정, 차단 목록 관리, 사용자 특성 관리, 전체 사용자 데이터베이스 사본 다운로드.',
  'navigation.settings.authentication.label': '인증',
  'navigation.settings.classic-login.label': '클래식 로그인',
  'navigation.settings.classic-login.alert': '저장한 설정을 유지한 채로 클래식 로그인, 암호 없는 로그인, 소셜 로그인 간에 간단하게 전환할 수 있습니다. <a>로그인 방법을 변경합니다.</a>',
  'navigation.settings.settings.title': '설정',
  'navigation.settings.settings.subtitle': '암호를 사용하지 않는 방법을 구성하여 사용자가 암호 없이 로그인할 수 있게 하세요.',
  'navigation.settings.sign-up.title': '등록 설정',
  'navigation.settings.sign-up.subtitle': '메인 등록 설정을 설정합니다.',
  'navigation.settings.username.title': '사용자 이름 설정',
  'navigation.settings.username.subtitle': '사용자는 이메일 주소 외에 사용자 이름을 추가로 제공해야 합니다.',
  'navigation.settings.email-validation.title': '이메일 유효성 검사',
  'navigation.settings.email-validation.subtitle': '이메일 유효성 검사에 사용할 유효성 검사 방법을 선택합니다.',
  'navigation.settings.callback.title': '콜백 URL',
  'navigation.settings.callback.subtitle': '인증이 성공한 후 사용자가 리디렉션될 유효한 URL을 여러 개 지정합니다.',
  'navigation.settings.email.title': '이메일 설정',
  'navigation.settings.email.subtitle': '사용자 이메일 주소 유효성 검사에 사용할 유효성 검사 방법 및 링크를 설정합니다.',
  'navigation.settings.classic-login.password.title': '암호 설정',
  'navigation.settings.classic-login.password.subtitle': '수동으로 안전한 암호를 만들거나 자동으로 생성하세요.',
  'navigation.settings.passwordless.label': '암호 없는 로그인',
  'navigation.settings.social.label': '소셜 로그인',
  'navigation.settings.authentication.social-connections.title': '소셜 로그인',
  'navigation.settings.authentication.social-connections.subtitle': '선택한 소셜 네트워크를 통해 사용자가 로그인할 수 있게 합니다.',
  'navigation.settings.authentication.enterprise-connections.title': 'OAuth 2.0 로그인 연결',
  'navigation.settings.authentication.enterprise-connections.subtitle': '사용자가 OAuth 2.0을 통해 엑솔라에 연결된 인증 인터페이스로 로그인할 수 있습니다.',
  'navigation.settings.authentication.passkey.title': '패스키',
  'navigation.settings.authentication.passkey.subtitle': '사용자가 암호 대신 지문, 얼굴 또는 기기 PIN으로 로그인할 수 있도록 합니다.',
  'navigation.settings.authentication.miscellaneous-data.title': '다양한 데이터 양식',
  'navigation.settings.authentication.miscellaneous-data.subtitle': "사용자 데이터 수집을 위한 추가 양식을 표시합니다. 필수 데이터가 등록 중에 제공되지 않았을 때 용하세요.",
  'navigation.settings.authentication.publisher-platforms.title': '퍼블리싱 플랫폼',
  'navigation.settings.authentication.api-settings.title': '로그인 API 통합',
  'navigation.settings.authentication.api-settings.subtitle': '로그인 API와의 통합을 구성합니다.',
  'navigation.settings.custom-providers.label': '통신 서비스 제공업체',
  'navigation.settings.custom-providers.email.title': '이메일 서비스 제공업체',
  'navigation.settings.custom-providers.email.subtitle': '대용량 이메일 서비스를 통해 모든 이메일의 경로를 지정합니다.',
  'navigation.settings.custom-providers.sms.title': 'SMS 서비스 제공업체',
  'navigation.settings.custom-providers.sms.subtitle': '대용량 메시지 서비스를 통해 모든 SMS 메시지의 경로를 지정합니다.',
  'navigation.settings.customization.label': '사용자 정의',
  'navigation.settings.customization.widget-customization.title': '위젯 사용자 정의',
  'navigation.settings.customization.widget-customization.subtitle': '위젯 언어 및 비주얼을 설정합니다.',
  'navigation.settings.customization.email-customization.title': '이메일 사용자 정의',
  'navigation.settings.customization.email-customization.subtitle': '사용자에게 전송할 이메일의 비주얼을 사용자 지정합니다.',
  'navigation.settings.customization.sms-customization.title': 'SMS 사용자 지정',
  'navigation.settings.customization.sms-customization.subtitle': '사용자에게 전송할 SMS 메시지를 사용자 지정합니다.',
  'navigation.settings.legal.label': '법률 관련 설정',
  'navigation.settings.legal.terms-and-policies.title': '약관 및 정책',
  'navigation.settings.legal.terms-and-policies.subtitle': '규정을 준수하고 사용자와의 법적 관계를 정의하는 약관과 정책에 대한 링크를 제공합니다. 사용자는 로그인 위젯 화면에서 이러한 링크를 보게 됩니다.',
  'navigation.settings.legal.age-restrictions.title': '나이 제한',
  'navigation.settings.legal.age-restrictions.subtitle': '게임에 액세스할 수 있는 최소 나이를 지정합니다.',

  'change-method.main-title': '인증 방식',
  'change-method.main-subtitle': '사용자 자격 증명을 엑솔라 데이터베이스 또는 자체 저장소에 안전하게 저장하고 관리하세요.',
  'change-method.main-notification': '인증 방법을 변경해도 설정을 잃지 않습니다.',
  'change-method.button.cancel': '취소',
  'change-method.button.save': '저장 및 설정',
  'change-method.methods.classic.title': '클래식 로그인',
  'change-method.methods.classic.subtitle': '사용자 이름 및 암호로 사용자가 등록 및 로그인할 수 있게 합니다.',
  'change-method.methods.passwordless.title': '암호 없는 로그인',
  'change-method.methods.passwordless.subtitle': '암호를 사용하지 않고 사용자가 이메일 주소 또는 전화번호를 통해 로그인할 수 있게 합니다.',
  'change-method.methods.social.title': '소셜 로그인',
  'change-method.methods.social.subtitle': '소셜 네트워크를 이용해 사용자가 등록 및 로그인할 수 있게 합니다.',

  'delete-project-form.description': '삭제한 로그인 프로젝트는 삭제 날짜로부터 30일 동안만 복원할 수 있습니다.',
  'delete-project-form.title': '\'{projectName}\' 프로젝트를 삭제할까요?',
  'delete-project-form.input.title': '삭제하려는 로그인 프로젝트 이름을 입력하세요.',
  'delete-project-launchers.title': '\'{projectName}\' 프로젝트를 삭제할 수 없습니다.',
  'delete-project-launchers.description': '이 {projectName} 프로젝트는 기존 런처에 연결되어 있습니다. 먼저 연결을 해제하세요.',
  'delete-project-launchers.notification': '런처 설정에서 로그인을 연결 해제할 수 있습니다.',
  'delete-project-launchers.link': '\'{launcherName}\' 런처 설정으로 이동',
  'delete-project-success.title': '로그인 프로젝트가 삭제됨',
  'delete-project-success.description': '이 로그인 프로젝트를 복원하려면 <a>지원팀에 문의하세요</a>.',

  'welcome-page.header.title': '엑솔라 로그인에 오신 것을 환영합니다',
  'welcome-page.header.description': '귀하의 소유권 아래에서 사용자 데이터를 안전하게 보관하면서 현지화된 원활할 원클릭 인증을 활성화하세요.',
  'welcome-page.header.create-login-button': '로그인 프로젝트 만들기',
  'welcome-page.header.annotation-integration': '통합에 걸리는 시간은 <span>20분 미만입니다</span>',
  'welcome-page.header.guide-link': '로그인 통합 가이드',
  'welcome-page.features-list.title': '주요 기능',
  'welcome-page.features-list.make-game.title': '게임 인증을 간단하게 합니다',
  'welcome-page.features-list.make-game.description': '플레이어가 30개 이상의 신뢰할 수 있는 소셜 네트워크의 본인 프로필을 사용하여 게임에 로그인할 수 있게 합니다.',
  'welcome-page.features-list.data-laws.title': '글로벌 데이터 법률 준수',
  'welcome-page.features-list.data-laws.description': '게임 플레이 액세스 및 온라인 ID 시스템의 정보 보호법, 시간제한 사항을 준수하세요.',
  'welcome-page.features-list.brand-identity.title': '브랜드 ID 추가',
  'welcome-page.features-list.brand-identity.description': '로그인 위젯 디자인을 관리자 페이지에서 바로 맞춤 설정하고 CSS 및 HTML을 통해 이메일의 시각적 디자인을 귀하의 브랜드에 맞게 수정할 수도 있습니다.',
  'welcome-page.features-list.own-your-database.title': '데이터베이스 소유',
  'welcome-page.features-list.own-your-database.description': '사용자 데이터베이스의 액세스 권한을 관리하여 이메일 주소 업데이트, 확인 이메일 재전송, 사용자 규제 및 규제 해제, 사용자 삭제 또는 CSV 파일 내보내기를 할 수 있습니다.',
  'welcome-page.features-list.relevant-login-methods.title': '관련 로그인 방법 강조',
  'welcome-page.features-list.relevant-login-methods.description': "각 플레이어의 기록 및 위치를 기반으로 가장 관련 높은 로그인 방법을 상단으로 푸시하세요.",
  'welcome-page.features-list.earn-layout-security.title': '보안을 통한 로열티 받기',
  'welcome-page.features-list.earn-layout-security.description': '강력한 고객 인증(SCA)의 요구 사항을 만족하는 매개 변수를 사용하여 플레이어 ID를 확인하고 권한 없는 데이터 액세스 위험을 최소화하세요.',
  'welcome-page.features-list.dock-link': '더 많은 기능',

  'create-login-page.title': '로그인 프로젝트 만들기',
  'create-login-page.description': '이러한 단계를 따라 로그인 프로젝트를 만든 다음 설정 및 맞춤 설정하세요.',
  'create-login-page.notification': '생성하려는 로그인 프로젝트 유형을 선택합니다. 각 옵션의 설정 단계는 서로 다릅니다. 선택한 로그인 프로젝트 유형을 변경할 수 없습니다. 다른 유형의 새로운 로그인 프로젝트는 언제든지 생성할 수 있습니다.',
  'create-login-page.documentation': '문서화',
  'create-login-page.create': '생성 및 설정',
  'create-login-page.back': '<b>대시보드</b>로 돌아가기',
  'create-login-page.master.label': '표준 로그인 프로젝트',
  'create-login-page.master.description': '로그인을 사용하면 원활하고 현지화된 원클릭 인증을 사용할 수 있으며, 플레이어 데이터를 안전하게 지키면서도 소유권은 전적으로 본인에게 있게 됩니다.',
  'create-login-page.shadow.label': '그림자 로그인 프로젝트',
  'create-login-page.shadow.description': '그림자 프로젝트는 게시 플랫폼을 통해 사용자를 인증할 수 있게 합니다.',
  'create-login-page.settings.label': '추가 설정',
  'create-login-page.master.settings.text': '소셜 연결',
  'create-login-page.shadow.settings.text': '플랫폼 연결',
  'create-login-page.time.label': '생성할 시간',
  'create-login-page.master.time.text': '30분',
  'create-login-page.shadow.time.text': '15분',

  'settings.crumbs.login-type.classic-login': '클래식 로그인',
  'settings.tabs.try-login.button': '로그인 시도',

  "users.mailchimp": "Mailchimp",
  "users.mailchimp.head": "Mailchimp 연결",
  "users.mailchimp.notification.title": "지침 보기",
  "users.mailchimp.notification.description.mailchimp-api-key": '1. <b>Mailchimp API  .</b> API  <a1>Mailchimp </a1>   .<br></br> 2.     Mailchimp Audience <b></b>. <a2>Mailchimp </a2> Audience   .<br></br> 3. <b></b>       Mailchimp   . <br></br>4. <a3>   </a3>         .<br></br><br></br>      Mailchimp  .',
  "users.mailchimp.notification.description.mailchimp-merge-tags": "해당 태그가 Mailchimp 대시보드에 이미 존재하는지 확인해 주세요. 이미 설정된 경우, 인터페이스에서는 다시 추가할 수 없으며, 다시 추가하려 하면 예기치 않은 오류가 발생할 수 있습니다.",
  "users.mailchimp.key.label": "Mailchimp API 키",
  "users.mailchimp.key.placeholder": "36자 또는 37자로 된 API 키를 입력하세요",
  "users.mailchimp.audience.label": "Mailchimp Audience",
  "users.mailchimp.audience.empty.title": "Audience가 없습니다",
  "users.mailchimp.audience.empty.text": "<a>Mailchimp 계정</a>에서 첫 번째 Audience를 생성한 후 다시 시도하세요.",
  "users.mailchimp.confirm.label": "<a>허가의 중요성</a>에 따라 내 Audience의 사용자가 이메일 수신에 동의한다는 것을 확인했습니다.",
  "users.mailchimp.connect-form.button": "연결",
  "users.mailchimp.confirm-form.button": "확인",
  "users.mailchimp.export.alert.title": "Mailchimp로 내보내기 수행 중",
  "users.mailchimp.export.alert.message": "내보내기에 다소 시간이 걸릴 수 있습니다. 지금 창을 닫으셔도 됩니다.",
  "users.mailchimp.export.alert.button": "감사합니다. 무시",
  "users.mailchimp.disconnect.title": "Mailchimp 연결을 해제하시겠습니까?",
  "users.mailchimp.disconnect.description": "로그인 사용자를 더 이상 Mailchimp로 내보낼 수 없습니다. 다음 번에 연결하기로 결정할 경우, 필드를 다시 채워야 합니다.",
  "users.mailchimp.button-dropdown.integration.title": "Mailchimp 통합",
  "users.mailchimp.button-dropdown.integration.description": "자동으로 Mailchimp Audience에게 로그인 사용자를 내보내도록 설정합니다.",
  "users.mailchimp.button-dropdown.integration.button": "연결",
  "users.mailchimp.button-dropdown.fetching.title": "Mailchimp로 내보내기 수행 중",
  "users.mailchimp.button-dropdown.fetching.description": "내보내기 시간은 로그인 목록에 있는 사용자 수에 따라 달라질 수 있습니다.",
  "users.mailchimp.button-dropdown.export-completed.title": "내보내기 완료",
  "users.mailchimp.button-dropdown.export-completed.description": "로그인 사용자들이 Mailchimp Audience에게 내보내집니다.",
  "users.mailchimp.button-dropdown.export-completed.button": "연결 해제",
  "users.mailchimp.merge-tags-form.button.skip": "건너뛰기",
  "users.mailchimp.merge-tags-form.head": "Mailchimp 병합 태그 사용",
  "users.mailchimp.merge-tags-form.add-tag": "병합 태그 추가",
  "users.mailchimp.merge-tags-form.edit-tag": "병합 태그 편집",
  "users.mailchimp.merge-tags-form.field-label.placeholder": "필드 레이블",
  "users.mailchimp.merge-tags-form.merge-tag.placeholder": "병합 태그",
  "users.mailchimp.merge-tags-form.field-label.error": "필드 레이블은 1자에서 10자 사이여야 합니다",
  "users.mailchimp.merge-tags-form.merge-tag.error": "병합 태그는 1자에서 50자 사이여야 합니다",

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=3724%3A76750 */
  'configuration-page.menu.item.callback-url': '콜백 URL',
  'configuration-page.menu.item.signup-settings': '등록',
  'configuration-page.menu.item.username-settings': '사용자 이름',
  'configuration-page.menu.item.password-settings': '암호',
  'configuration-page.menu.item.email-validation': '이메일 유효성 검사',

  'configuration-page.callback-urls.page-title': 'URL',
  'configuration-page.callback-urls.page-description': '사용자가 애플리케이션에 성공적으로 로그인하면 인증 서버는 URL에 있는 인증 코드 또는 액세스 토큰을 사용하여 사용자를 애플리케이션으로 다시 리디렉션합니다.',

  'configuration-page.urls.callback-urls.title': '콜백 URL',
  'configuration-page.urls.callback-urls.description': '인증 성공, 이메일 확인 또는 암호 재설정 후 사용자가 리디렉션되는 콜백 URL입니다. 사용자가 인증한 후에는 이러한 URL에만 콜백합니다.',
  'configuration-page.urls.callback-urls.notification': '<u>https://</u> 또는 <u>http://</u>로 프로토콜을 지정해야 합니다.그렇지 않으면 경우에 따라 콜백이 실패할 수 있습니다.',
  'configuration-page.urls.callback-urls.input.title': '콜백 URL',
  'configuration-page.urls.callback-urls.input.placeholder': 'https://',
  'configuration-page.urls.callback-urls.input.add-button': '추가 URL',
  "configuration-page.urls.callback-urls.notification": "OAuth 인가 중에 리디렉션으로 사용될 수 있는 모든 URL을 반드시 나열하세요.<br></br><br></br> 1. 전체 형식(스킴 + 도메인 + 경로)을 사용하세요. 예: https://domain.com/auth<br></br> 2. 모든 서브도메인 변형을 포함하세요 — 예: https://domain.com/auth 및 https://www.domain.com/auth<br></br> 3. 앱이 https://와 http://를 모두 사용할 수 있다면, 두 버전을 모두 명시적으로 추가하세요.<br></br> 4. 경로 끝의 슬래시(/)를 주의하세요. 앱이 /auth와 /auth/를 모두 사용할 수 있다면 둘 다 포함하세요.<br></br> 5. 쿼리 매개변수와 프래그먼트는 제외하세요 — ?code=... 또는 #section 같은 항목은 추가하지 마세요.<br></br><br></br> 리디렉션 URL이 목록에 없으면 사용자는 로그인 절차를 완료할 수 없습니다.",

  'configuration-page.urls.allowed-origin.title': '허용된 출처(CORS)',
  'configuration-page.urls.allowed-origin.description': '엑솔라 API(일반적으로 CORS와 함께 사용)에 대해 교차 출처 HTTP 요청을 수행할 수 있는 URL 세트입니다. 이는 웹 브라우저에서 엑솔라 서비스 및 제품을 사용할 때 동일 출처 정책 오류를 방지합니다.',
  'configuration-page.urls.allowed-origin.notification': '필요한 경우 이 필드를 사용하여 출처를 지정할 수 있습니다. 유효한 URL을 여러 개 지정할 수 있습니다.',
  'configuration-page.urls.allowed-origin.input.title': '허용된 출처(CORS)',
  'configuration-page.urls.allowed-origin.input.placeholder': 'https://',
  'configuration-page.urls.allowed-origin.input.add-button': '추가 URL',

  'configuration-page.urls.error-callback.title': '오류 콜백 URL',
  'configuration-page.urls.error-callback.description': '로그인 오류가 발생한 경우 사용자가 리디렉션되는 오류 콜백 URL입니다.',
  'configuration-page.urls.error-callback.notification': '값을 지정하지 않으면 콜백 URL을 사용합니다.',
  'configuration-page.urls.error-callback.input.title': '오류 콜백 URL',
  'configuration-page.urls.error-callback.input.placeholder': 'https://',
  'configuration-page.urls.error-callback.input.add-button': '추가 URL',
  'configuration-page.urls.default-callback.title': '기본 콜백 URL',
  'configuration-page.urls.default-callback.description': '사용자가 리디렉션되는 기본 콜백 URL입니다.',
  'configuration-page.urls.default-callback.notification': '아래 목록에 있는 콜백 URL을 입력하세요.',

  'configuration-page.urls.allow-logout.title': '허용된 로그아웃 URL',
  'configuration-page.urls.allow-logout.description': '사용자가 로그인에서 로그아웃한 후의 리디렉션에 유효한 URL입니다. (returnTo) 쿼리 매개변수를 사용하여 리디렉션할 수 있습니다.',
  'configuration-page.urls.allow-logout.notification': '값을 지정하지 않으면 콜백 URL을 사용합니다.',
  'configuration-page.urls.allow-logout.input.title': '허용된 로그아웃 URL',
  'configuration-page.urls.allow-logout.input.placeholder': 'https://',
  'configuration-page.urls.allow-logout.input.add-button': '추가 URL',

  'configuration-page.sign-up.page-title': '등록 설정',
  'configuration-page.sign-up.page-description': '이러한 설정을 통해 사용자 등록을 관리할 수 있습니다.',
  'configuration-page.sign-up.page-notification': '이 옵션을 사용하면 사용자 이름과 암호 또는 이메일과 암호 쌍으로 사용자 등록을 관리할 수 있습니다. 소셜 네트워크를 사용하여 가입을 관리하려면 <a>소셜 네트워크 설정</a>으로 이동하세요.',
  'configuration-page.sign-up.disable-sign-up.title': '사용자 등록',
  'configuration-page.sign-up.disable-sign-up.description': '이 토글을 켜기로 설정하면 사용자가 등록할 수 있게 됩니다.',
  'configuration-page.sign-up.welcome-email.title': '가입 환영 이메일 활성화',
  'configuration-page.sign-up.welcome-email.description': '이 토글이 켜져 있으면 사용자는 가입 시 환영 이메일을 받을 수 있습니다.',


  'configuration-page.password.page-title': '암호 설정',
  'configuration-page.password.page-description': '암호 강도는 인증에 암호를 사용할 경우 중요한 고려 사항입니다.',
  'configuration-page.password.page-notification': '강력한 암호 정책은 타인이 수동 또는 자동으로 암호를 추측하는 것을 불가능하게 만들 수는 없지만 어렵게 만들 수는 있습니다.',
  'configuration-page.password.miscellaneous.title': '기타 암호 설정',
  'configuration-page.password.miscellaneous.description': '다음 보안 조건에서 작동하는 암호를 허용합니다.',
  'configuration-page.password.miscellaneous.notification': '이것은 서로의 단점을 보완하여 보다 강력한 솔루션을 만드는 데 도움이 되는 권장 사항 모음입니다.',
  'configuration-page.password.miscellaneous.recover-pass.title': '암호 복구',
  'configuration-page.password.miscellaneous.recover-pass.description': '사용자가 분실한 암호를 복구하도록 허용.',
  'configuration-page.password.miscellaneous.pass-history.title': '암호 내역',
  'configuration-page.password.miscellaneous.pass-history.description': '각 사용자의 암호 내역을 유지하고 이전 암호의 사용을 방지합니다.',
  'configuration-page.password.miscellaneous.pass-check.title': '암호 확인',
  'configuration-page.password.miscellaneous.pass-check.description': '등록하는 동안 사용자에게 암호를 반복하도록 요청합니다.',
  'configuration-page.password.password-reset-cb-url.title': '암호 재설정 콜백 URL 선택',
  'configuration-page.password.password-reset-cb-url.description': '암호 재설정 후 사용자가 리디렉션되는 URL 주소를 선택해 주세요.',
  'configuration-page.password.password-reset-cb-url.placeholder': 'URL 선택',
  'configuration-page.password.password-validation.toggle-box.title': '암호 검증',
  'configuration-page.password.password-validation.toggle-box.description': '암호 검증 규칙을 선택하세요.',
  'configuration-page.password.password-validation.tests.title': '암호 테스트',
  'configuration-page.password.password-validation.tests.description': '암호를 입력하여 확인하기:',
  'configuration-page.password.password-validation.tests.input-title': '암호',
  'configuration-page.password.status.absent': '보호되지 않음',
  'configuration-page.password.status.weak': '취약한 암호',
  'configuration-page.password.status.good': '적절한 암호',
  'configuration-page.password.status.strong': '강력한 암호',
  'configuration-page.username.page-title': '사용자 이름 설정',
  'configuration-page.username.page-description': '이러한 설정을 통해 기본 로그인 플로우를 설정할 수 있습니다.',
  'configuration-page.username.page-notification': '이 설정을 사용하려면 다음 옵션을 활성화하세요. <ul><li>사용자 이름과 암호를 사용하여 등록</li><li>사용자 이름과 암호를 사용하여 로그인</li></ul>',
  'configuration-page.username.requires.title': '사용자 이름이 필요함',
  'configuration-page.username.requires.description': '사용자는 이메일 주소 외에 사용자 이름을 추가로 제공해야 합니다.',
  'configuration-page.username.username-validation.title': '사용자 이름 검증',
  'configuration-page.username.username-validation.description': '사용자 정의 필드 유효성 검사는 사용자 이름 필드에 대해서만 구성할 수 있습니다.',
  'configuration-page.username.username-validation.notification': '사용자 이름 유효성 검사에 대해 최대 4개의 규칙을 설정하거나 유효성 검사 규칙을 전혀 설정하지 않을 수 있습니다.',
  'configuration-page.username.username-validation.toggle-box.title': '사용자 이름 검증',
  'configuration-page.username.username-validation.toggle-box.description': '사용자 이름 검증 규칙을 선택하세요.',
  'configuration-page.username.username-validation.tests.title': '사용자 이름 테스트',
  'configuration-page.username.username-validation.tests.description': '사용자 이름을 입력하여 확인하기:',
  'configuration-page.username.username-validation.tests.input-title': '사용자 이름',
  'configuration-page.username.username-validation.tests.username-email': '사용자 이름을 이메일로 사용',

  'configuration-page.validation-rule.min_characters': '길이는 최소한 {number}자 이상이어야 함',
  'configuration-page.validation-rule.max_characters': '길이는 최대 {number}자 이하여야 함',
  'configuration-page.validation-rule.user_numerals_spec_symbol': '숫자, 대시 또는 밑줄을 포함해야 함',
  'configuration-page.validation-rule.letter_case': '대문자와 소문자를 조합해야 함',
  'configuration-page.validation-rule.numerals': '숫자를 하나 이상 포함해야 함(0~9)',
  'configuration-page.validation-rule.spec_characters': '최소 1개 이상의 특수 문자를 포함해야 함',
  'configuration-page.validation-rule.allow_ascii_characters': 'ASCII 문자만 포함해야 함',
  'configuration-page.validation-rule.exclude_personal_data': '개인 데이터를 제외해야 함',
  'configuration-page.validation-rule.password_dictionary': '암호 <a>사전</a>에서 단어를 제외해야 함',

  /* settings.email-validation встречается при классической авторизации и passwordless.
    На двух макетах: https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=3724%3A79600
    https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=3724%3A76750
  */
  'settings.email-validation.title': '이메일 유효성 검사',
  'settings.email-validation.subtitle': '이메일 유효성 검사를 통해 사용자 이메일 주소의 진위 여부를 확인할 수 있습니다.',
  'settings.email-validation.notification.label': '하나 이상의 조건을 활성화하여 이메일 주소의 유효성을 확인할 수 있습니다.',
  'settings.email-validation.smtp.switch.title': 'SMTP 유효성 검사',
  'settings.email-validation.smtp.switch.caption': "수신자의 이메일이 실제로 존재하는지 보여주는 수신자의 서버와의 연결입니다.",
  'settings.email-validation.rfc.switch.title': 'RFC 유효성 검사',
  'settings.email-validation.rfc.switch.caption': '이메일 주소에 사용할 수 있는 문자를 결정하는 사양입니다.',
  'settings.email-validation.gray-list.switch.title': '차단 목록 유효성 검사',
  'settings.email-validation.gray-list.switch.caption': '영구적으로 스팸 이메일 도메인을 차단하고 해당 도메인의 이메일을 거부합니다. 이 목록에 이메일 도메인을 추가하거나 목록에서 제외하려면 문의해 주세요.',
  'settings.email-validation.confirmation.switch.title': '확인 이메일 전송',
  'settings.email-validation.confirmation.switch.caption': "사용자를 확인하기 위해 확인 이메일을 전송합니다.",

  'settings.email-settings.title': '이메일 설정',
  'settings.email-settings.subtitle': '이러한 설정을 통해 기본 로그인 플로우를 설정할 수 있습니다.',
  'settings.email-settings.magic-link.title': '매직 링크',
  'settings.email-settings.magic-link.subtitle': '클릭하여 로그인해야 하는 링크가 포함된 이메일을 사용자가 받게 됩니다.',
  'settings.email-settings.magic-link.switch.title': '매직 링크로 로그인',
  'settings.email-settings.magic-link.switch.caption': '링크를 클릭한 후 사용자가 로그인하도록 허용합니다.',

  'settings.crumbs.login-type.passwordless-login': '암호 없는 로그인',
  'settings.tabs.email-settings': '이메일 설정',
  'settings.tabs.passwordless-settings': '설정',

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=3724%3A79600 */
  'settings.passwordless.change-method.description': '암호를 사용하지 않고 사용자가 이메일 주소 또는 전화번호를 통해 로그인할 수 있게 합니다.',
  'settings.passwordless.change-method.notification': '사용하고자 하는 비밀번호 없는 인증 유형을 선택하세요:',
  'settings.passwordless.change-method.phone.label': '비밀번호 없이 전화를 이용한 로그인',
  'settings.passwordless.change-method.phone.description': '사용자가 전화번호 및 확인 코드를 사용하여 로그인할 수 있게 합니다.',
  'settings.passwordless.change-method.email.label': '비밀번호 없이 이메일 주소를 이용한 로그인',
  'settings.passwordless.change-method.email.description': '사용자가 이메일 주소 및 확인 코드를 사용하여 등록 및 로그인할 수 있게 합니다.',
  'settings.passwordless.change-method.phoneEmail.label': '비밀번호 없이 전화번호 및 이메일 주소를 이용한 로그인',
  'settings.passwordless.change-method.phoneEmail.description': '사용자가 전화번호 및 확인 코드와 함께 이메일 주소를 사용하여 등록 및 로그인할 수 있게 합니다.',

  'secure.oauth2.tab': 'OAuth 2.0',
  'secure.signature.tab': 'JWT 서명',
  'secure.mfa.tab': 'MFA 정책',
  'authorization.settings.oauth2.client.title': 'OAuth 2.0 클라이언트',
  'authorization.settings.oauth2.client.subtitle': 'OAuth 2.0은 인증 레이어로 작동하며 클라이언트를 리소스 소유자로부터 분리합니다.',
  'authorization.settings.oauth2.notification': '<b>클라이언트 ID 및 비밀 키 취득 방법</b> <br></br> 1. OAuth 2.0 인증을 추가합니다.<br></br> 2. 클라이언트 이름 및 OAuth 2.0 리디렉션 URI를 지정합니다.<br></br> 3. 인증 유형 지정: 공개 혹은 기밀.<br></br><br></br> <a>문서를 보고</a>, OAuth 2.0에 대해 알아보기.',
  'authorization.settings.oauth2.add': 'OAuth 2.0 클라이언트 추가',
  'authorization.settings.oauth2.server.title': 'OAuth 2.0 서버',
  'authorization.settings.oauth2.server.name.title': '클라이언트 이름',
  'authorization.settings.oauth2.server.name.placeholder': 'OAuth 2.0 인증',
  'authorization.settings.oauth2.server.secret-key.title': '비밀 키',
  'authorization.settings.oauth2.server.secret-key.extra': '비밀 키 초기화',
  'authorization.settings.oauth2.server.subtitle': 'OAuth 2.0은 인증 레이어로 작동하며 클라이언트를 리소스 소유자로부터 분리합니다.',
  'authorization.settings.oauth2.table.client-name': '클라이언트 이름',
  'authorization.settings.oauth2.table.client-id': '클라이언트 ID',
  'authorization.settings.oauth2.table.client-secret': '비밀 키',
  'authorization.settings.oauth2.table.auth-type': '인증 유형',
  'authorization.settings.oauth2.table.copy': '복사 키',
  'authorization.settings.oauth2.table.empty.title': '아직 OAuth 2.0 클라이언트가 없음',
  'authorization.settings.oauth2.table.empty.text': '추가된 모든 OAuth 2.0 클라이언트가 여기에 표시됩니다.',
  'authorization.settings.oauth2.modal.connect.button': '연결',
  'authorization.settings.oauth2.modal.connect.title': 'OAuth 2.0 인증',
  'authorization.settings.oauth2.modal.connect.instruction.title': 'OAuth 2.0 인증 설정 방법',
  'authorization.settings.oauth2.modal.connect.instruction': '1. 클라이언트 ID 및 기본 키를 복사합니다<br></br> 2. <a>위젯</a> 혹은 <c>API apthem</c>를 통해 프로젝트 통합을 업데이트합니다',
  'authorization.settings.oauth2.modal.connect.redirect-uri.title': 'OAuth 2.0 리디렉션 URI',
  'authorization.settings.oauth2.modal.connect.redirect-uri.placeholder': 'https://example.com',
  'authorization.settings.oauth2.validation.invalid-url': '잘못된 URL',
  'authorization.settings.oauth2.validation.duplicate-url': '중복 URL',
  'authorization.settings.oauth2.modal.connect.type.public': '공개 <span>(앱에 권장)</span>',
  'authorization.settings.oauth2.modal.connect.type.private': '기밀 <span>(서버에서 서버로 연결 시 권장)</span>',
  'authorization.settings.oauth2.modal.connect.success.title': 'OAuth 2.0 인증이 성공적으로 연결됨',
  'authorization.settings.oauth2.modal.connect.success.subtitle': '프로젝트 통합을 위해 이 클라이언트 ID 및 비밀 키 복사',
  'authorization.settings.oauth2.modal.connect.success.client-id': '클라이언트 ID',
  'authorization.settings.oauth2.modal.connect.success.more-title.title': '다음 단계',
  'authorization.settings.oauth2.modal.connect.success.more-title': 'OAuth 2.0 인증 통합 방법',
  'authorization.settings.oauth2.modal.connect.success.dismiss': '닫기',
  'authorization.settings.oauth2.modal.connect.update.remove': 'OAuth 2.0 클라이언트 삭제',
  'authorization.settings.oauth2.modal.connect.update.remove.subtitle': '삭제한 OAuth 2.0 클라이언트는 복구할 수 없습니다.',
  'authorization.settings.oauth2.modal.remove.title': '{name} OAuth 2.0 클라이언트를 삭제하시겠습니까?',
  'authorization.settings.oauth2.modal.remove.subtitle': '다른 인증 메소드를 구성할 때까지 모든 연결된 URI은 사용자에 대한 인증을 해 줄 수 없습니다.',
  'authorization.settings.oauth2.modal.remove.checkbox': '예, 알고 있습니다',
  'authorization.settings.oauth2.modal.remove.submit': '예, 삭제합니다',
  'authorization.settings.oauth2.table.client-key': '클라이언트 키',
  'authorization.settings.oauth2.table.server-key': '서버 키',
  'authorization.settings.oauth2.modal.connect.type.server': '서버 <span>(서버에서 서버로 연결)</span>',
  'authorization.settings.oauth2.modal.connect.merchant-project.label': '프로젝트 ID',
  'authorization.settings.oauth2.modal.connect.type.server.description': ' 인증 레이어로 작동하며 클라이언트를 리소스 소유자로부터 분리합니다.',
  'authorization.settings.oauth2.modal.connect.type.confidential.description': '로그인을 시작하려면 클라이언트에 비밀 키가 필요합니다.',
  'authorization.settings.oauth2.modal.connect.type.public.description': '클라이언트에 비밀 키가 필요하지 않습니다.',

  'authorization.settings.babkaLogin.modal.connect.title': '새로운 OAuth 2.0 클라이언트',
  'authorization.settings.babkaLogin.modal.connect.scope.title': 'Scope',
  'authorization.settings.babkaLogin.modal.connect.scope.placeholder': '새로운 범위',
  'authorization.settings.babkaLogin.modal.connect.audience.title': 'Audience',
  'authorization.settings.babkaLogin.client.name': '엑솔라 OAuth 2.0 클라이언트',
  'authorization.settings.babkaLogin.field.logo-url.title': '애플리케이션 아이콘',
  'authorization.settings.babkaLogin.field.logo-url.tooltip': '권장 이미지 해상도: {sizePx}x{sizePx}{br}지원 형식: JPG 및 PNG{br}최대 크기: {sizeKb}KB',
  "authorization.settings.babkaLogin.field.logo-url.upload-error": "이미지를 업로드할 수 없습니다. 다시 시도해주세요.",
  "authorization.settings.babkaLogin.field.logo-url.size-error": "이미지 크기는 {size}KB 미만이어야 합니다.",
  "authorization.settings.babkaLogin.info.displayed-details": "엑솔라 ID로 앱 또는 게임에 로그인한 경우 플레이어의 엑솔라 지갑 페이지에 앱의 아이콘, 이름 및 설명이 표시됩니다.",
  'authorization.settings.babkaLogin.field.name.label': '애플리케이션 이름',
  'authorization.settings.babkaLogin.field.description.label': '짧은 설명',
  'authorization.settings.babkaLogin.scopes.add-button': '새로운 범위',
  'authorization.settings.babkaLogin.field.scope.regex-error': '라틴 문자, 점 또는 밑줄만 사용하되, 점이나 밑줄로 시작하거나 끝내지 마십시오.',

  'social-connection.title': '소셜 네트워크',
  'social-connection.subtitle': '클릭 단 한 번으로 사용자가 그들이 선택한 신원 정보 제공자를 통해 여러분 앱에 로그인하도록 할 수 있습니다.',
  'social-connection.tabs.social-connection-path': '소셜 네트워크',
  'social-connection.tabs.enterprise-connection-path': 'OAuth 2.0 로그인 연결',
  'social-connection.tabs.passkey': '패스키',
  'social-connection.tabs.miscellaneous': '여타 형식',
  'social-connection.tabs.api-settings': '로그인 API 통합',
  'social-connection.select.deselect': '선택 해제',
  'social-connection.select.select': '모두 선택',
  'social-connection.select.all': '모든 SNS',
  'social-connection.select.connected': '연결됨',
  'social-connection.select.disconnected': '연결 해제',
  'social-connection.search.placeholder': '검색...',
  'social-connection.mode.title': '관리',
  'social-connection.mode.connect': '연결',
  'social-connection.mode.disconnect': '연결 해제',
  'social-connection.card.tooltip': '엑솔라 키로 활성화',
  'social-connection.card.subscription.subtitle': '사용자가 여러분 앱에 등록하고 로그인하도록 허용',
  'social-connection.card.settings.connect': '연결',
  'social-connection.card.settings.disconnect': '연결 해제',
  'social-connection.card.settings.settings': '설정',
  'social-connection.card.settings.try': '연결 시도',
  'social-connection.babka-disconnect.title': '엑솔라 계정 연결 해제',
  'social-connection.babka-disconnect.description': '연결 해제 후, 사용자는 엑솔라 ID로 자동으로 마이그레이션됩니다. 엑솔라 계정 옵션은 더 이상 표시되지 않습니다. 이를 되돌리려면 지원을 요청해야 합니다.',
  'social-connection.card.status.connected': '연결됨',
  'social-connection.card.status.disconnected': '연결 해제',
  'social-connection.card.button.show-more': '모두 표시',
  'social-connection.card.button.show-less': '간단히 표시',
  'social-connection.jwt.title': '소셜 네트워크 JWT 토큰 내장',
  'social-connection.jwt.subtitle': '엑솔라 로그인 JWT 토큰에 소셜 네트워크 JWT 토큰을 자동으로 내장합니다.',
  'social-connection.jwt.notification': '소셜 네트워크 API에 직접 액세스하는 데 소셜 네트워크 JWT 토큰을 사용할 수도 있습니다.',

  'social-connection.settings.subtitle': '다음 단계를 따라 이 SNS에 연결.',
  'social-connection.settings.notification': "자신의 애플리케이션을 사용하는 경우:<br></br> 1. 소셜 네트워크에서 개발자 계정으로 이동합니다.<br></br> 2. {link}를 허용된 리디렉션 URI로 추가합니다.<br></br><br></br> 참고: SNS 인증에 엑솔라 애플리케이션을 사용하는 경우에는 위의 설정을 완료할 필요가 없습니다.",
  'social-connection.settings.sync.notification': '기본적으로, 로그인은 각 사용자 로그인 시 사용자 프로필을 자동으로 동기화합니다.',
  'social-connection.settings.back-button': '<b>SNS</b>로 돌아가기',
  'social-connection.settings.sync.switch.title': '매 로그인 이후, 사용자 프로필 특성을 동기화합니다',
  'social-connection.settings.sync.switch.subtitle': '선택 사항으로, 사용자 프로필 데이터 동기화를 비활성화하여 application에서 프로필 속성을 업데이트할 수 있습니다.',
  'social-connection.settings.app-id.notification': 'Application ID 획득 방법',
  'social-connection.settings.one-tap.title': '{name} 한 번 택하여 로그인',
  'social-connection.settings.one-tap.subtitle': '별도의 로그인 창 없이 사용자가 자신의 {name} 계정을 통해 로그인할 수 있도록 합니다.',
  'social-connection.settings.field.client_id.label': '애플리케이션 ID',
  'social-connection.settings.field.client_id.placeholder': '엑솔라 ID를 사용하려면 비워둡니다.',
  'social-connection.settings.field.client_secret.label': '애플리케이션 비밀 키',
  'social-connection.settings.field.client_secret.placeholder': '엑솔라 키를 사용하려면 비워둡니다.',
  'social-connection.settings.field.client_secret.footer': '보안상의 목적으로, 여러분의 기존 비밀 키는 볼 수 없습니다.',
  'social-connection.settings.field.client_secret.file': '업로드한 파일',
  'social-connection.settings.field.custom_return_url.label': 'Return URL 사용자 정의',
  'social-connection.settings.field.custom_return_url.placeholder': '엑솔라 Return URL을 사용하려면 공백으로 남겨둡니다.',
  'social-connection.settings.field.team_id.label': 'Team ID',
  'social-connection.settings.field.team_id.placeholder': '엑솔라 Team ID를 사용하려면 비워둡니다.',
  'social-connection.settings.field.key_id.label': 'Key ID',
  'social-connection.settings.field.key_id.placeholder': '엑솔라 Key ID를 사용하려면 비워둡니다.',
  'social-connection.settings.scopes-disabled.notification': '확인한 사용자 데이터를 취합하거나 SNS에서 확인한 권한을 적용하기 위해 여러분 자신의 SNS application을 사용할 필요가 있습니다. 이렇게 하려면, 위의 application ID 및 application 비밀 키를 입력하세요.',
  'social-connection.settings.user-data.title': '사용자 데이터',
  'social-connection.settings.user-data.subtitle': '아래에서 확인된 사용자 프로필 데이터에 대한 접근을 제공합니다. {name}은 해당 동의 메시지를 표시합니다.',
  'social-connection.settings.permission.title': '허가',
  'social-connection.settings.permission.subtitle': '확인한 각 허가에 대하여, 로그인은 해당 허가를 {name}에서 요청하여 access_token을 사용하여 {name} API를 호출할 수 있습니다.',
  'social-connection.settings.permission.notification': '<a>세부 내역은 {name} 문서</a>를 보세요.',
  'social-connection.settings.field.url_authorize.label': '인증 URL',
  'social-connection.settings.field.url_access_token.label': '액세스 토큰 URL',
  'social-connection.subtitle.custom-social': "사용자 정의 OAuth 2.0 로그인 연결을 활성화했습니다. <a>OAuth 2.0 로그인 연결 페이지를 엽니다.</a>",

  /* Custom social fields */
  'social-connection.settings.apple.app-id.notification': 'Service ID를 받는 방법',
  'social-connection.settings.apple.app-id.notification': 'Service ID를 받는 방법',
  'social-connection.settings.babka.app-id.notification': '엑솔라 계정이 비활성되어 있는 경우 <a>다음 지침을 따르세요</a>.',
  'social-connection.settings.field.apple.client_id.label': 'Service ID',
  'social-connection.settings.field.apple.client_id.placeholder': '엑솔라 Service ID를 사용하려면 비워둡니다.',
  'social-connection.settings.field.apple.client_secret.label': 'Auth Key',
  'social-connection.settings.field.apple.client_secret.placeholder': '엑솔라 키를 사용하려면 비워둡니다.',
  'social-connection.settings.field.apple.client_secret.file': '키 파일',
  'social-connection.settings.field.babka.audience.label': '웹사이트 링크',

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=2454%3A77981 */
  'settings.tabs.platform-settings': '퍼블리싱 플랫폼',
  'settings.platform-settings.connect': '연결',
  'settings.platform-settings.update': '적용',
  'settings.platform-settings.select.all': '모든 게시 플랫폼',

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=745%3A38333 */
  'custom-providers.settings.email.title': '이메일 서비스 제공업체',
  'custom-providers.settings.email.subtitle': '이메일 커뮤니케이션을 직접 관리, 모니터링, 문제 해결하도록 이메일 서비스 제공업체를 구성할 수 있습니다.',
  'custom-providers.settings.email.notification': '<a>이메일 사용자 정의 페이지에서 이메일을 사용자 정의하세요.</a> 엑솔라 이메일 템플릿을 기본 템플릿으로 사용할 수도 있습니다.',
  'custom-providers.settings.email.settings.label': '이메일 발신자 설정',
  'custom-providers.settings.email.settings.description': '발신자 이름과 발신자 이메일 주소를 지정할 수 있습니다. 이를 지정하지 않으면 로그인 프로젝트에서 설정한 기본 발신자 이름과 발신자 이메일 주소를 수신자가 보게 됩니다.',
  'custom-providers.settings.email.from_email.label': '발신자 이메일 주소',
  'custom-providers.settings.email.from_email.placeholder': 'noreply@login.xsolla.com',
  'custom-providers.settings.email.from_email.footer': '이메일을 받는 수신자에게 이 이메일 주소가 표시됩니다.',
  'custom-providers.settings.email.from_name.label': '발신자 이름',
  'custom-providers.settings.email.from_name.footer': '귀하로부터 이메일을 받는 수신자에게 이 이름이 표시됩니다.',
  'custom-providers.settings.email.provider.notification': '기본값으로 SendGrid가 사용됩니다. SendGrid API 키는 항상 엑솔라 데이터베이스 내에서 암호화됩니다.',
  'custom-providers.settings.email.provider.send-grid': 'SendGrid',
  'custom-providers.settings.email.provider.send-grid.label': '제공업체 설정',
  'custom-providers.settings.email.provider.send-grid.description': 'SendGrid 계정에 가입하고 <a>API 키</a>를 받으세요.',
  'custom-providers.settings.email.provider.send-grid.api-key.label': 'API 키',
  'custom-providers.settings.email.provider.send-grid.api-key.placeholder': 'SendGrid API 키',
  'custom-providers.settings.email.provider.smtp': '사용자 정의(곧 제공 예정)',
  'custom-providers.settings.email.provider.smtp.label': '제공업체 설정',
  'custom-providers.settings.email.provider.smtp.description': 'SMTP 자격 증명은 항상 당사 데이터베이스에서 암호화됩니다. 설정을 저장하고 \"테스트 이메일 보내기\" 버튼을 사용하여 연결을 테스트할 수 있습니다. <a>자세한 내용은 지침을 확인하세요</a>.',
  'custom-providers.settings.email.provider.smtp.notification': 'SMTP 서버 요구 사항:<ul><li>사용자 이름 및 암호 인증을 지원해야 합니다.</li><li>TLS 1.0 이상을 지원해야 합니다.</li></ul>',
  'custom-providers.settings.email.provider.smtp.host.label': 'Host',
  'custom-providers.settings.email.provider.smtp.host.placeholder': 'your.smtp.host.com',
  'custom-providers.settings.email.provider.smtp.host.sublabel': 'SMTP 서버의 호스트 이름 또는 IP 주소',
  'custom-providers.settings.email.provider.smtp.port.label': '포트',
  'custom-providers.settings.email.provider.smtp.port.placeholder': '587',
  'custom-providers.settings.email.provider.smtp.port.sublabel': 'SMTP 서버에서 사용하는 포트입니다. 공통 포트는 25, 465 및 587입니다.<br></br>가능하면 포트 25를 사용하지 마세요. 많은 서비스 제공업체가 이 포트에 제한을 두고 있습니다.',
  'custom-providers.settings.email.provider.smtp.username.label': '사용자 이름',
  'custom-providers.settings.email.provider.smtp.username.placeholder': '서비스 제공업체 사용자 이름 사용자 정의',
  'custom-providers.settings.email.provider.smtp.password.label': '암호',
  'custom-providers.settings.email.provider.smtp.password.placeholder': '서비스 제공업체 암호 사용자 정의',

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=3724%3A87099 */
  'miscellaneous.settings.title': '다양한 데이터 양식',
  'miscellaneous.settings.subtitle': '등록 진행 중 필요 데이터가 제공되지 않는 경우, 추가 양식을 사용하세요. 추가 검증을 위한 데이터 양식은 성공적인 인증에 도움이 됩니다. 이러한 양식은 수집된 이메일 주소 및 전화번호를 확인에 사용됩니다.',
  'miscellaneous.settings.email.title': '이메일 주소 양식',
  'miscellaneous.settings.email.subtitle': '등록 진행 중 필요 데이터가 제공되지 않거나 SNS가 인증 수단으로 사용 가능한 경우, 이메일 주소가 추가 양식이 됩니다.',
  'miscellaneous.settings.email.collect-data.title': '사용자 이메일 주소 취합',
  'miscellaneous.settings.email.collect-data.subtitle': '확인 코드 혹은 사용자가 받은 이메일 링크를 통해 수집한 이메일 주소를 확인합니다.',
  'miscellaneous.settings.email.required.title': '이메일 양식을 작성하도록 사용자에게 요구',
  'miscellaneous.settings.email.required.subtitle': '이 토글이 켜짐으로 설정되어 있으면 사용자는 추가 데이터 수집 양식을 작성해야 합니다. 꺼짐으로 설정된 경우에 사용자는 양식을 건너뛸 수 있습니다.',
  'miscellaneous.settings.email.confirmation.title': '이메일 주소 확인 방식',
  'miscellaneous.settings.email.confirmation.code.title': '코드를 통함',
  'miscellaneous.settings.email.confirmation.code.description': '사용자가 받은 코드를 통한 확인',
  'miscellaneous.settings.email.confirmation.link.title': '코드 및 링크를 통함',
  'miscellaneous.settings.email.confirmation.link.description': '코드 및 사용자가 받은 이메일 링크를 통한 확인.',
  'miscellaneous.settings.email.confirmation.link-only.title': '링크 사용',
  'miscellaneous.settings.email.confirmation.link-only.description': '사용자에게 이메일로 전송된 링크로 확인합니다.',
  'miscellaneous.settings.phone_number.title': '전화 번호 양식',
  'miscellaneous.settings.phone_number.subtitle': '등록 진행 중 필요 데이터가 제공되지 않거나 SNS가 인증 수단으로 사용 가능한 경우, 전화 번호가 추가 양식이 됩니다.',
  'miscellaneous.settings.phone_number.collect-data.title': '사용자 전화 번호 수집',
  'miscellaneous.settings.phone_number.collect-data.subtitle': '수집한 전화 번호는 SMS로 전송한 확인 코드를 통해 확인합니다.',
  'miscellaneous.settings.phone_number.required.title': '전화번호를 입력하도록 사용자에게 요구',
  'miscellaneous.settings.phone_number.required.subtitle': '이 토글이 켜짐으로 설정되어 있으면 사용자는 추가 데이터 수집 양식을 작성해야 합니다. 꺼짐으로 설정된 경우에 사용자는 양식을 건너뛸 수 있습니다.',
  'miscellaneous.settings.order.title': '양식 주문',
  'miscellaneous.settings.order.subtitle': '확인 양식은 선택한 순서대로 사용자에게 표시됩니다.',
  'miscellaneous.settings.order.notification': '본 옵션을 사용하려면, 이메일 주소 및 전화 번호 양식을 모두 활성화할 필요가 있습니다.',
  'miscellaneous.settings.order.email': '이메일 양식 먼저',
  'miscellaneous.settings.order.phone': '전화 양식 먼저',

  'api-settings.title': '로그인 API 통합',
  'api-settings.subtitle': '로그인 API와의 통합을 구성합니다.',
  'api-settings.device-id.title': '장치 ID로 로그인',
  'api-settings.device-id.subtitle': '<a>API 호출</a>을 사용하여 장치 ID로 사용자가 로그인할 수 있게 허용합니다.',

  'auth-methods.login_pass_auth': '이메일/암호',
  'auth-methods.email_auth': '이메일을 통해 암호 없이',
  'auth-methods.phone_auth': '전화를 통해 암호 없이',
  'auth-methods.telegram': 'Telegram',
  'auth-methods.other': '기타',
  'auth-methods.google': 'Google',
  'auth-methods.abyss': 'The Abyss',
  'auth-methods.apple': 'Apple',
  'auth-methods.epicgames': 'Epic Games',
  'auth-methods.amazon': 'Amazon',
  'auth-methods.babka': '엑솔라',
  'auth-methods.baidu': 'Baidu',
  'auth-methods.battlenet': 'Battle.net',
  'auth-methods.china_telecom': 'China Telecom',
  'auth-methods.discord': 'Discord',
  'auth-methods.facebook': 'Facebook',
  'auth-methods.github': 'GitHub',
  'auth-methods.google-plus': 'Google+',
  'auth-methods.instagram': 'Instagram',
  'auth-methods.kabam': 'Kabam',
  'auth-methods.kakao': '카카오톡',
  'auth-methods.linkedin': 'LinkedIn',
  'auth-methods.mailru': 'Mail.Ru',
  'auth-methods.microsoft': 'Microsoft 계정',
  'auth-methods.msn': 'MSN',
  'auth-methods.naver': 'Naver',
  'auth-methods.ok': 'OK',
  'auth-methods.paradox': 'Paradox',
  'auth-methods.paypal': 'PayPal',
  'auth-methods.pinterest': 'Pinterest',
  'auth-methods.playfab': 'PlayFab',
  'auth-methods.wbgames': 'Player Network',
  'auth-methods.qq': 'QQ',
  'auth-methods.reddit': 'Reddit',
  'auth-methods.steam': 'Steam',
  'auth-methods.stone': 'Stone',
  'auth-methods.twitch': 'Twitch',
  'auth-methods.twitter': 'X',
  'auth-methods.vimeo': 'Vimeo',
  'auth-methods.vk': 'VK',
  'auth-methods.wechat': 'WeChat',
  'auth-methods.weibo': 'Weibo',
  'auth-methods.xbox': 'Xbox Live',
  'auth-methods.xsolla-id': 'Xsolla',
  'auth-methods.yahoo': 'Yahoo',
  'auth-methods.yandex': 'Yandex',
  'auth-methods.youtube': 'YouTube',

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=3724%3A86451 */
  'enterprise-connection.settings.title': 'OAuth 2.0 로그인 연결',
  'enterprise-connection.settings.subtitle': '사용자가 OAuth 2.0을 통해 엑솔라에 연결된 인증 인터페이스로 로그인할 수 있습니다.',
  'enterprise-connection.settings.notification': 'OAuth 로그인 연결을 사용하려면 아래 필드를 작성해 주세요. 도움이 필요하면 <a>고객 성공 매니저에게 문의해 주세요</a>.',
  'enterprise-connection.settings.integration-name.label': '인증 이름',
  'enterprise-connection.settings.integration-name.tooltip': '엑솔라 로그인에서 OAuth 2.0 연동을 식별하는 데 사용됩니다.',
  'enterprise-connection.settings.integration-name.placeholder': 'xsolla-oauth2',
  'enterprise-connection.settings.authorization-endpoint.label': '인증 URL',
  'enterprise-connection.settings.authorization-endpoint.placeholder': 'https://example.com',
  'enterprise-connection.settings.authorization-endpoint.tooltip': '인증과 액세스를 위해 사용자가 리디렉션되는 인증 서버 엔드포인트의 URL입니다.',
  'enterprise-connection.settings.token-endpoint.label': '토큰 URL',
  'enterprise-connection.settings.token-endpoint.placeholder': 'https://example.com',
  'enterprise-connection.settings.token-endpoint.tooltip': '인증 성공 후 액세스 토큰을 가져오는 인증 서버 토큰 엔드포인트의 URL입니다.',
  'enterprise-connection.settings.url_resource_owner_details.label': '귀하의 정보 URL',
  'enterprise-connection.settings.url_resource_owner_details.placeholder': 'https://example.com',
  'enterprise-connection.settings.url_resource_owner_details.tooltip': '인증 서버 사용자 정보 엔드포인트의 URL',
  'enterprise-connection.settings.client-id.label': '클라이언트 ID',
  'enterprise-connection.settings.client-id.placeholder': '1234',
  'enterprise-connection.settings.client-id.tooltip': '인증 시스템에서 생성한 고유 ID\n',
  'enterprise-connection.settings.client-secret.label': '클라이언트 비밀 키',
  'enterprise-connection.settings.client-secret.placeholder': '123a12b1234ab1234a1ab1234abc1234',
  'enterprise-connection.settings.client-secret.tooltip': '인증 서버에서 제공',
  'enterprise-connection.settings.scope.label': '권한 범위',
  'enterprise-connection.settings.scope.placeholder': '예: 이메일, 오프라인 등',
  'enterprise-connection.settings.map.title': '키 이름 지도',
  'enterprise-connection.settings.map.description': '토큰의 사용자 속성 키 이름을 입력하여 Xsolla Login과 데이터를 동기화합니다.',
  'enterprise-connection.settings.map.notification': '오른쪽 필드에 키 이름을 입력하세요. 입력한 키 이름은 왼쪽의 해당 필드와 매핑됩니다.',
  'enterprise-connection.settings.delete': '로그인 연결 삭제',
  'enterprise-connection.settings.map.email.placeholder': "토큰의 이메일 키 이름",
  'enterprise-connection.settings.map.id.placeholder': "토큰의 ID 키 이름",
  "enterprise-connection.settings.customization.title": "사용자 정의",
  "enterprise-connection.settings.customization.subtitle": "로그인 위젯에 인증 버튼이 표시되도록 설정하기",
  "enterprise-connection.settings.customization.display_name.label": "인증 버튼 이름",
  "enterprise-connection.settings.customization.display_name.tooltip": "이 이름이 사용자에게 표시됩니다.",
  "enterprise-connection.settings.customization.background_color.label": "인증 버튼 색상",
  "enterprise-connection.settings.customization.logo_url.label": "로고",
  "enterprise-connection.settings.customization.logo_url.footer": "권장 크기: 24px × 24px{newLine}지원 형식: JPG, PNG 및 SVG",

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=6751%3A97166 */
  'custom-providers.bread-crumbs.label': '통신 서비스 제공업체',
  'custom-providers.tabs.email': '이메일 서비스 제공업체',
  'custom-providers.tabs.sms': 'SMS 서비스 제공업체',
  'custom-providers.tabs.send-sms.button': '테스트 SMS 전송',
  'custom-providers.tabs.send-email.button': '테스트 이메일 전송',

  'custom-providers.settings.sms.title': 'SMS 서비스 제공업체',
  'custom-providers.settings.sms.fields-group.active': '활성',
  'custom-providers.settings.sms.fields-group.inactive': '비활성',
  'custom-providers.settings.sms.fields-group.list-item.activate': '서비스 제공업체 활성화',
  'custom-providers.settings.sms.fields-group.list-item.deactivate': '서비스 제공업체 비활성화',
  'custom-providers.settings.sms.subtitle': '코드가 포함된 SMS를 인증 방식으로 사용하도록 SMS 서비스 제공업체를 구성할 수 있습니다.',
  'custom-providers.settings.sms.notification': '기본값으로 Amazon SNS, Twilio, Sinch, Telnyx, SMSCENTER 및 Alibaba Cloud를 SMS 서비스 제공업체로 사용할 수 있습니다. 여러 제공업체를 사용하고 개별적으로 활성화하거나 비활성화할 수도 있습니다. 여러 제공업체를 활성화하면 각 국가에 가장 적합한 제공업체를 사용합니다.',
  'custom-providers.settings.sms.msp.read-more': '<a>메시지 서비스 제공업체 가격 정책에 대한 자세한 내용을 알아보세요.</a>',
  'custom-providers.settings.sms.provider.sender-id.label': '발신자 ID',
  'custom-providers.settings.sms.provider.sender-id.placeholder': 'your.smtp.host.com',
  'custom-providers.settings.sms.provider.sender-id.sublabel': '<a>SMS 메시지 발신자를 식별하는 알파벳 이름</a>',
  'custom-providers.settings.sms.provider.amazon': 'Amazon SNS',
  'custom-providers.settings.sms.provider.amazon.label': 'Amazon SNS 설정',
  'custom-providers.settings.sms.provider.amazon.description': 'Amazon 계정에 가입하고 도메인을 확인하고 프로덕션 액세스를 요청하여 <a>Amazon SNS를 구성</a>합니다.',
  'custom-providers.settings.sms.provider.amazon.phone.label': 'Amazon SNS 전화번호',
  'custom-providers.settings.sms.provider.amazon.key-id.label': '액세스 키 ID',
  'custom-providers.settings.sms.provider.amazon.access-key.label': '비밀 액세스 키',
  'custom-providers.settings.sms.provider.amazon.region.label': '지역',
  'custom-providers.settings.sms.provider.amazon.region.sublabel': '<a>귀하의 AWS SNS 지역</a>',
  'custom-providers.settings.sms.provider.twilio': 'Twilio',
  'custom-providers.settings.sms.provider.twilio.label': 'Twilio 설정',
  'custom-providers.settings.sms.provider.twilio.description': 'Twilio 계정에 가입하고 <a>프로그램 가능 메시징 API를 구성</a>합니다.',
  'custom-providers.settings.sms.provider.twilio.sid.label': 'Twilio SID',
  'custom-providers.settings.sms.provider.twilio.sid.sublabel': '<a>Twilio SID에 대해 자세히 알아보기</a>',
  'custom-providers.settings.sms.provider.twilio.auth-token.label': 'Twilio 인증 토큰',
  'custom-providers.settings.sms.provider.twilio.auth-token.sublabel': '<a>Twilio 인증 토큰에 대해 자세히 알아보기</a>',
  'custom-providers.settings.sms.provider.twilio.phone.label': 'Twilio 전화 번호',
  'custom-providers.settings.sms.provider.sinch': 'Sinch',
  'custom-providers.settings.sms.provider.sinch.label': 'Sinch 설정',
  'custom-providers.settings.sms.provider.sinch.description': 'Sinch 계정에 가입하고 <a>SMS 메시징 API를 구성</a>합니다.',
  'custom-providers.settings.sms.provider.sinch.plan-id.label': 'Sinch 서비스 플랜 ID',
  'custom-providers.settings.sms.provider.sinch.plan-id.sublabel': '<a>Sinch 서비스 플랜 ID에 대해 자세히 알아보기</a>',
  'custom-providers.settings.sms.provider.sinch.auth-token.label': 'Sinch API 토큰',
  'custom-providers.settings.sms.provider.sinch.phone.label': 'Sinch 전화 번호',
  'custom-providers.settings.sms.provider.telnyx': 'Telnyx',
  'custom-providers.settings.sms.provider.telnyx.label': 'Telnyx 설정',
  'custom-providers.settings.sms.provider.telnyx.description': 'Telnyx 계정에 가입하고 <a>SMS API를 구성</a>합니다.',
  'custom-providers.settings.sms.provider.telnyx.app-id.label': 'Telnyx Messaging Profile ID',
  'custom-providers.settings.sms.provider.telnyx.api-key.label': 'Telnyx API 키',
  'custom-providers.settings.sms.provider.telnyx.phone.label': 'Telnyx 전화 번호',
  'custom-providers.settings.sms.provider.smscenter': 'SMSCENTER',
  'custom-providers.settings.sms.provider.smscenter.label': 'SMSCENTER 설정',
  'custom-providers.settings.sms.provider.smscenter.description': 'SMSCENTER에 가입하고 <a>SMS API를 구성</a>합니다.',
  'custom-providers.settings.sms.provider.smscenter.app-id.label': 'SMSCENTER 로그인',
  'custom-providers.settings.sms.provider.smscenter.app-secret.label': 'SMSCENTER 암호',
  'custom-providers.settings.sms.provider.smscenter.sender-id.label': '발신자 이름',
  'custom-providers.settings.sms.provider.alibaba': 'Alibaba Cloud',
  'custom-providers.settings.sms.provider.alibaba.label': 'Alibaba Cloud 설정',
  'custom-providers.settings.sms.provider.alibaba.description': 'Alibaba Cloud에 가입하고 <a>SMS API를 구성</a>합니다.',
  'custom-providers.settings.sms.provider.alibaba.app-id.label': '액세스 키 ID',
  'custom-providers.settings.sms.provider.alibaba.app-secret.label': '비밀 액세스 키',
  'custom-providers.settings.sms.provider.alibaba.sender-id.label': '발신자 ID',

  'user-data-base.breadcrumb.label': '사용자 데이터베이스',
  'user-data-base.settings.tabs.users': '사용자',
  'user-data-base.settings.tabs.data-storage': '데이터 저장소',
  'user-data-base.settings.tabs.user-supplementary-info': '추가 사용자 정보',

  /* User storage https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=1943%3A66839 */
  'user-data-base.settings.title': '사용자 데이터 저장소',
  'user-data-base.settings.subtitle': '제품 기능은 선택한 사용자 데이터 저장소 방법에 따라 다릅니다.',
  'user-data-base.settings.user-storage.xsolla.label': '엑솔라 저장소',
  'user-data-base.settings.user-storage.xsolla.description': '기본 방법. 사용자 데이터가 엑솔라 측에 저장됩니다.',
  'user-data-base.settings.user-storage.custom.label': '저장소 사용자 정의',
  'user-data-base.settings.user-storage.custom.description': '사용자 데이터가 엑솔라 측에 저장되지만 암호는 사용자 정의 저장소를 통해 확인됩니다.',
  'user-data-base.settings.user-storage.custom.notification.title': '사용자 정의 저장소로 가능한 작업:',
  'user-data-base.settings.user-storage.custom.notification.description': '<ul><li>사용자 등록</li><li>사용자 이름과 암호를 통한 사용자 인증</li><li>소셜 네트워크를 통한 사용자 인증</li><li>사용자 암호 재설정</li><li>사용자 차단</li></ul>',
  'user-data-base.settings.user-storage.custom.login_url.label': '사용자 확인 URL',
  'user-data-base.settings.user-storage.custom.login_url.link': '사용자 인증 요청 예시',
  'user-data-base.settings.user-storage.custom.registration_url.label': '신규 사용자 URL',
  'user-data-base.settings.user-storage.custom.registration_url.link': '새 사용자 요청 예시',
  'user-data-base.settings.user-storage.custom.password_reset_url.label': '암호 재설정 URL',
  'user-data-base.settings.user-storage.custom.password_reset_url.link': '암호 재설정 요청 예시',
  'user-data-base.settings.user-storage.custom.email_change_url.label': '이메일 변경 URL',
  'user-data-base.settings.user-storage.custom.email_change_url.link': '이메일 변경 요청 예시',
  'user-data-base.settings.user-storage.custom.passwordless_registration_url.label': '암호 없는 로그인 URL',
  'user-data-base.settings.user-storage.custom.passwordless_registration_url.link': '암호 없는 로그인 요청 예시',
  'user-data-base.settings.user-storage.custom.social_url.label': '소셜 로그인 URL',
  'user-data-base.settings.user-storage.custom.social_url.link': '소셜 로그인 요청 예시',
  'user-data-base.settings.user-storage.custom.refresh_token_url.label': '토큰 새로 고침 URL',
  'user-data-base.settings.user-storage.custom.refresh_token_url.link': '토큰 갱신 요청 예시',
  'user-data-base.settings.user-storage.custom.add_social_access_token.label': '소셜 네트워크가 토큰에 접근하도록 허용',
  'user-data-base.settings.user-storage.custom.add_user_account_linking.label': '사용자 계정 연결 활성화',
  'user-data-base.settings.user-storage.custom.add_user_account_linking.description': '이 옵션을 활성화하면 동일한 server_custom_id를 공유하는 모든 계정을 단일 사용자로 처리할 수 있습니다.',
  'user-data-base.settings.user-storage.playfab.label': 'PlayFab',
  'user-data-base.settings.user-storage.playfab.description': '사용자 데이터가 엑솔라 측에 저장되지만 암호는 PlayFab을 통해 확인됩니다.',
  'user-data-base.settings.user-storage.playfab.notification.title': 'PlayFab으로 가능한 작업:',
  'user-data-base.settings.user-storage.playfab.notification.description': '<ul><li>사용자 등록</li><li>이메일 주소와 암호를 통한 사용자 인증</li><li>Twitch를 통한 사용자 인증</li><li>사용자 암호 재설정</li><li>사용자 차단</li></ul>',
  'user-data-base.settings.user-storage.playfab.title-id.notification': '타이틀 ID 필드에 PlayFab 계정과 동일한 필드 값을 입력합니다.',
  'user-data-base.settings.user-storage.playfab.playfab_title_id.label': '타이틀 ID',
  'user-data-base.settings.user-storage.playfab.playfab_title_id.link': '타이틀 ID를 받는 방법',
  'user-data-base.settings.user-storage.firebase.label': 'Firebase',
  'user-data-base.settings.user-storage.firebase.description': '사용자 데이터는 JSON 형식으로 저장되며 연결된 모든 클라이언트와 실시간으로 업데이트됩니다.',
  'user-data-base.settings.user-storage.firebase.notification': '타이틀 ID 필드에 PlayFab 계정과 동일한 필드 값을 입력합니다.',
  'user-data-base.settings.user-storage.firebase.firebase_apikey.label': 'API 키',
  'user-data-base.settings.user-storage.firebase.firebase_apikey.link': 'API 키를 찾는 방법',

  'user-data-base.settings.supplementary-info.main.title': '추가 사용자 정보',
  'user-data-base.settings.supplementary-info.main.subtitle': '추가 양식을 사용하여 사용자로부터 필요한 정보를 수집합니다. 사용자가 등록한 후에 이 양식을 작성할 수 있습니다.',
  'user-data-base.settings.supplementary-info.main.notification': '기본 필드를 사용하거나 사용자 정의 필드를 추가하여 데이터를 수집할 수 있습니다. 이 데이터는 사용자 데이터베이스의 사용자 프로필에 저장됩니다. 별표 아이콘을 클릭하여 필드를 필수 항목으로 설정할 수 있습니다.',
  'user-data-base.settings.supplementary-info.fields-additional': '추가 사용자 정보 입력란',
  'user-data-base.settings.supplementary-info.field.email': '이메일',
  'user-data-base.settings.supplementary-info.field.username': '사용자 이름',
  'user-data-base.settings.supplementary-info.field.password': '암호',
  'user-data-base.settings.supplementary-info.field.given-name': '이름',
  'user-data-base.settings.supplementary-info.field.family-name': '성',
  'user-data-base.settings.supplementary-info.field.bday': '생년월일',
  'user-data-base.settings.supplementary-info.field.gender': '성별',
  'user-data-base.settings.supplementary-info.field.country-name': '국가',
  'user-data-base.settings.supplementary-info.field.phone_number': '전화 번호',
  'user-data-base.settings.supplementary-info.field.promo_email_agreement': '뉴스레터',
  'user-data-base.settings.supplementary-info.field.additional_agreement': '추가 동의',
  'user-data-base.settings.supplementary-info.field.standart-field': '기본 필드의 이름과 유형은 변경할 수 없습니다.',
  'user-data-base.settings.supplementary-info.field.required': '입력란을 필수 항목으로 설정하려면 별 아이콘을 클릭하세요.',
  'user-data-base.settings.supplementary-info.field-type.str': '짧은 텍스트 답변',
  'user-data-base.settings.supplementary-info.field-type.pass': '암호',
  'user-data-base.settings.supplementary-info.field-type.date': '날짜 선택기',
  'user-data-base.settings.supplementary-info.field-type.bool': '선택란',
  'user-data-base.settings.supplementary-info.field-type.email': '이메일',
  'user-data-base.settings.supplementary-info.field-type.select': '선택',
  'user-data-base.settings.supplementary-info.field-type.phone': '전화 번호',
  'user-data-base.settings.supplementary-info.default-language.notification': '올바르게 현지화할 수 있도록 사용자 정의 필드 이름을 영어로 입력하세요.',
  'user-data-base.settings.supplementary-info.age-restrict': '나이 제한 기능이 필요하신가요? <a>나이 제한 설정으로 이동하세요.</a>',

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=7945%3A99727 */
  'user-data-base.settings.tabs.user-attributes': '사용자 특성 스키마',
  'user-data-base.settings.attributes.title': '사용자 특성 스키마',
  'user-data-base.settings.attributes.subtitle': '사용자 특성은 데이터 액세스를 관리하고 각 사용자에게 맞춤형 경험을 제공하는 데 사용할 수 있는 사용자의 메타데이터입니다.<br></br>JSON 스키마를 추가하여 특성 구성 프로세스를 개선하세요.',
  'user-data-base.settings.attributes.notification': 'JSON 스키마를 사용하면 다음을 수행할 수 있습니다.<ul><li>기존 데이터 형식을 설명합니다.</li><li>사람과 기계가 읽을 수 있는 문서를 갖습니다.</li><li>자동화된 테스트 및 클라이언트가 제출한 데이터의 품질 보증을 위해 데이터를 검증합니다.</li></ul>',
  'user-data-base.settings.attributes.notification-link': '추가 정보가 필요한 경우 <a>JSON 스키마 사양을 참조</a>하세요.',
  'user-data-base.settings.attributes.field.title': '사용자 특성 사양',
  'user-data-base.settings.attributes.error.title': '잘못된 스키마',
  'user-data-base.settings.attributes.error.default': 'JSON 스키마가 잘못되었거나 정의된 속성의 중첩 수준이 1보다 높습니다.',
  'user-data-base.settings.attributes.error.characters': "JSON 스키마에 잘못된 문자 \'{characters}\'가 하나 이상 포함되어 있습니다.",
  'user-data-base.settings.attributes.error.type': "\'{name}\' 속성은 문자열, 숫자, 정수, 부울 유형 중 하나여야 합니다.",
  'user-data-base.settings.attributes.error.properties-required': "속성 필드는 필수입니다.",

  // https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=5898%3A102126
  'mfa.settings.title': '다단계 인증 정책',
  'mfa.settings.subtitle': '무단 액세스를 방지하기 위해 다단계 인증을 사용하여 사용자가 로그인 프로세스 중에 추가 단계를 완료하도록 할 수 있습니다.',
  'mfa.settings.usage.title': '다단계 인증 사용',
  'mfa.settings.usage.subtitle': '다단계 인증을 적용하는 시기를 선택하세요.',
  'mfa.settings.never.title': '사용 안 함',
  'mfa.settings.never.description': '사용자가 로그인할 때 추가 단계를 완료하지 않습니다.',
  'mfa.settings.adaptive.title': '적응형 다단계 인증 사용',
  'mfa.settings.adaptive.description': '위험한 로그인 시도로 간주되는 경우 사용자는 추가 단계를 완료해야 합니다.',
  'mfa.settings.always.title': '항상',
  'mfa.settings.always.description': '로그인하려면 사용자가 항상 추가 단계를 완료해야 합니다.',
  'mfa.settings.risk.title': '다중 요소 인증 활성화',
  'mfa.settings.risk.description': '이 옵션을 켜면 모든 사용자가 이메일을 통해 MFA로 로그인하도록 강제됩니다.',
  'mfa.settings.url.title': '다중 요소 인증 URL',
  'mfa.settings.url.description': '사용자는 이 URL로 리디렉션되어 다중 요소 인증 프로세스를 완료합니다.',

  // https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=3944%3A84284
  'settings.signature.title': 'JWT 서명',
  'settings.signature.subtitle': 'JWT 서명에 사용할 암호화 방법을 아래에서 선택하세요.',
  'settings.signature.notification': '기본적으로 비밀 키는 숨겨져 있으며, 비밀 키를 사용할 경우 민감한 정보에 액세스할 수 있으므로 기밀로 유지해야 합니다.',
  'settings.signature.copy': '복사 키',
  'settings.signature.hmac.label': '비밀 키',
  'settings.signature.hmac.new.label': '새 비밀 키',
  'settings.signature.rsa.label': '공개 JSON 웹 키',
  'settings.signature.rsa.new.label': '새 공개 JSON 웹 키',
  'settings.signature.hmac.switch.title': 'HS256(HMAC, SHA-256 포함)',
  'settings.signature.hmac.switch.caption': 'HS256은 단일 비밀 키를 사용하여 JWT에 서명하고 유효성을 검사합니다. JWT 유효성 검사를 위해 비밀 키는 사용자 측에 저장해야 합니다.',
  'settings.signature.rsa.switch.title': 'RS256(RSA Signature, SHA-256 포함)',
  'settings.signature.rsa.switch.caption': 'RS256은 JWT에 서명하는 데 사용하는 비밀 키와 JWT의 유효성을 검사하는 데 사용하는 공개 키가 있는 비대칭형 알고리즘입니다.',
  'settings.signature.reset.title': '새 키를 적용하시겠습니까?',
  'settings.signature.reset.hmac.title': '비밀 키 초기화',
  'settings.signature.reset.rsa.title': 'JSON 웹 키 초기화',
  'settings.signature.reset.hmac.description': '새 키를 적용하면 현재 비밀 키를 복구할 수 없습니다.',
  'settings.signature.reset.rsa.description': '새 키를 적용한 후에는 현재 공개 JSON 웹 키를 복구할 수 없습니다.',
  'settings.signature.reset.description': '모든 애플리케이션이 새 키로 업데이트되었는지 확인하세요.<br></br>모든 새 JWT는 새 키로 서명됩니다.',
  'settings.signature.reset.checkbox': '이해합니다',
  'settings.signature.reset.submit': '예, 적용합니다.',
  'settings.signature.token-lifetime.title': '토큰 라이프타임',
  'settings.signature.token-lifetime.description': '토큰은 수명이 끝나면 만료됩니다.<br></br>기본 수명은 1일(86400초)입니다.',
  'settings.signature.token-lifetime.description-oauth': 'OAuth 2.0 토큰은 수명이 끝나면 만료됩니다.<br></br>기본 수명은 1시간(3600초)입니다.',
  'settings.signature.token-lifetime.seconds': '초',
  'settings.signature.notification.title': '새 키가 생성되었습니다.',
  'settings.signature.notification.caption': '새 키를 복사하여 모든 종속 애플리케이션에 적용합니다. 모든 대상을 업데이트한 후 \"변경 사항 저장\"을 클릭하세요.',
  'settings.signature.long-token-checkbox': '토큰의 수명이 5일을 초과합니다. 확인하려면 체크박스를 클릭하세요.',

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=5647%3A93743 */
  'sms-customization.settings.title': 'SMS 사용자 지정',
  'sms-customization.settings.subtitle': '사용자에게 보내는 코드로 SMS 메시지를 사용자 정의합니다.',
  'sms-customization.settings.main.notification': 'SMS 메시지에 자체 내용을 추가할 경우 필수 언어를 사용해야 합니다. 그렇지 않으면 사용자는 표준 엑솔라 확인 메시지를 받게 됩니다.<p>Liquid Syntax를 통해 메시지를 사용자 정의하는 방법을 알아보세요.</p>',
  'sms-customization.settings.input.title': '등록 및 로그인 메시지',
  'sms-customization.settings.phone_auth_code.title': '등록 및 로그인 메시지',
  'sms-customization.settings.phone_auth_code.description': '이 메시지는 사용자가 로그인하거나 등록할 때마다 전송됩니다.',
  'sms-customization.settings.phone_auth_code.placeholder': '예시: {{code}}는 {{Game}}에 대한 확인 코드입니다. {{link}}를 사용하여 로그인할 수도 있습니다.',
  'sms-customization.settings.phone_auth_code.post-description': '{{code}}, {{Game}}, {{link}} 태그는 자동으로 실제 값으로 교체됩니다. 이 필드에 실제 코드, 링크 또는 이름을 입력하지 마세요.',
  'sms-customization.settings.mfa_code.title': '다단계 인증 메시지',
  'sms-customization.settings.mfa_code.description': '이 메시지는 사용자가 새 장치에 로그인할 때마다 전송됩니다. <a>MFA 방식을 설정합니다.</a>',
  'sms-customization.settings.mfa_code.placeholder': '예시: {{code}}는 {{Game}}에 대한 확인 코드입니다.',
  'sms-customization.settings.mfa_code.post-description': '{{code}}와 {{Game}} 태그는 자동으로 실제 값으로 교체됩니다. 이 필드에 실제 코드 또는 이름을 입력하지 마세요.',
  'sms-customization.settings.limit-symbol.error': 'SMS 메시지는 {number}자 미만이어야 합니다.',
  'sms-customization.settings.not-code.error': '템플릿에는 코드용 태그가 포함되어야 합니다.',

  /* Custom scopes https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=3724%3A81985 */
  'social-connection.settings.user-data.profile': '프로필',
  'social-connection.settings.user-data.public-profile': '공개 프로필',
  'social-connection.settings.user-data.other-profile': '모든 사용자의 프로필',
  'social-connection.settings.user-data.id': '사용자 ID',
  'social-connection.settings.user-data.email': '사용자 이메일 주소',
  'social-connection.settings.user-data.phone': '전화 번호',
  'social-connection.settings.user-data.image': '프로필 이미지',
  'social-connection.settings.user-data.name': '이름',
  'social-connection.settings.user-data.nickname': '별명',
  'social-connection.settings.user-data.age-range': '연령대',
  'social-connection.settings.user-data.birthday': '생일',
  'social-connection.settings.user-data.birthyear': '출생 년도',
  'social-connection.settings.user-data.location': '위치',
  'social-connection.settings.user-data.gender': '성별',
  'social-connection.settings.user-data.hometown': '출생지',
  'social-connection.settings.user-data.address': '주소',
  'social-connection.settings.user-data.likes': '좋아요',
  'social-connection.settings.user-data.link': '프로필 URL',
  'social-connection.settings.user-data.postal-code': '우편 번호',
  'social-connection.settings.user-data.connections': '소셜 연결',
  'social-connection.settings.user-data.profile-instagram': 'Instagram 프로필',
  'social-connection.settings.user-data.openid': 'OpenID 사용자 세부 정보',
  'social-connection.settings.user-data.guilds': '사용자의 길드 프로필',
  'social-connection.settings.user-data.long-token': '긴 만료 시간을 가진 토큰',
  'social-connection.settings.user-data.profile-d3': '디아블로 III 프로필',
  'social-connection.settings.user-data.profile-sc2': '스타크래프트 II 프로필',
  'social-connection.settings.user-data.profile-wow': '월드 오브 워크래프트 캐릭터',
  'social-connection.settings.user-data.offline': '오프라인 액세스',

  'social-connection.settings.permission.all': '모든 Scope 요청',
  'social-connection.settings.permission.user': '사용자 프로필 읽기/업데이트',
  'social-connection.settings.permission.user-subscriptions:read': '사용자의 정기 결제 읽기',
  'social-connection.settings.permission.user-block:read': '차단 목록 보기',
  'social-connection.settings.permission.user-block:write': '차단 목록 관리',
  'social-connection.settings.permission.messenger-contact': '메신저로 문의하기',
  'social-connection.settings.permission.photos': '사진',
  'social-connection.settings.permission.posts': '게시물',
  'social-connection.settings.permission.videos': '동영상',
  'social-connection.settings.permission.groups': '그룹',
  'social-connection.settings.permission.groups:read': '그룹 정보 읽기',
  'social-connection.settings.permission.groups:write': '그룹 콘텐츠 관리',
  'social-connection.settings.permission.groups:stats': '그룹 통계에 대한 액세스 권한',
  'social-connection.settings.permission.friends': '친구',
  'social-connection.settings.permission.plusfriends': '친구',
  'social-connection.settings.permission.stories': '스토리에 대한 액세스 권한',
  'social-connection.settings.permission.status': '사용자 상태에 대한 액세스 권한',
  'social-connection.settings.permission.notes': '사용자 메모에 대한 액세스 권한',
  'social-connection.settings.permission.wall': '프로필 피드 기술에 대한 액세스 권한',
  'social-connection.settings.permission.offline': 'API에 대한 오프라인 액세스 권한',
  'social-connection.settings.permission.notify': '사용자에게 알림 보내기',
  'social-connection.settings.permission.market': '제품에 대한 액세스 권한',
  'social-connection.settings.permission.users': '모든 사용자의 전체 프로필 읽기/업데이트',
  'social-connection.settings.permission.users-follow:read': '사용자의 팔로우 목록 보기',
  'social-connection.settings.permission.users-follow:write': '다른 사용자 팔로우/팔로우 취소',
  'social-connection.settings.permission.users:invite': '조직에 게스트 사용자 초대',
  'social-connection.settings.permission.users:export': '사용자 데이터 내보내기',
  'social-connection.settings.permission.users:manage': '사용자 신원 관리',
  'social-connection.settings.permission.files': '사용자 파일에 대한 액세스 권한 받기',
  'social-connection.settings.permission.send-messages': '사용자에게 메시지 보내기',
  'social-connection.settings.permission.country': '국가',
  'social-connection.settings.permission.presence:read': '사용자의 현재 상태 정보 읽기',
  'social-connection.settings.permission.presence:write': '사용자의 현재 상태 정보 읽기 및 쓰기',
  'social-connection.settings.permission.activities:read': '사용자 활동 읽기',
  'social-connection.settings.permission.activities:write': '사용자 활동 업데이트',
  'social-connection.settings.permission.application:invite': '애플리케이션에 사용자 초대',
  'social-connection.settings.permission.applications-builds:read': '빌드 데이터 읽기',
  'social-connection.settings.permission.applications-builds:upload': '빌드 데이터 업로드',
  'social-connection.settings.permission.applications-commands': '명령 사용',
  'social-connection.settings.permission.applications-commands:update': '업데이트 명령',
  'social-connection.settings.permission.applications-entitlements': '권리 유형 읽기',
  'social-connection.settings.permission.applications-store:update': '스토어 데이터 읽기/업데이트',
  'social-connection.settings.permission.bot': '봇',
  'social-connection.settings.permission.gdm:join': '길드 가입',
  'social-connection.settings.permission.guilds:join': '길드에 사용자 가입',
  'social-connection.settings.permission.messages:read': '사용자의 메시지 읽기',
  'social-connection.settings.permission.messages:write': '사용자의 메시지 읽기/보내기',
  'social-connection.settings.permission.relationships:read': '사용자의 친구 가져오기',
  'social-connection.settings.permission.rpc': 'RPC 서버 액세스',
  'social-connection.settings.permission.rpc-activities:write': '사용자 활동 업데이트(RPC)',
  'social-connection.settings.permission.rpc-notifications:read': '알림 수신(RPC)',
  'social-connection.settings.permission.rpc-voice:read': '음성 설정 읽기',
  'social-connection.settings.permission.rpc-voice:write': '음성 설정 업데이트',
  'social-connection.settings.permission.webhook-incoming': '웹훅 생성',
  'social-connection.settings.permission.identify:premium': '프리미엄 확인(Nitro)',
  'social-connection.settings.permission.ads:read': '광고 읽기',
  'social-connection.settings.permission.ads:write': '광고 관리',
  'social-connection.settings.permission.ads-report:read': '광고 보고서 읽기',
  'social-connection.settings.permission.ads-leads:read': '광고 리드 보고서 읽기',
  'social-connection.settings.permission.ads-publishers:read': '게시자용 광고 읽기',
  'social-connection.settings.permission.attribution:read': '특성 API 읽기',
  'social-connection.settings.permission.business:write': '비즈니스 관리자 API 관리',
  'social-connection.settings.permission.catalog:write': '제품 카탈로그 관리',
  'social-connection.settings.permission.gaming-user_locale': '사용자의 로케일 가져오기',
  'social-connection.settings.permission.instagram:publish': 'Instagram 사진 게시하기',
  'social-connection.settings.permission.instagram-comments:write': 'Instagram 댓글 관리',
  'social-connection.settings.permission.instagram-insights:write': 'Instagram 인사이트 읽기',
  'social-connection.settings.permission.leads:read': '리드 광고 읽기',
  'social-connection.settings.permission.pages-events': 'Facebook 페이지 관리',
  'social-connection.settings.permission.ads-pages:write': 'Facebook 페이지 광고 관리',
  'social-connection.settings.permission.cta:write': 'CTA 작업 관리',
  'social-connection.settings.permission.pages-articles:write': '인스턴트 기사 관리',
  'social-connection.settings.permission.pages-engagement:write': '페이지 댓글 관리',
  'social-connection.settings.permission.pages-metadata:write': '페이지 웹훅 수신',
  'social-connection.settings.permission.pages-posts:write': '게시물 관리',
  'social-connection.settings.permission.pages-messaging': '페이지 메시지 관리',
  'social-connection.settings.permission.pages-engagement:read': '페이지 콘텐츠 읽기',
  'social-connection.settings.permission.pages-content:read': '페이지 댓글 읽기',
  'social-connection.settings.permission.pages-list': '사용자 페이지 읽기',
  'social-connection.settings.permission.pages-gender': '사용자의 페이지 성별 읽기',
  'social-connection.settings.permission.pages-locale': '사용자의 페이지 로케일 읽기',
  'social-connection.settings.permission.pages-timezone': '사용자의 페이지 시간대 읽기',
  'social-connection.settings.permission.social-user:write': '사용자를 통해 게시물 관리',
  'social-connection.settings.permission.social-org:read': '조직 게시물 보기',
  'social-connection.settings.permission.social-org:write': '조직을 통해 게시물 관리',
  'social-connection.settings.permission.video:write': '동영상 게시',
  'social-connection.settings.permission.insights:read': '페이지 인사이트 데이터 읽기',
  'social-connection.settings.permission.research-apis': '리서치 API에 대한 액세스 권한',
  'social-connection.settings.permission.repo': '리포지토리에 대한 전체 액세스 권한',
  'social-connection.settings.permission.repo:status': '커밋 상태에 대한 읽기/쓰기 액세스 권한',
  'social-connection.settings.permission.repo_deployment': '액세스 배포 상태',
  'social-connection.settings.permission.public_repo': '공개 리포지토리에 대한 액세스 권한',
  'social-connection.settings.permission.repo:invite': '초대 수락/거절',
  'social-connection.settings.permission.security_events': '보안 이벤트에 대한 읽기/쓰기 액세스 권한',
  'social-connection.settings.permission.admin:repo_hook': '리포지토리 후크에 대한 관리자 액세스 권한',
  'social-connection.settings.permission.write:repo_hook': '리포지토리 후크에 대한 쓰기 액세스 권한',
  'social-connection.settings.permission.read:repo_hook': '리포지토리 후크에 대한 읽기 액세스 권한',
  'social-connection.settings.permission.admin:org': '조직에 대한 관리자 액세스 권한',
  'social-connection.settings.permission.write:org': '조직에 대한 쓰기 액세스 권한',
  'social-connection.settings.permission.read:org': '조직에 대한 읽기 액세스 권한',
  'social-connection.settings.permission.admin:public_key': '공개 키에 대한 관리자 액세스 권한',
  'social-connection.settings.permission.write:public_key': '공개 키에 대한 쓰기 액세스 권한',
  'social-connection.settings.permission.read:public_key': '공개 키에 대한 읽기 액세스 권한',
  'social-connection.settings.permission.admin:org_hook': '조직 후크에 대한 관리자 액세스 권한',
  'social-connection.settings.permission.gist': 'Gists에 대한 쓰기 액세스 권한',
  'social-connection.settings.permission.notifications': '사용자 알림에 대한 액세스 권한',
  'social-connection.settings.permission.delete_repo': '리포지토리 삭제',
  'social-connection.settings.permission.write:discussion': '팀 토론에 대한 쓰기 액세스 권한',
  'social-connection.settings.permission.read:discussion': '팀 토론에 대한 읽기 액세스 권한',
  'social-connection.settings.permission.write:packages': '패키지 게시에 대한 액세스 권한',
  'social-connection.settings.permission.read:packages': '패키지 다운로드에 대한 액세스 권한',
  'social-connection.settings.permission.delete:packages': '패키지 삭제에 대한 액세스 권한',
  'social-connection.settings.permission.admin:gpg_key': 'GPG 키에 대한 관리자 액세스 권한',
  'social-connection.settings.permission.write:gpg_key': 'GPG 키에 대한 쓰기 액세스 권한',
  'social-connection.settings.permission.read:gpg_key': 'GPG 키에 대한 읽기 액세스 권한',
  'social-connection.settings.permission.codespace': '작업 영역 생성 및 관리',
  'social-connection.settings.permission.workflow': 'GitHub 작업 워크플로 파일 업데이트',
  'social-connection.settings.permission.cloud-platform': '클라우드 플랫폼',
  'social-connection.settings.permission.adsense': 'AdSense',
  'social-connection.settings.permission.analytics': '애널리틱스',
  'social-connection.settings.permission.analytics-extensions': 'Twitch 확장 프로그램용 애널리틱스',
  'social-connection.settings.permission.analytics-games': '게임용 애널리틱스',
  'social-connection.settings.permission.appengine:admin': 'App Engine',
  'social-connection.settings.permission.mail:read': '사용자 메일 읽기',
  'social-connection.settings.permission.mail:write': '사용자 메일에 대한 읽기 및 쓰기 액세스 권한',
  'social-connection.settings.permission.mail:send': '사용자로 메일 보내기',
  'social-connection.settings.permission.bigquery': 'BigQuery',
  'social-connection.settings.permission.blogger': 'Blogger',
  'social-connection.settings.permission.books': 'Books',
  'social-connection.settings.permission.calendar:read': '캘린더 읽기',
  'social-connection.settings.permission.calendar:write': '캘린더 관리',
  'social-connection.settings.permission.ddmconversions': 'DoubleClick Digital Marketing',
  'social-connection.settings.permission.bigtable': 'Cloud Bigtable',
  'social-connection.settings.permission.content': 'Shopping',
  'social-connection.settings.permission.display-video': 'Display & Video 360',
  'social-connection.settings.permission.doubleclickbidmanager': 'DoubleClick 입찰 관리자',
  'social-connection.settings.permission.files:read': '사용자 파일 읽기',
  'social-connection.settings.permission.files:write': '사용자 파일에 대한 전체 액세스 권한 보유',
  'social-connection.settings.permission.firebase': 'Firebase',
  'social-connection.settings.permission.fitness': 'Fitness',
  'social-connection.settings.permission.ediscovery': 'G Suite Vault',
  'social-connection.settings.permission.classroom': 'Classroom',
  'social-connection.settings.permission.documents': 'Docs',
  'social-connection.settings.permission.androidpublisher': 'Google Play',
  'social-connection.settings.permission.games': 'Google Play 게임 활동',
  'social-connection.settings.permission.webmasters': 'Search Console',
  'social-connection.settings.permission.presentations': 'Slides',
  'social-connection.settings.permission.spreadsheets': 'Sheets',
  'social-connection.settings.permission.manufacturercenter': 'Manufacturer Center',
  'social-connection.settings.permission.contacts:read': '사용자 연락처 읽기',
  'social-connection.settings.permission.contacts:write': '사용자 연락처 관리',
  'social-connection.settings.permission.photoslibrary': '사진 라이브러리',
  'social-connection.settings.permission.tagmanager': '태그 관리자',
  'social-connection.settings.permission.tasks': '작업',
  'social-connection.settings.permission.youtube': 'YouTube',
  'social-connection.settings.permission.story:read': '카카오스토리 게시물 읽기',
  'social-connection.settings.permission.story:publish': '카카오스토리에 게시',
  'social-connection.settings.permission.talk:message': '카카오톡',
  'social-connection.settings.permission.connections-1st:view': '1촌 연결 보기',
  'social-connection.settings.permission.audience:write': '일치하는 대상 Audiences 관리',
  'social-connection.settings.permission.guestbook': '방명록 쓰기',
  'social-connection.settings.permission.apps:read': '모든 앱 카탈로그 읽기',
  'social-connection.settings.permission.apps:write': '모든 앱 카탈로그 읽기 및 쓰기',
  'social-connection.settings.permission.logs:read': '감사 로그 데이터 읽기',
  'social-connection.settings.permission.bookings:read': '예약 일정 읽기',
  'social-connection.settings.permission.bookings:write': '예약 일정 관리',
  'social-connection.settings.permission.call': '발신 1:1 통화 시작',
  'social-connection.settings.permission.call-group': '발신 그룹 통화 시작',
  'social-connection.settings.permission.device:read': '사용자 장치 읽기',
  'social-connection.settings.permission.notes:read': '사용자 OneNote 전자 필기장 읽기',
  'social-connection.settings.permission.notes:write': '사용자 OneNote 전자 필기장 읽기 및 쓰기',
  'social-connection.settings.permission.tasks:read': '사용자의 작업 및 작업 목록 읽기',
  'social-connection.settings.permission.tasks:write': '사용자 작업 생성 및 업데이트',
  'social-connection.settings.permission.credits': '골드 크레딧 사용',
  'social-connection.settings.permission.flair': '사용자 Flair 관리',
  'social-connection.settings.permission.votes:read': '투표 내역 읽기',
  'social-connection.settings.permission.live-threads:read': '라이브 스레드 관리',
  'social-connection.settings.permission.modconfig': '하위 레딧 구성 조정',
  'social-connection.settings.permission.modcontributors': '사용자 승인 및 차단',
  'social-connection.settings.permission.modflair': 'Flair 조정',
  'social-connection.settings.permission.modlog': '조정 로그',
  'social-connection.settings.permission.modmail': '새 Modmail',
  'social-connection.settings.permission.modothers': '다른 중재자 초대 또는 제거',
  'social-connection.settings.permission.modposts': '게시물 검토',
  'social-connection.settings.permission.modself': '중재자 상태 관리',
  'social-connection.settings.permission.modwiki': 'Wiki 조정',
  'social-connection.settings.permission.mysubreddits': '내 하위 레딧',
  'social-connection.settings.permission.report': '콘텐츠 보고',
  'social-connection.settings.permission.save': '콘텐츠 저장',
  'social-connection.settings.permission.structuredstyles': '구조화 스타일 편집',
  'social-connection.settings.permission.submit': '콘텐츠 제출',
  'social-connection.settings.permission.subscribe': '내 정기 결제 편집',
  'social-connection.settings.permission.vote': '투표',
  'social-connection.settings.permission.wiki:edit': 'Wiki 편집',
  'social-connection.settings.permission.wiki:read': 'Wiki 페이지 읽기',
  'social-connection.settings.permission.bits:read': 'Bits 정보 보기',
  'social-connection.settings.permission.channel:edit:commercial': '채널에서 광고 실행',
  'social-connection.settings.permission.channel:manage:broadcast': '채널의 브로드캐스트 구성 관리',
  'social-connection.settings.permission.channel:manage:extensions': '채널의 확장 구성 관리',
  'social-connection.settings.permission.channel:manage:polls': '채널의 투표 관리',
  'social-connection.settings.permission.channel:manage:predictions': '채널의 채널 포인트 예측 관리',
  'social-connection.settings.permission.channel:manage:redemptions': '채널 포인트 맞춤 보상 관리',
  'social-connection.settings.permission.channel:manage:schedule': '채널의 스트림 일정 관리',
  'social-connection.settings.permission.channel:manage:videos': '채널의 동영상 관리',
  'social-connection.settings.permission.channel:read:editors': '편집자 역할이 있는 사용자 보기',
  'social-connection.settings.permission.channel:read:goals': '채널의 크리에이터 목표 보기',
  'social-connection.settings.permission.channel:read:hype_train': '채널의 Hype Train 정보 보기',
  'social-connection.settings.permission.channel:read:polls': '채널의 설문조사 보기',
  'social-connection.settings.permission.channel:read:predictions': '채널의 채널 포인트 예측 보기',
  'social-connection.settings.permission.channel:read:redemptions': '채널 포인트 맞춤 보상 보기',
  'social-connection.settings.permission.channel:read:stream_key': '승인된 사용자의 스트림 키 보기',
  'social-connection.settings.permission.channel:read:subscriptions': '모든 구독자 목록 보기',
  'social-connection.settings.permission.clips:edit': '채널의 클립 관리',
  'social-connection.settings.permission.moderation:read': '채널의 조정 데이터 보기',
  'social-connection.settings.permission.moderator:manage:banned_users': '사용자 차단 및 차단 해제',
  'social-connection.settings.permission.moderator:read:blocked_terms': '브로드캐스터의 차단된 용어 목록 보기',
  'social-connection.settings.permission.moderator:manage:blocked_terms': '브로드캐스터의 차단된 용어 목록 관리',
  'social-connection.settings.permission.moderator:manage:automod': 'AutoMod에서 메시지 관리',
  'social-connection.settings.permission.moderator:read:automod_settings': '브로드캐스터의 AutoMod 설정 보기',
  'social-connection.settings.permission.moderator:manage:automod_settings': '브로드캐스터의 AutoMod 설정 관리',
  'social-connection.settings.permission.moderator:read:chat_settings': '브로드캐스터의 채팅방 설정 보기',
  'social-connection.settings.permission.moderator:manage:chat_settings': '브로드캐스터의 채팅방 설정 관리',
  'social-connection.settings.permission.promo-codes:vimeo': 'Vimeo 프로모션',
  'social-connection.settings.permission.upload:vimeo': '동영상 업로드',
  'social-connection.settings.permission.interact:vimeo': 'Vimeo 리소스와 상호 작용',
  'social-connection.settings.permission.delete:vimeo': '기존 Vimeo 리소스 삭제',
  'social-connection.settings.permission.edit:vimeo': '기존 Vimeo 리소스 편집',
  'social-connection.settings.permission.create:vimeo': '새 Vimeo 리소스 만들기',
  'social-connection.settings.permission.purchased:vimeo': '구매 내역에 대한 액세스 권한',
  'social-connection.settings.permission.audio': '오디오 녹음에 대한 액세스 권한',
  'social-connection.settings.permission.fantasy-sport:read': 'Fantasy Sports 읽기',
  'social-connection.settings.permission.fantasy-sport:write': 'Fantasy Sports 읽기/쓰기',
  'social-connection.settings.permission.finance:read': 'Finance 읽기',
  'social-connection.settings.permission.finance:write': 'Finance 읽기/쓰기',

  'social-connection.settings.user-data.amazon.profile.help': '프로필 Scope에는 사용자 이름, 사용자 ID 및 이메일 주소가 포함됩니다.',
  'social-connection.settings.user-data.amazon.id.help': '사용자 ID Scope는 프로필의 user_id 필드만 포함합니다. 이것은 사용자를 고유하게 식별하지만 이름, 이메일 주소 또는 우편번호를 제공하지 않습니다.',
  'social-connection.settings.user-data.amazon.postal-code.help': '우편번호 Scope에는 기본 배송 주소에서 가져온 사용자의 우편번호를 포함합니다.',
  'social-connection.settings.user-data.apple.name.help': '사용자의 전체 이름입니다.',
  'social-connection.settings.user-data.apple.email.help': '사용자의 이메일.',
  'social-connection.settings.user-data.baidu.profile.help': '기본 사용자 권한, 기본 사용자 정보를 얻을 수 있습니다.',
  'social-connection.settings.user-data.battlenet.openid.help': 'OpenID Connect(OIDC)를 사용하여 현재 로그인한 사용자의 액세스 세부 정보.',
  'social-connection.settings.user-data.battlenet.profile-d3.help': '사용자의 디아블로 III 프로필에 엑세스합니다.',
  'social-connection.settings.user-data.battlenet.profile-sc2.help': '사용자의 스타크래프트 II 프로필에 액세스합니다.',
  'social-connection.settings.user-data.battlenet.profile-wow.help': '사용자의 월드 오브 워크래프트 캐릭터에 액세스합니다.',
  'social-connection.settings.user-data.discord.profile.help': '이메일 없이 /users/@me를 허용합니다.',
  'social-connection.settings.user-data.discord.email.help': '/users/@me가 이메일을 반환할 수 있도록 합니다.',
  'social-connection.settings.user-data.discord.connections.help': '/users/@me/connections가 연결된 타사 계정을 반환하도록 허용합니다.',
  'social-connection.settings.user-data.discord.guilds.help': '/users/@me/guilds가 사용자의 모든 길드에 대한 기본 정보를 반환하도록 허용합니다.',
  'social-connection.settings.user-data.epicgames.profile.help': '사용자 표시 이름, 언어 기본 설정 및 연결된 계정 표시 이름에 대한 읽기 액세스를 허용합니다.',
  'social-connection.settings.user-data.facebook.profile.help': '앱이 사용자 노드의 기본 공개 프로필 필드를 읽을 수 있도록 허용합니다. 이 권한은 모든 앱에 자동으로 부여됩니다.',
  'social-connection.settings.user-data.facebook.email.help': '이메일 권한은 앱이 개인의 기본 이메일 주소를 읽을 수 있도록 허용합니다.',
  'social-connection.settings.user-data.facebook.age-range.help': 'user_age_range 권한은 앱이 Facebook 프로필에 나열된 사람들의 연령대에 액세스할 수 있도록 허용합니다.',
  'social-connection.settings.user-data.facebook.birthday.help': 'user_birthday 권한은 앱이 Facebook 프로필에 나열된 사람들의 생일 정보를 읽을 수 있도록 허용합니다.',
  'social-connection.settings.user-data.facebook.gender.help': 'user_gender 권한은 있으면 앱이 Facebook 프로필에 나열된 사람들의 성별을 읽을 수 있도록 허용합니다.',
  'social-connection.settings.user-data.facebook.hometown.help': 'user_hometown 권한은 앱이 Facebook 프로필에서 사람들의 출생지 위치를 읽을 수 있도록 허용합니다.',
  'social-connection.settings.user-data.facebook.likes.help': 'user_likes 권한은 앱이 사용자가 좋아요를 누른 모든 Facebook 페이지 목록을 읽을 수 있도록 허용합니다.',
  'social-connection.settings.user-data.facebook.link.help': 'user_link 권한은 앱을 사용하는 사람들의 Facebook 프로필 URL에 액세스할 수 있도록 허용합니다.',
  'social-connection.settings.user-data.facebook.location.help': 'user_location 권한은 앱이 사람들의 Facebook 프로필의 위치 필드에 나열된 도시 이름을 읽을 수 있도록 허용합니다.',
  'social-connection.settings.user-data.facebook.profile-instagram.help': 'instagram_basic 권한은 앱이 Instagram 계정 프로필의 정보와 미디어를 읽을 수 있도록 허용합니다.',
  'social-connection.settings.user-data.github.public-profile.help': '공개 정보(사용자 프로필 정보, 리포지토리 정보 및 gists 포함)에 대한 읽기 전용 액세스 권한을 부여합니다.',
  'social-connection.settings.user-data.github.profile.help': '사용자의 프로필 데이터를 읽을 수 있는 액세스 권한을 부여합니다.',
  'social-connection.settings.user-data.github.email.help': '사용자의 이메일 주소에 대한 읽기 액세스 권한을 부여합니다.',
  'social-connection.settings.user-data.google.profile.help': '공개적으로 제공한 모든 개인 정보를 포함하여 개인 정보를 확인합니다.',
  'social-connection.settings.user-data.google.email.help': '이메일 주소를 봅니다.',
  'social-connection.settings.user-data.google.openid.help': '귀하를 Google의 개인 정보와 연결합니다.',
  'social-connection.settings.user-data.kakao.profile.help': '카카오 계정 프로필 정보.',
  'social-connection.settings.user-data.kakao.nickname.help': '카카오 계정 닉네임.',
  'social-connection.settings.user-data.kakao.image.help': '프로필 이미지 URL.',
  'social-connection.settings.user-data.kakao.email.help': '카카오 계정 대표 이메일입니다. 이메일은 사용자의 카카오 계정에서 수집되지 않을 수 있습니다. 이 경우 정보 수집 후 프로비전 옵션을 사용하거나 내부적으로 서비스 내에서 수집합니다. 사용자의 카카오 계정 이메일이 인증되지 않을 수 있습니다. 서비스에서 인증된 이메일만 사용해야 하는 경우 인증되지 않은 이메일이 없는 사용자에 대해 인증 프로세스를 진행합니다.',
  'social-connection.settings.user-data.kakao.name.help': '카카오 계정의 이름.',
  'social-connection.settings.user-data.kakao.gender.help': '카카오 계정의 성별.',
  'social-connection.settings.user-data.kakao.age-range.help': '한국 나이를 기준으로 한 카카오 계정의 연령대.',
  'social-connection.settings.user-data.kakao.birthday.help': '카카오 계정의 생일.',
  'social-connection.settings.user-data.kakao.birthyear.help': '카카오 계정의 탄생 연도.',
  'social-connection.settings.user-data.kakao.phone.help': '카카오계정 전화 번호.',
  'social-connection.settings.user-data.kakao.id.help': '암호화 사용자 식별 값입니다. ID는 동일한 사용자가 이미 멤버십 데이터베이스에 등록되어 있는지 확인하는 경우에만 사용할 수 있습니다.',
  'social-connection.settings.user-data.kakao.address.help': '카카오 계정 배송 정보.',
  'social-connection.settings.user-data.kakao.link.help': '카카오스토리 프로필 URL.',
  'social-connection.settings.user-data.linkedin.public-profile.help': '이름, 사진, 헤드라인, 공개 프로필 URL을 포함한 인증된 회원의 기본 프로필을 읽습니다.',
  'social-connection.settings.user-data.linkedin.profile.help': '인증된 회원의 이름, 헤드라인 및 사진을 검색합니다.',
  'social-connection.settings.user-data.linkedin.email.help': '인증된 회원의 기본 이메일 주소를 검색합니다.',
  'social-connection.settings.user-data.mailru.public-profile.help': '이름, 사진, 생일 및 기타 필드를 포함한 인증된 사용자의 기본 프로필을 읽습니다.',
  'social-connection.settings.user-data.microsoft.public-profile.help': '사용자가 앱에 로그인할 수 있도록 허용하고 앱이 로그인한 사용자의 프로필을 읽을 수 있도록 허용합니다. 또한 앱이 로그인한 사용자의 기본 회사 정보를 읽을 수 있도록 합니다.',
  'social-connection.settings.user-data.microsoft.other-profile.help': '앱이 로그인한 사용자를 대신하여 조직 내 다른 사용자의 기본 프로필 속성 설정을 읽을 수 있도록 허용합니다. 여기에는 표시 이름, 성명, 이메일 주소, 열기 확장 및 사진이 포함됩니다. 또한 앱이 로그인한 사용자의 전체 프로필을 읽을 수 있도록 허용합니다.',
  'social-connection.settings.user-data.microsoft.profile.help': '앱이 로그인한 사용자를 대신하여 조직 내 다른 사용자의 전체 프로필 속성, 보고서 및 관리자를 읽을 수 있도록 허용합니다.',
  'social-connection.settings.user-data.ok.profile.help': '대부분의 메소드를 호출하는 데 필요한 기본 권한입니다.',
  'social-connection.settings.user-data.ok.email.help': '사용자의 이메일 주소에 대한 액세스 권한.',
  'social-connection.settings.user-data.ok.long-token.help': 'OAuth 인증으로부터 긴 만료 시간 토큰을 가져오기.',
  'social-connection.settings.user-data.paypal.openid.help': '기본 인증.',
  'social-connection.settings.user-data.paypal.profile.help': '사용자의 전체 이름에 액세스.',
  'social-connection.settings.user-data.paypal.email.help': '사용자의 이메일 주소에 액세스.',
  'social-connection.settings.user-data.paypal.address.help': '사용자의 전체 주소에 액세스.',
  'social-connection.settings.user-data.paypal.id.help': 'PayPal 계정 ID(지불자 ID) 및 계정 확인 상태에 액세스.',
  'social-connection.settings.user-data.qq.profile.help': '로그인한 사용자의 닉네임, 아바타, 성별 가져오기.',
  'social-connection.settings.user-data.reddit.profile.help': '사용자의 reddit 사용자 이름과 가입 날짜에 액세스.',
  'social-connection.settings.user-data.twitch.email.help': '사용자의 이메일 주소 보기.',
  'social-connection.settings.user-data.vimeo.public-profile.help': '공개 회원 데이터에 액세스.',
  'social-connection.settings.user-data.vimeo.profile.help': '비공개 회원 데이터에 액세스합니다. public 이외의 모든 Scope에 필요합니다.',
  'social-connection.settings.user-data.vk.email.help': '사용자의 이메일에 액세스합니다.',
  'social-connection.settings.user-data.wechat.profile.help': '기본 로그인 Scope. 웹 애플리케이션은 현재 snsapi_login만 채웁니다.',
  'social-connection.settings.user-data.weibo.email.help': '사용자의 연락처 이메일.',
  'social-connection.settings.user-data.yahoo.profile.help': '프로필 정보.',
  'social-connection.settings.user-data.yahoo.email.help': '이메일 주소.',

  'social-connection.settings.permission.baidu.files.help': '개인 클라우드 저장소에 저장된 사용자 데이터를 가져옵니다.',
  'social-connection.settings.permission.baidu.send-messages.help': '사용자의 Baidu 홈페이지에 알림 메시지를 보냅니다.',
  'social-connection.settings.permission.discord.activities:read.help': '앱이 사용자의 \"지금 재생 중/최근 재생\" 목록에서 데이터를 가져올 수 있도록 허용합니다. Discord 승인이 필요합니다.',
  'social-connection.settings.permission.discord.activities:write.help': '앱이 사용자의 활동을 업데이트하도록 허용합니다. Discord 승인이 필요합니다(GAMESDK 활동 관리자의 경우 필요하지 않음).',
  'social-connection.settings.permission.discord.applications-builds:read.help': '앱이 사용자 애플리케이션의 빌드 데이터를 읽을 수 있도록 허용합니다.',
  'social-connection.settings.permission.discord.applications-builds:upload.help': '앱이 사용자 애플리케이션의 빌드를 업로드/업데이트하도록 허용합니다. Discord 승인이 필요합니다.',
  'social-connection.settings.permission.discord.applications-commands.help': '앱이 길드에서 명령을 사용하도록 허용합니다.',
  'social-connection.settings.permission.discord.applications-commands:update.help': '앱이 이 전달자 토큰을 통해 명령을 업데이트하도록 허용합니다. 클라이언트 자격 증명만 부여합니다.',
  'social-connection.settings.permission.discord.applications-entitlements.help': '앱이 사용자의 애플리케이션에 대한 권리 유형을 읽을 수 있도록 허용합니다.',
  'social-connection.settings.permission.discord.applications-store:update.help': '앱이 사용자 애플리케이션에 대한 스토어 데이터(SKU, 스토어 목록, 업적 등)를 읽고 업데이트하도록 허용합니다.',
  'social-connection.settings.permission.discord.bot.help': 'Oauth2 봇의 경우 기본적으로 사용자가 선택한 길드에 봇을 삽입합니다.',
  'social-connection.settings.permission.discord.gdm:join.help': '앱이 사용자를 그룹 DM에 가입하도록 허용합니다.',
  'social-connection.settings.permission.discord.guilds:join.help': '사용자를 길드에 가입시키는 데 /guilds/{guild.id}/members/{user.id}을(를) 사용하도록 허용합니다.',
  'social-connection.settings.permission.discord.messages:read.help': '로컬 rpc 서버 API 액세스의 경우 모든 클라이언트 채널의 메시지를 읽을 수 있도록 허용합니다(그렇지 않은 경우 앱이 생성하는 채널/길드로 제한됨).',
  'social-connection.settings.permission.discord.relationships:read.help': '앱이 사용자의 친구와 암시적인 관계를 알 수 있도록 허용합니다. Discord 승인이 필요합니다.',
  'social-connection.settings.permission.discord.rpc.help': '로컬 rpc 서버 액세스의 경우 사용자의 로컬 Discord 클라이언트를 제어할 수 있도록 허용합니다. Discord 승인이 필요합니다.',
  'social-connection.settings.permission.discord.rpc-activities:write.help': '로컬 rpc 서버 액세스의 경우 사용자의 활동을 업데이트할 수 있도록 허용합니다. Discord 승인이 필요합니다.',
  'social-connection.settings.permission.discord.rpc-notifications:read.help': '로컬 rpc 서버 액세스의 경우 사용자에게 푸시된 알림을 수신할 수 있도록 허용합니다. Discord 승인이 필요합니다.',
  'social-connection.settings.permission.discord.rpc-voice:read.help': '로컬 rpc 서버 액세스의 경우 사용자의 음성 설정을 읽고 음성 이벤트를 들을 수 있도록 허용합니다. Discord 승인이 필요합니다.',
  'social-connection.settings.permission.discord.rpc-voice:write.help': '로컬 rpc 서버 액세스의 경우 사용자의 음성 설정을 업데이트할 수 있도록 허용합니다. Discord 승인이 필요합니다.',
  'social-connection.settings.permission.discord.webhook-incoming.help': '이렇게 하면 인증 코드 부여에 대한 oauth 토큰 응답에서 반환되는 웹훅이 생성됩니다.',
  'social-connection.settings.permission.discord.identify:premium.help': '사용자가 유효한 Nitro 구독(premium_type 필드)을 보유하고 있는지 여부를 반환합니다. Discord 승인이 필요합니다.',
  'social-connection.settings.permission.epicgames.friends.help': '현재 사용자 계정의 친구 목록에 대한 읽기 액세스 권한을 허용합니다.',
  'social-connection.settings.permission.epicgames.presence:write.help': '애플리케이션이 현재 사용자의 온라인 현재 상태를 설정하고 친구로부터 온라인 현재 상태 업데이트를 받을 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.messenger-contact.help': 'user_messenger_contact 권한은 승인 시 또는 비즈니스 페이지와의 채팅 스레드 시작 시 Messenger를 통해 개인에게 연락할 수 있도록 비즈니스에 허용합니다.',
  'social-connection.settings.permission.facebook.photos.help': 'user_photos 권한은 앱이 Facebook에 업로드한 사진을 읽을 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.posts.help': 'user_posts 권한은 앱이 사용자가 타임라인에 작성한 게시물에 액세스할 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.videos.help': 'user_videos 권한은 앱이 사람이 업로드한 동영상 목록을 읽을 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.friends.help': 'user_friends 권한은 앱이 해당 앱을 사용하는 사람의 친구 목록을 가져올 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.ads:read.help': 'ads_read 권한은 앱이 Ads Insights API에 액세스하여 소유하거나 이 권한을 통해 다른 광고 계정의 소유자가 액세스 권한을 부여한 광고 계정에 대한 광고 보고서 정보를 가져올 수 있습니다.',
  'social-connection.settings.permission.facebook.ads:write.help': 'ads_management 권한은 앱이 소유하거나 광고 계정 소유자가 액세스 권한을 부여한 광고 계정을 읽고 관리할 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.attribution:read.help': 'attribution_read 권한은 소유하거나 다른 영업 부문의 소유자 또는 소유자가 액세스 권한을 부여한 영업 부문에 대한 속성 보고서 데이터를 가져오기 위해 Attribution API에 대한 액세스 권한을 앱에 부여합니다.',
  'social-connection.settings.permission.facebook.business:write.help': 'business_management 권한은 앱이 Business Manager API를 사용하여 읽고 쓸 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.catalog:write.help': 'catalog_management 권한은 앱은 사용자가 관리자인 기업 소유 제품 카탈로그를 생성, 읽기, 업데이트 및 삭제할 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.gaming-user_locale.help': 'gaming_user_locale 권한은 사용자가 Facebook에서 게임(예: 인스턴트 게임 또는 클라우드 게임)을 플레이하는 동안 앱에서 사용자가 선호하는 언어를 가져올 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.groups:read.help': 'groups_access_member_info 권한은 게시물 작성자가 앱 액세스 권한을 부여한 경우 앱에서 이름 및 ID와 같은 공개적으로 사용 가능한 그룹 구성원 정보를 읽을 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.instagram:publish.help': 'instagram_content_publish 권한은 앱에서 비즈니스 사용자를 대신하여 유기적 피드 사진 및 동영상 게시물을 만들 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.instagram-comments:write.help': 'instagram_manage_comments 권한은 앱이 페이지에 연결된 Instagram 계정을 대신하여 댓글을 생성, 삭제 및 숨길 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.instagram-insights:write.help': 'instagram_manage_insights 권한은 앱이 Facebook 페이지에 연결된 Instagram 계정에 대한 인사이트에 액세스할 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.leads:read.help': 'leads_retrieval 권한은 앱이 Ads Manager 또는 Marketing API에서 생성한 광고와 연결된 리드 광고 양식에서 캡처한 모든 정보를 검색하고 읽을 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.pages-events.help': 'page_events 권한은 앱을 사용하는 사람들이 관리하는 Facebook 페이지를 대신하여 이벤트를 기록하고 광고 타겟팅, 최적화 및 보고를 위해 해당 이벤트를 Facebook으로 보낼 수 있는 앱 권한을 허용합니다.',
  'social-connection.settings.permission.facebook.ads-pages:write.help': 'pages_manage_ads 권한은 앱이 페이지와 연결된 광고를 관리할 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.cta:write.help': 'pages_manage_cta 권한은 앱이 Facebook 페이지의 콜 투 액션(call-to-action) 버튼을 관리하는 데 사용되는 엔드포인트에서 POST 및 DELETE 기능을 수행할 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.pages-articles:write.help': 'pages_manage_instant_articles 권한은 앱을 사용하는 사람들이 관리하는 Facebook 페이지를 대신하여 앱이 인스턴트 아티클을 관리할 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.pages-engagement:write.help': 'pages_manage_engagement 권한은 앱이 페이지에 게시된 댓글을 생성, 편집 및 삭제할 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.pages-metadata:write.help': 'pages_manage_metadata 권한은 앱이 페이지 활동에 대한 웹훅을 구독 및 수신하고 페이지 설정을 업데이트할 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.pages-posts:write.help': 'pages_manage_posts 권한은 앱이 페이지 게시물을 생성, 편집 및 삭제할 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.pages-messaging.help': 'pages_messaging 권한은 앱이 Messenger의 페이지 대화를 관리하고 액세스할 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.pages-engagement:read.help': 'pages_read_engagement 권한은 앱이 페이지에서 게시한 콘텐츠(게시물, 사진, 동영상, 이벤트)를 읽고 팔로워 데이터(이름, PSID 포함) 및 프로필 사진을 읽고 페이지에 대한 메타데이터 및 기타 인사이트를 읽을 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.pages-content:read.help': 'pages_read_user_content 권한은 앱이 사용자 또는 다른 페이지의 게시물, 댓글 및 평가와 같이 페이지에서 사용자가 생성한 콘텐츠를 읽고 페이지 게시물에서 사용자 댓글을 삭제할 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.pages-list.help': 'pages_show_list 권한은 앱이 사용자가 관리하는 페이지 목록에 액세스할 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.pages-gender.help': 'pages_user_gender 권한은 연결된 페이지를 통해 앱이 사용자의 성별에 액세스할 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.pages-locale.help': 'Pages_user_gender 권한은 연결된 페이지를 통해 앱이 사용자의 성별에 액세스할 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.pages-timezone.help': 'pages_user_timezone 권한은 앱이 연결된 페이지를 통해 사용자의 시간대에 대한 액세스 권한을 앱에 부여합니다.',
  'social-connection.settings.permission.facebook.groups:write.help': 'publish_to_groups 권한은 앱 액세스 권한을 부여한 사용자를 대신하여 앱이 콘텐츠를 그룹에 게시할 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.video:write.help': 'publish_video 권한은 앱이 앱 사용자의 타임라인, 그룹, 이벤트 또는 페이지에 라이브 동영상을 게시할 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.insights:read.help': 'read_insights 권한은 앱이 개인이 소유한 페이지, 앱 및 웹 도메인에 대한 인사이트 데이터를 읽을 수 있도록 허용합니다.',
  'social-connection.settings.permission.facebook.research-apis.help': 'research_apis 권한은 앱이 Facebook Open Research and Transparency Tool 내에서 공개 Facebook 페이지, 그룹 및 이벤트의 데이터에 액세스할 수 있도록 허용합니다.',
  'social-connection.settings.permission.github.user.help': '프로필 정보에만 읽기/쓰기 액세스 권한을 부여합니다. 이 Scope에는 user:email 및 user:follow가 포함되어 있습니다.',
  'social-connection.settings.permission.github.users-follow:write.help': '다른 사용자를 팔로우하거나 팔로우를 취소할 수 있는 액세스 권한을 부여합니다.',
  'social-connection.settings.permission.github.repo.help': '개인 리포지토리를 포함하여 리포지토리에 대한 전체 액세스 권한을 부여합니다. 여기에는 코드에 대한 읽기/쓰기 액세스 권한, 커밋 상태, 리포지토리 및 조직 프로젝트, 초대, 공동 작업자, 팀 구성원 추가, 배포 상태, 리포지토리 및 조직에 대한 리포지토리 웹훅이 포함됩니다. 또한 사용자 프로젝트를 관리할 수 있는 권한을 부여합니다.',
  'social-connection.settings.permission.github.repo:status.help': '공개 및 비공개 리포지토리의 커밋 상태에 대한 읽기/쓰기 액세스 권한을 부여합니다. 이 Scope는 코드에 대한 액세스 권한을 부여하지 않고 개인 리포지토리 커밋 상태에 대한 다른 사용자 또는 서비스 액세스 권한을 부여하는 경우에만 필요합니다.',
  'social-connection.settings.permission.github.repo_deployment.help': '공개 및 비공개 리포지토리의 배포 상태에 대한 액세스 권한을 부여합니다. 이 Scope는 코드에 대한 액세스 권한을 부여하지 않고 다른 사용자 또는 서비스의 배포 상태에 대한 액세스 권한을 부여하는 데만 필요합니다.',
  'social-connection.settings.permission.github.public_repo.help': '공개 리포지토리에 대한 액세스를 제한합니다. 여기에는 코드에 대한 읽기/쓰기 액세스, 커밋 상태, 리포지토리 프로젝트, 공동 작업자, 공개 리포지토리 및 조직의 배포 상태가 포함됩니다. 또한 공개 리포지토리를 별 표시하는 경우에도 필요합니다.',
  'social-connection.settings.permission.github.repo:invite.help': '리포지토리에서 공동 작업을 위한 초대를 수락/거절할 수 있는 권한을 부여합니다. 이 Scope는 코드에 대한 액세스 권한을 부여하지 않고 다른 사용자 또는 서비스의 초대에 대한 액세스 권한을 부여하는 경우에만 필요합니다.',
  'social-connection.settings.permission.github.security_events.help': '권한 부여: 코드 스캐닝 API의 보안 이벤트에 대한 읽기 및 쓰기 액세스 권한. 비밀 스캐닝 API의 보안 이벤트에 대한 읽기 및 쓰기 액세스 권한. 이 Scope는 코드에 대한 액세스 권한을 부여하지 않고 보안 이벤트에 대한 다른 사용자 또는 서비스 액세스 권한을 부여하는 경우에만 필요합니다.',
  'social-connection.settings.permission.github.admin:repo_hook.help': '공개 또는 비공개 리포지토리의 리포지토리 후크에 대한 읽기, 쓰기, 핑 및 삭제 액세스 권한을 부여합니다. 리포지토리와 public_repo Scope는 리포지토리 후크를 포함하여 리포지토리에 대한 전체 액세스 권한을 부여합니다. 관리자:repo_hook Scope를 사용하면 리포지토리 후크에만 액세스를 제한할 수 있습니다.',
  'social-connection.settings.permission.github.write:repo_hook.help': '공개 또는 비공개 리포지토리의 후크에 대한 읽기, 쓰기 및 핑 액세스 권한을 부여합니다.',
  'social-connection.settings.permission.github.read:repo_hook.help': '공개 또는 비공개 리포지토리의 후크에 대한 읽기 및 핑 액세스 권한을 부여합니다.',
  'social-connection.settings.permission.github.admin:org.help': '조직과 해당 팀, 프로젝트 및 멤버십 전체를 관리.',
  'social-connection.settings.permission.github.write:org.help': '조직 멤버십, 조직 프로젝트 및 팀 멤버십에 대한 읽기 및 쓰기 액세스 권한.',
  'social-connection.settings.permission.github.read:org.help': '조직 멤버십, 조직 프로젝트 및 팀 멤버십에 대한 읽기 전용 액세스 권한.',
  'social-connection.settings.permission.github.admin:public_key.help': '공개 키를 완전히 관리.',
  'social-connection.settings.permission.github.write:public_key.help': '공개 키의 세부 정보를 생성, 나열 및 확인합니다.',
  'social-connection.settings.permission.github.read:public_key.help': '공개 키의 세부 정보를 나열하고 확인합니다.',
  'social-connection.settings.permission.github.admin:org_hook.help': '조직 후크에 대한 읽기, 쓰기, 핑 및 삭제 액세스 권한을 부여합니다. 참고: OAuth 토큰은 OAuth 앱에서 생성한 조직 후크에서만 이러한 작업을 수행할 수 있습니다. 개인 액세스 토큰은 사용자가 생성한 조직 후크에서만 이러한 작업을 수행할 수 있습니다.',
  'social-connection.settings.permission.github.gist.help': 'Gists에 쓰기 액세스 권한을 부여합니다.',
  'social-connection.settings.permission.github.notifications.help': '권한 부여: 사용자 알림에 대한 읽기 액세스 권한. 스레드에 대한 읽기 액세스로 표시. 리포지토리에 대한 액세스를 감시 및 감시 해제하고, 스레드 정기 결제에 대한 읽기, 쓰기 및 삭제 액세스.',
  'social-connection.settings.permission.github.delete_repo.help': '관리 가능한 리포지토리를 삭제할 수 있는 액세스 권한을 부여합니다.',
  'social-connection.settings.permission.github.write:discussion.help': '팀 토론에 대한 읽기 및 쓰기 액세스를 허용합니다.',
  'social-connection.settings.permission.github.read:discussion.help': '팀 토론에 대한 읽기 액세스를 허용합니다.',
  'social-connection.settings.permission.github.write:packages.help': 'GitHub 패키지에서 패키지를 업로드하거나 게시할 수 있는 액세스 권한을 부여합니다. 자세한 정보는 \"패키지 게시\"를 참조하세요.',
  'social-connection.settings.permission.github.read:packages.help': 'GitHub 패키지에서 패키지를 다운로드하거나 설치할 수 있는 액세스 권한을 부여합니다. 자세한 정보는 \"패키지 설치\"를 참조하세요.',
  'social-connection.settings.permission.github.delete:packages.help': 'GitHub 패키지에서 패키지를 삭제할 수 있는 액세스 권한을 부여합니다. 자세한 정보는 \"패키지 삭제 및 복원\"을 참조하세요.',
  'social-connection.settings.permission.github.admin:gpg_key.help': 'GPG 키를 완전히 관리.',
  'social-connection.settings.permission.github.write:gpg_key.help': 'GPG 키에 대한 세부 정보를 생성, 나열 및 확인합니다.',
  'social-connection.settings.permission.github.read:gpg_key.help': 'GPG 키에 대한 세부 정보를 나열하고 확인합니다.',
  'social-connection.settings.permission.github.codespace.help': '코드 스페이스를 만들고 관리할 수 있는 권한을 부여합니다. 코드 스페이스는 다른 Scope 세트를 가질 수 있는 GITHUB_TOKEN을 노출할 수 있습니다. 자세한 정보는 \"코드 스페이스의 보안\"을 참조하세요.',
  'social-connection.settings.permission.github.workflow.help': 'GitHub 작업 워크플로 파일을 추가 및 업데이트할 수 있는 권한을 부여합니다. 동일한 리포지토리의 다른 브랜치에 동일한 파일(동일한 경로와 내용 포함)이 있는 경우 이러한 Scope 없이 워크플로 파일을 커밋할 수 있습니다. 워크플로 파일은 다른 Scope 세트를 가질 수 있는 GITHUB_TOKEN을 노출할 수 있습니다.',
  'social-connection.settings.permission.google.cloud-platform.help': 'Google Cloud Platform 서비스 전체의 데이터를 확인하고 관리합니다.',
  'social-connection.settings.permission.google.adsense.help': 'AdSense 데이터를 확인하고 관리합니다.',
  'social-connection.settings.permission.google.analytics.help': 'Google Analytics 데이터를 확인하고 관리합니다.',
  'social-connection.settings.permission.google.appengine:admin.help': 'Google App Engine에서 배포한 애플리케이션을 확인하고 관리합니다.',
  'social-connection.settings.permission.google.mail:send.help': 'Gmail에서 모든 이메일을 읽고, 작성하고, 보내고, 영구적으로 삭제합니다.',
  'social-connection.settings.permission.google.bigquery.help': 'Google BigQuery에서 데이터를 확인하고 관리합니다.',
  'social-connection.settings.permission.google.blogger.help': 'Blogger 계정을 관리합니다.',
  'social-connection.settings.permission.google.books.help': '서적을 관리합니다.',
  'social-connection.settings.permission.google.calendar:write.help': 'Google Calendar를 사용하여 액세스할 수 있는 모든 캘린더를 확인하고, 수정하고, 공유하고, 영구적으로 삭제합니다.',
  'social-connection.settings.permission.google.ddmconversions.help': 'DoubleClick 디지털 마케팅 전환을 관리합니다.',
  'social-connection.settings.permission.google.bigtable.help': 'Cloud Bigtable 테이블 및 클러스터를 관리합니다.',
  'social-connection.settings.permission.google.content.help': 'Google Shopping의 제품 목록 및 계정을 관리합니다.',
  'social-connection.settings.permission.google.display-video.help': 'Display & Video 360 엔티티 및 보고서를 생성, 확인, 수정하고 영구적으로 삭제합니다.',
  'social-connection.settings.permission.google.doubleclickbidmanager.help': 'DoubleClick Bid Manager에서 보고서를 확인하고 관리합니다.',
  'social-connection.settings.permission.google.files:write.help': '모든 Google 드라이브 파일을 확인하고, 수정하고, 만들고, 삭제합니다.',
  'social-connection.settings.permission.google.firebase.help': '모든 Firebase 데이터 및 설정을 확인하고 관리합니다.',
  'social-connection.settings.permission.google.fitness.help': 'Google Fit 신체 활동 데이터를 확인하고 추가합니다.',
  'social-connection.settings.permission.google.ediscovery.help': 'eDiscovery 데이터를 관리합니다.',
  'social-connection.settings.permission.google.classroom.help': 'Google Classroom 수업을 관리합니다.',
  'social-connection.settings.permission.google.documents.help': 'Google Docs 문서를 확인하고 관리합니다.',
  'social-connection.settings.permission.google.androidpublisher.help': 'Google Play 개발자 계정을 확인하고 관리합니다.',
  'social-connection.settings.permission.google.games.help': 'Google Play 게임 활동을 생성하고 편집하고 삭제합니다.',
  'social-connection.settings.permission.google.webmasters.help': '확인된 사이트에 대한 Search Console 데이터를 확인하고 관리합니다.',
  'social-connection.settings.permission.google.presentations.help': 'Google 프레젠테이션을 확인하고 관리합니다.',
  'social-connection.settings.permission.google.spreadsheets.help': 'Google Drive에서 스프레드시트를 확인하고 수정하고 만들고 삭제합니다.',
  'social-connection.settings.permission.google.manufacturercenter.help': 'Google Manufacturer Center의 제품 목록을 관리합니다.',
  'social-connection.settings.permission.google.contacts:write.help': '연락처를 확인하고 편집하고 다운로드하고 영구적으로 삭제합니다.',
  'social-connection.settings.permission.google.photoslibrary.help': 'Google Photos 라이브러리를 확인하고 관리합니다.',
  'social-connection.settings.permission.google.tagmanager.help': '버전 관리 및 게시를 제외한 Google Tag Manager 컨테이너 및 해당 하위 구성요소를 관리합니다.',
  'social-connection.settings.permission.google.tasks.help': '모든 작업을 생성, 편집, 구성 및 삭제합니다.',
  'social-connection.settings.permission.google.youtube.help': 'YouTube 계정을 관리합니다.',
  'social-connection.settings.permission.kakao.friends.help': '카카오톡 친구 정보.',
  'social-connection.settings.permission.kakao.plusfriends.help': 'Relationship between a Kakao Talk Channel and a user.',
  'social-connection.settings.permission.kakao.story:read.help': '카카오스토리 게시물에 대한 읽기 권한.',
  'social-connection.settings.permission.kakao.story:publish.help': '카카오스토리에 글을 게시합니다.',
  'social-connection.settings.permission.kakao.talk:message.help': '카카오톡으로 메시지를 보냅니다.',
  'social-connection.settings.permission.linkedin.social-user:write.help': '인증된 회원을 대신하여 게시물을 올리고 댓글을 달고 좋아요를 누릅니다.',
  'social-connection.settings.permission.linkedin.social-org:write.help': '조직을 대신하여 게시물을 올리고 댓글을 달고 좋아요를 누릅니다.',
  'social-connection.settings.permission.linkedin.social-org:read.help': '조직의 게시물, 댓글 및 좋아요를 검색합니다.',
  'social-connection.settings.permission.linkedin.ads:write.help': '인증된 회원의 광고 계정을 관리하고 읽습니다.',
  'social-connection.settings.permission.linkedin.ads:read.help': '인증된 회원의 광고 계정을 읽습니다.',
  'social-connection.settings.permission.linkedin.ads-report:read.help': '광고 계정에 대한 보고서를 검색합니다.',
  'social-connection.settings.permission.linkedin.ads-leads:read.help': '인증된 회원의 리드 생성 양식에 액세스하고 리드를 검색합니다.',
  'social-connection.settings.permission.linkedin.connections-1st:view.help': '인증된 구성원의 1촌 연결 수를 검색합니다.',
  'social-connection.settings.permission.linkedin.audience:write.help': '일치하는 Audiences를 만들고 관리합니다.',
  'social-connection.settings.permission.mailru.photoslibrary.help': '사용자의 사진 라이브러리를 보고 관리합니다.',
  'social-connection.settings.permission.mailru.guestbook.help': '사용자의 방명록 항목을 관리합니다.',
  'social-connection.settings.permission.mailru.pages-posts:write.help': '사용자의 \"새 소식\" 피드에 게시합니다.',
  'social-connection.settings.permission.mailru.messages:write.help': '사용자의 개인 메시지에 액세스합니다.',
  'social-connection.settings.permission.mailru.calendar:read.help': '\"나의 세계\"에서 사용자의 이벤트에 액세스합니다.',
  'social-connection.settings.permission.microsoft.user.help': '앱이 로그인한 사용자의 전체 프로필을 읽을 수 있도록 허용합니다. 또한 앱이 사용자를 대신하여 로그인한 사용자의 프로필 정보를 업데이트할 수 있도록 허용합니다.',
  'social-connection.settings.permission.microsoft.users.help': '앱이 로그인한 사용자를 대신하여 조직 내 다른 사용자의 전체 프로필 속성 세트, 보고서 및 관리자를 읽고 쓸 수 있도록 허용합니다. 또한 앱이 로그인한 사용자를 대신하여 사용자를 생성 및 삭제하고 사용자 암호를 재설정할 수 있도록 허용합니다.',
  'social-connection.settings.permission.microsoft.users:invite.help': '앱이 로그인한 사용자를 대신하여 게스트 사용자를 조직에 초대할 수 있도록 허용합니다.',
  'social-connection.settings.permission.microsoft.users:export.help': '회사 관리자가 수행하는 경우 앱이 조직 사용자의 데이터를 내보낼 수 있도록 허용합니다.',
  'social-connection.settings.permission.microsoft.users:manage.help': '애플리케이션이 로그인한 사용자가 액세스할 수 있는 사용자 계정과 연결된 ID를 읽고 업데이트하고 삭제할 수 있도록 허용합니다. 이것은 사용자가 로그인할 수 있는 ID를 제어합니다.',
  'social-connection.settings.permission.microsoft.activities:read.help': '앱이 사용자가 이메일, 회의 또는 채팅 세션에 보낸 시간과 같이 로그인한 사용자의 활동 통계를 읽을 수 있도록 허용합니다.',
  'social-connection.settings.permission.microsoft.apps:read.help': '앱이 앱 카탈로그의 앱을 읽을 수 있도록 허용합니다.',
  'social-connection.settings.permission.microsoft.apps:write.help': '앱이 앱 카탈로그에서 앱을 만들고, 읽고, 업데이트하고, 삭제할 수 있도록 허용합니다.',
  'social-connection.settings.permission.microsoft.logs:read.help': '앱이 로그인한 사용자를 대신하여 감사 로그 활동을 읽고 쿼리하도록 허용합니다.',
  'social-connection.settings.permission.microsoft.bookings:read.help': '읽기 전용 애플리케이션을 위한 것입니다. 일반적인 대상 사용자는 예약 비즈니스의 고객입니다.',
  'social-connection.settings.permission.microsoft.bookings:write.help': '앱이 전체 액세스 권한을 갖도록 허용합니다. 전체 관리 경험을 위한 것입니다. 일반적인 대상 사용자는 조직의 관리자입니다.',
  'social-connection.settings.permission.microsoft.calendar:read.help': '앱이 사용자 캘린더의 이벤트를 읽을 수 있도록 허용합니다.',
  'social-connection.settings.permission.microsoft.calendar:write.help': '앱이 사용자 캘린더에서 이벤트를 만들고, 읽고, 업데이트하고, 삭제할 수 있도록 허용합니다.',
  'social-connection.settings.permission.microsoft.call.help': '앱이 로그인한 사용자 없이 단일 사용자에게 발신 전화를 걸고 조직의 디렉터리에 있는 사용자에게 전화를 전달할 수 있도록 허용합니다.',
  'social-connection.settings.permission.microsoft.call-group.help': '앱이 로그인한 사용자 없이 여러 사용자에게 발신 전화를 걸고 조직의 회의에 참석자를 추가할 수 있도록 허용합니다.',
  'social-connection.settings.permission.microsoft.messages:read.help': '앱이 사용자를 대신하여 Microsoft Teams에서 1:1 또는 그룹 채팅 메시지를 읽을 수 있도록 허용합니다.',
  'social-connection.settings.permission.microsoft.messages:write.help': '앱이 사용자를 대신하여 Microsoft Teams에서 1:1 또는 그룹 채팅 메시지를 읽고 보낼 수 있도록 허용합니다.',
  'social-connection.settings.permission.microsoft.contacts:read.help': '앱이 사용자 연락처를 읽을 수 있도록 허용합니다.',
  'social-connection.settings.permission.microsoft.contacts:write.help': '앱이 사용자 연락처를 만들고, 읽고, 업데이트하고, 삭제할 수 있도록 허용합니다.',
  'social-connection.settings.permission.microsoft.device:read.help': '앱이 로그인한 사용자를 대신하여 사용자의 장치 목록을 읽을 수 있도록 허용합니다.',
  'social-connection.settings.permission.microsoft.files:read.help': '앱이 로그인한 사용자의 파일을 읽을 수 있도록 허용합니다.',
  'social-connection.settings.permission.microsoft.files:write.help': '앱이 로그인한 사용자의 파일을 읽고, 만들고, 업데이트하고, 삭제할 수 있도록 허용합니다.',
  'social-connection.settings.permission.microsoft.mail:read.help': '앱이 사용자 편지함에 있는 이메일을 읽을 수 있도록 허용합니다.',
  'social-connection.settings.permission.microsoft.mail:write.help': '앱이 사용자 편지함에서 이메일을 만들고, 읽고, 업데이트하고, 삭제할 수 있도록 허용합니다. 메일을 보낼 수 있는 권한은 포함되어 있지 않습니다.',
  'social-connection.settings.permission.microsoft.mail:send.help': '앱이 조직의 사용자로 메일을 보낼 수 있도록 허용합니다.',
  'social-connection.settings.permission.microsoft.notes:read.help': '앱이 OneNote 전자 필기장 및 섹션의 제목을 읽고 로그인한 사용자를 대신하여 새 페이지, 전자 필기장 및 섹션을 만들 수 있도록 허용합니다.',
  'social-connection.settings.permission.microsoft.notes:write.help': '앱이 로그인한 사용자를 대신하여 OneNote 전자 필기장을 읽고 공유하고 수정할 수 있도록 허용합니다.',
  'social-connection.settings.permission.microsoft.presence:read.help': '앱이 로그인한 사용자를 대신하여 현재 상태 정보를 읽을 수 있도록 허용합니다. 현재 상태 정보에는 활동, 가용성, 상태 메모, 캘린더 부재 중 메시지, 시간대 및 위치가 포함됩니다.',
  'social-connection.settings.permission.microsoft.presence:write.help': '앱이 로그인한 사용자를 대신하여 현재 상태 정보를 읽고 활동 및 참석 여부를 쓸 수 있도록 허용합니다. 현재 상태 정보에는 활동, 가용성, 상태 메모, 캘린더 부재 중 메시지, 시간대 및 위치가 포함됩니다.',
  'social-connection.settings.permission.microsoft.tasks:read.help': '앱이 사용자와 공유된 작업을 포함하여 로그인한 사용자의 작업 및 작업 목록을 읽을 수 있도록 허용합니다. 생성, 삭제 또는 업데이트 권한은 포함되지 않습니다.',
  'social-connection.settings.permission.microsoft.tasks:write.help': '앱이 사용자와 공유된 작업을 포함하여 로그인한 사용자의 작업 및 작업 목록을 생성, 읽기, 업데이트 및 삭제할 수 있도록 허용합니다.',
  'social-connection.settings.permission.ok.photos.help': '사용자의 사진에 대한 액세스 권한.',
  'social-connection.settings.permission.ok.groups.help': '사용자 그룹에 대한 액세스 권한.',
  'social-connection.settings.permission.ok.videos.help': '사용자의 동영상에 대한 액세스 권한',
  'social-connection.settings.permission.ok.application:invite.help': 'friends.appInvite 메소드를 사용하여 게임에 친구를 초대할 수 있는 권한.',
  'social-connection.settings.permission.reddit.user.help': '기본 설정 및 관련 계정 정보를 업데이트합니다. 이메일 또는 암호에는 액세스할 수 없스니다.',
  'social-connection.settings.permission.reddit.credits.help': '다른 사용자에게 골드를 제공할 경우 나의 reddit 골드 크레딧을 사용합니다.',
  'social-connection.settings.permission.reddit.pages-engagement:write.help': '내 댓글과 제출 항목을 수정하고 삭제합니다.',
  'social-connection.settings.permission.reddit.flair.help': '내 하위 레딧 flair를 선택합니다. 내 제출 항목에 대한 링크 flair를 변경합니다.',
  'social-connection.settings.permission.reddit.votes:read.help': '내 투표 내역과 내가 저장했거나 숨긴 댓글 또는 제출 항목에 액세스합니다.',
  'social-connection.settings.permission.reddit.live-threads:read.help': '내가 기여한 라이브 스레드의 설정 및 기여자를 관리합니다.',
  'social-connection.settings.permission.reddit.modconfig.help': '내가 중재하는 하위 레딧의 구성, 사이드바 및 CSS를 관리합니다.',
  'social-connection.settings.permission.reddit.modcontributors.help': '승인된 사용자 목록에 사용자를 추가/제거하고 내가 중재하는 하위 레딧에서 사용자를 차단/차단 해제하거나 음소거/음소거 해제합니다.',
  'social-connection.settings.permission.reddit.modflair.help': '내가 중재하는 하위 레딧에서 flair를 관리하고 할당합니다.',
  'social-connection.settings.permission.reddit.modlog.help': '내가 중재하는 하위 레딧에서 중재 로그에 액세스합니다.',
  'social-connection.settings.permission.reddit.modmail.help': 'mod.reddit.com을 통해 modmail에 액세스하고 관리합니다.',
  'social-connection.settings.permission.reddit.modothers.help': '내가 중재하는 하위 레딧에서 다른 중재자를 초대하거나 제거합니다.',
  'social-connection.settings.permission.reddit.modposts.help': '내가 중재하는 하위 레딧에서 nsfw를 승인, 제거, 표시하고 구분합니다.',
  'social-connection.settings.permission.reddit.modself.help': '하위 레딧을 중재하기 위한 초대를 수락합니다. 내가 중재하거나 기여하는 하위 레딧의 중재자 또는 기여자에서 \'나\'를 제거합니다.',
  'social-connection.settings.permission.reddit.modwiki.help': '내가 중재하는 하위 레딧에서 편집자와 위키 페이지의 가시성을 변경합니다.',
  'social-connection.settings.permission.reddit.mysubreddits.help': '내가 중재하고, 기여하고, 구독하는 하위 레딧 목록에 액세스합니다.',
  'social-connection.settings.permission.reddit.messages:write.help': '내 받은 편지함에 액세스하고 다른 사용자에게 비공개 메시지를 보냅니다.',
  'social-connection.settings.permission.reddit.pages-engagement:read.help': '내 계정을 통해 게시물과 댓글에 액세스합니다.',
  'social-connection.settings.permission.reddit.report.help': '규칙 위반에 대한 내용을 보고합니다. 개별 제출 항목을 숨기고 표시합니다.',
  'social-connection.settings.permission.reddit.save.help': '댓글과 제출 항목을 저장 및 저장 취소합니다.',
  'social-connection.settings.permission.reddit.structuredstyles.help': '내가 중재하는 하위 레딧의 구조화된 스타일을 편집합니다.',
  'social-connection.settings.permission.reddit.submit.help': '내 계정에서 링크와 의견을 제출합니다.',
  'social-connection.settings.permission.reddit.subscribe.help': '내 하위 레딧 정기 결제을 관리합니다. 내가 팔로우하는 콘텐츠 사용자인 \"친구\"를 관리합니다.',
  'social-connection.settings.permission.reddit.vote.help': '댓글과 제출 항목에 대한 내 투표를 제출하고 변경합니다.',
  'social-connection.settings.permission.reddit.wiki:edit.help': '나를 대신하여 위키 페이지를 편집합니다.',
  'social-connection.settings.permission.reddit.wiki:read.help': '내 계정을 통해 위키 페이지를 읽습니다.',
  'social-connection.settings.permission.twitch.user.help': '사용자 객체를 관리합니다.',
  'social-connection.settings.permission.twitch.users-follow:read.help': '사용자가 팔로우하는 채널 목록을 확인합니다.',
  'social-connection.settings.permission.twitch.user-subscriptions:read.help': '승인된 사용자가 특정 채널에 가입되어 있는지 확인합니다.',
  'social-connection.settings.permission.twitch.user-block:read.help': '사용자의 차단 목록을 봅니다.',
  'social-connection.settings.permission.twitch.user-block:write.help': '사용자의 차단 목록을 관리합니다.',
  'social-connection.settings.permission.twitch.bits:read.help': '채널에 대한 Bits 정보를 확인합니다.',
  'social-connection.settings.permission.twitch.analytics-extensions.help': '인증된 계정이 소유한 Twitch Extensions에 대한 분석 데이터를 확인합니다.',
  'social-connection.settings.permission.twitch.analytics-games.help': '인증된 계정이 소유한 게임에 대한 분석 데이터를 확인합니다.',
  'social-connection.settings.permission.twitch.channel:edit:commercial.help': '채널에서 광고를 실행합니다.',
  'social-connection.settings.permission.twitch.channel:manage:broadcast.help': '채널 구성 업데이트와 스트림 마커 및 스트림 태그 관리 등 채널의 브로드캐스트 구성을 관리합니다.',
  'social-connection.settings.permission.twitch.channel:manage:extensions.help': 'Extensions 활성화를 포함하여 채널의 Extension 구성을 관리합니다.',
  'social-connection.settings.permission.twitch.channel:manage:polls.help': '채널의 투표를 관리합니다.',
  'social-connection.settings.permission.twitch.channel:manage:predictions.help': '채널의 Channel Points Predictions을 관리합니다.',
  'social-connection.settings.permission.twitch.channel:manage:redemptions.help': '채널에서 Channel Points 맞춤 보상 및 사용을 관리합니다.',
  'social-connection.settings.permission.twitch.channel:manage:schedule.help': '채널의 스트림 일정을 관리합니다.',
  'social-connection.settings.permission.twitch.channel:manage:videos.help': '동영상 삭제 등 채널의 동영상을 관리합니다.',
  'social-connection.settings.permission.twitch.channel:read:editors.help': '채널의 편집자 역할을 가진 사용자 목록을 확인합니다.',
  'social-connection.settings.permission.twitch.channel:read:goals.help': '채널의 크리에이터 목표를 확인합니다.',
  'social-connection.settings.permission.twitch.channel:read:hype_train.help': '채널의 Hype Train 정보를 확인합니다.',
  'social-connection.settings.permission.twitch.channel:read:polls.help': '채널의 투표를 확인합니다.',
  'social-connection.settings.permission.twitch.channel:read:predictions.help': '채널의 Channel Points Predictions을 확인합니다.',
  'social-connection.settings.permission.twitch.channel:read:redemptions.help': '채널에서 Channel Points 맞춤 보상 및 사용을 확인합니다.',
  'social-connection.settings.permission.twitch.channel:read:stream_key.help': '승인된 사용자의 스트림 키를 확인합니다.',
  'social-connection.settings.permission.twitch.channel:read:subscriptions.help': '채널의 모든 구독자 목록을 확인하고 사용자가 채널을 구독 중인지 확인합니다.',
  'social-connection.settings.permission.twitch.clips:edit.help': '채널의 클립을 관리합니다.',
  'social-connection.settings.permission.twitch.moderation:read.help': '중재자, 금지, 시간 초과 및 자동 모드 설정 등 채널의 중재 데이터를 확인합니다.',
  'social-connection.settings.permission.twitch.moderator:manage:banned_users.help': '사용자 차단 및 차단 해제.',
  'social-connection.settings.permission.twitch.moderator:read:blocked_terms.help': '브로드캐스터의 차단된 용어 목록을 확인합니다.',
  'social-connection.settings.permission.twitch.moderator:manage:blocked_terms.help': '브로드캐스터의 차단된 용어 목록을 관리합니다.',
  'social-connection.settings.permission.twitch.moderator:manage:automod.help': '중재자인 채널에서 AutoMod가 검토를 위해 보류한 메시지를 관리합니다.',
  'social-connection.settings.permission.twitch.moderator:read:automod_settings.help': '브로드캐스터의 AutoMod 설정을 확인합니다.',
  'social-connection.settings.permission.twitch.moderator:manage:automod_settings.help': '브로드캐스터의 AutoMod 설정을 관리합니다.',
  'social-connection.settings.permission.twitch.moderator:read:chat_settings.help': '브로드캐스터의 채팅방 설정을 확인합니다.',
  'social-connection.settings.permission.twitch.moderator:manage:chat_settings.help': '브로드캐스터의 채팅방 설정을 관리합니다.',
  'social-connection.settings.permission.vimeo.promo-codes:vimeo.help': 'Vimeo On Demand 프로모션을 추가, 제거 및 검토합니다.',
  'social-connection.settings.permission.vimeo.upload:vimeo.help': '동영상을 업로드합니다.',
  'social-connection.settings.permission.vimeo.interact:vimeo.help': '동영상을 좋아하거나 회원을 팔로우하는 등 Vimeo 리소스와 상호 작용합니다.',
  'social-connection.settings.permission.vimeo.delete:vimeo.help': '동영상 등 기존 Vimeo 리소스를 삭제합니다.',
  'social-connection.settings.permission.vimeo.edit:vimeo.help': '동영상 등 기존 Vimeo 리소스를 편집합니다.',
  'social-connection.settings.permission.vimeo.create:vimeo.help': '쇼케이스, 그룹, 채널, 포트폴리오와 같은 새로운 Vimeo 리소스를 생성합니다. 새 동영상을 생성하려면 업로드 Scope가 필요합니다.',
  'social-connection.settings.permission.vimeo.purchased:vimeo.help': '회원의 Vimeo On Demand 구매 내역에 액세스합니다.',
  'social-connection.settings.permission.vimeo.files:write.help': 'Vimeo Pro 멤버십 이상의 회원의 동영상 파일에 액세스합니다.',
  'social-connection.settings.permission.vk.notify.help': '사용자가 상대에게 알림을 보낼 수 있도록 허용했습니다(플래시/iframe 응용 프로그램의 경우).',
  'social-connection.settings.permission.vk.relationships:read.help': '친구에 대한 액세스 권한.',
  'social-connection.settings.permission.vk.photos.help': '사진에 대한 액세스 권한.',
  'social-connection.settings.permission.vk.audio.help': '오디오 녹음에 대한 액세스 권한.',
  'social-connection.settings.permission.vk.videos.help': '동영상 녹화에 대한 액세스 권한.',
  'social-connection.settings.permission.vk.stories.help': '친구에 대한 액세스 권한.',
  'social-connection.settings.permission.vk.posts.help': '위키 페이지에 대한 액세스 권한.',
  'social-connection.settings.permission.vk.status.help': '사용자 상태에 대한 액세스 권한.',
  'social-connection.settings.permission.vk.notes.help': '메모에 대한 액세스 권한.',
  'social-connection.settings.permission.vk.messages:write.help': '고급 메시지 작업 방법에 대한 액세스 권한(독립 실행형 애플리케이션만 해당, [중재 통과함](참조/로드맵)).',
  'social-connection.settings.permission.vk.wall.help': '일반 및 고급 벽 기술에 대한 액세스 권한. 이 액세스 권한은 기본적으로 사이트에 사용할 수 없습니다.',
  'social-connection.settings.permission.vk.ads:write.help': '광고 API로 하는 고급 작업의 방법에 대한 액세스 권한. 암시적 흐름 또는 인증 코드 흐름 체계에 의한 권한 부여에 사용할 수 있습니다.',
  'social-connection.settings.permission.vk.offline.help': '언제든지 API에 대한 액세스 권한(이 옵션을 사용하는 경우. access_token이 0(무제한 토큰)을 포함할 경우 expires_in 매개변수를 반환함). Open API에는 적용되지 않습니다.',
  'social-connection.settings.permission.vk.files.help': '문서에 대한 액세스 권한',
  'social-connection.settings.permission.vk.groups.help': '사용자 그룹에 대한 액세스 권한.',
  'social-connection.settings.permission.vk.notifications.help': '사용자에 대한 응답에 대한 알림의 액세스 권한.',
  'social-connection.settings.permission.vk.groups:stats.help': '사용자가 관리자인 그룹 및 애플리케이션의 통계에 대한 엑세스 권한.',
  'social-connection.settings.permission.vk.market.help': '상품에 대한 액세스 권한.',
  'social-connection.settings.permission.weibo.all.help': '아래에서 모든 Scope 권한을 요청합니다.',
  'social-connection.settings.permission.weibo.messages:write.help': '개인 메시지 전송 인터페이스.',
  'social-connection.settings.permission.weibo.messages:read.help': '개인 메시지 읽기 인터페이스.',
  'social-connection.settings.permission.weibo.application:invite.help': '인터페이스를 보내기 위한 초대.',
  'social-connection.settings.permission.weibo.groups:read.help': '인터페이스 그룹을 읽는 친구 그룹.',
  'social-connection.settings.permission.weibo.groups:write.help': '친구 그룹 쓰기 인터페이스 그룹.',
  'social-connection.settings.permission.weibo.status.help': 'Orient Weibo가 인터페이스 그룹을 읽기 위한 Orient Weibo',
  'social-connection.settings.permission.yahoo.contacts:read.help': '문의하기.',
  'social-connection.settings.permission.yahoo.contacts:write.help': '문의하기.',
  'social-connection.settings.permission.yahoo.fantasy-sport:read.help': '판타지 스포츠.',
  'social-connection.settings.permission.yahoo.fantasy-sport:write.help': '판타지 스포츠.',
  'social-connection.settings.permission.yahoo.finance:read.help': '금융.',
  'social-connection.settings.permission.yahoo.finance:write.help': '금융.',
  'social-connection.settings.permission.yahoo.ads:write.help': 'Oath Ad 플랫폼.',
  'social-connection.settings.permission.yahoo.ads-publishers:read.help': '게시자용 Oath Ad 플랫폼.',
  'social-connection.settings.permission.yahoo.messages:write.help': 'Messenger.',

  'legal-settings.breadcrumb.label': '법률 관련 설정',
  'legal-settings.tabs.terms-and-policies': '약관 및 정책',
  'legal-settings.tabs.age-restrictions': '나이 제한',

  // https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=407%3A32764
  'terms-and-policies.settings.title': '약관 및 정책',
  'terms-and-policies.settings.subtitle': '규정을 준수하고 사용자와의 법적 관계를 정의하는 약관과 정책에 대한 링크를 제공합니다. 사용자는 로그인 위젯 화면에서 이러한 링크를 보게 됩니다.',
  'terms-and-policies.tos-url.input.title': '이용 약관 URL(필수)',
  'terms-and-policies.privacy-policy-url.input.title': '개인정보 보호정책 URL',
  'terms-and-policies.cookies-policy-url.input.title': '쿠키 정책 URL',

  // https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=8380%3A132843
  'age-restrictions.settings.title': '나이 제한',
  'age-restrictions.settings.subtitle': '로그인 프로젝트에 연령 제한을 설정합니다. 엑솔라는 등록된 사용자가 추가 단계를 진행하지 않도록 사용자의 생년월일을 저장합니다.',
  'age-restrictions.settings.notification': '연령 제한을 설정한 경우 사용자는 가입할 때 위젯의 입력 필드를 통해 생년월일 정보를 제공해야 합니다. <a>추가 사용자 정보 설정</a>에서 이 필드를 활성화해야 합니다.',
  'age-restrictions.settings.all-countries.label': '최소 연령 | 모든 국가',
  'age-restrictions.settings.specific-countries.label': '특정 국가의 연령 제한',
  'age-restrictions.settings.specific-countries.placeholder': '국가 선택',
  'age-restrictions.settings.country.placeholder': '요구 연령',

  // https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=5435-99581
  'widget-customization.breadcrumb.label': '사용자 정의',
  'widget-customization.tabs.widget': '위젯',
  'widget-customization.tabs.email': '이메일',
  'widget-customization.tabs.sms': 'SMS',
  'widget-customization.settings.title': '위젯 사용자 정의',
  'widget-customization.settings.subtitle': '사용자를 대상으로 하는 가입 및 로그인 위젯을 만들고 사용자 정의합니다.',
  'widget-customization.settings.bar.label': '위젯',
  'widget-customization.settings.bar.select-method.passwordless': '암호 없는 로그인',
  'widget-customization.settings.bar.select-method.classic': '클래식 로그인',
  'widget-customization.settings.bar.select-method.social': '소셜 로그인',
  'widget-customization.settings.bar.select-mode': '미리보기',
  'widget-customization.settings.bar.customize': '사용자 정의',
  'widget-customization.settings.preview-code.copy': '코드 복사',
  'widget-customization.settings.language.title': '언어',
  'widget-customization.settings.language.description': '위젯에 대해 제공된 언어 중 하나를 선택할 수 있습니다.',
  'widget-customization.settings.language.notification': '위젯 초기화 코드에서 <o>preferredLocale</o> 옵션을 사용하여 언어를 변경할 수도 있습니다. <br></br>언어를 선택하지 않으면 사용자 IP 주소에 따라 언어가 자동으로 설정됩니다.',
  'widget-customization.settings.provided-language.title': '사용 가능한 언어',
  'widget-customization.settings.provided-language.description': '<a>언어 구현에 대한 자세한 내용을 알아보세요</a>.',
  'widget-customization.settings.placeholder.autodetected': '자동 감지됨',
  'widget-customization.settings.country.title': '국가',
  'widget-customization.settings.country.description': '가장 많이 사용된 곳부터 가장 적게 사용된 곳까지 선택한 국가에 해당하는 소셜 네트워크 목록을 보려면 국가를 선택하세요.',
  'widget-customization.settings.country.notification': '소셜 네트워크 사용자 정의 순서를 생성하기 위해 <a>소셜 네트워크 순위를 엽니다</a>.',
  'widget-customization.settings.country-select.title': '국가',
  'widget-customization.settings.oauth.title': 'OAuth 2.0 클라이언트',
  'widget-customization.settings.oauth.description': '위젯에 대해 생성한 하나의 OAuth 2.0 클라이언트를 선택할 수 있습니다.',
  'widget-customization.settings.oauth.dropdown.none': '없음',
  'widget-customization.settings.provided-oauth.title': '사용할 수 있는 OAuth 2.0 클라이언트',
  'widget-customization.settings.visual.title': '추가 사용자 정의',
  'widget-customization.settings.visual.description': 'CSS는 위젯 편집기의 스타일과 함께 적용됩니다.',
  'widget-customization.settings.visual.custom-styles.title': '사용자 정의 CSS 스타일',
  'widget-customization.settings.visual.custom-styles.placeholder': 'CSS 업로드',
  'widget-customization.settings.language-select.language.ru': '러시아어',
  "widget-customization.settings.language-select.language.en": "영어",
  "widget-customization.settings.language-select.language.cn": "중국어(간체)",
  "widget-customization.settings.language-select.language.ko": "한국어",
  "widget-customization.settings.language-select.language.es": "스페인어",
  "widget-customization.settings.language-select.language.fr": "프랑스어",
  "widget-customization.settings.language-select.language.pt": "포르투칼어",
  "widget-customization.settings.language-select.language.it": "이탈리아어",
  "widget-customization.settings.language-select.language.de": "독일어",
  "widget-customization.settings.language-select.language.he": "히브리어",
  "widget-customization.settings.language-select.language.ar": "아랍어",
  "widget-customization.settings.language-select.language.tw": "중국어(번체)",
  "widget-customization.settings.language-select.language.vi": "베트남어",
  "widget-customization.settings.language-select.language.cs": "체코어",
  "widget-customization.settings.language-select.language.pl": "폴란드어",
  "widget-customization.settings.language-select.language.bg": "불가리아어",
  "widget-customization.settings.language-select.language.ro": "로마니아어",
  "widget-customization.settings.language-select.language.tr": "터키어",
  "widget-customization.settings.language-select.language.th": "태국어",
  "widget-customization.settings.language-select.language.ja": "일본어",
  "widget-customization.settings.language-select.language.ph": "타갈로그어",
  "widget-customization.settings.language-select.language.ne": "네팔어",
  "widget-customization.settings.language-select.language.my": "버마어",
  "widget-customization.settings.language-select.language.lo": "라오어",
  "widget-customization.settings.language-select.language.km": "크메르어",
  "widget-customization.settings.language-select.language.id": "인도네시아어",
  'widget-customization.old.instruction': '<ul><ol>1. <a1>템플릿 SCSS</a1> 다운로드.</ol><ol>2. CSS 생성 및 사용자 정의(자세한 내용은 <a2>설명서</a2>조)</ol><ol>3. CSS 업로드.</ol></ul>',
  'widget-customization.old.upload_css.placeholder': 'CSS 업로드',

  'email-customization.settings.bar.label': '이메일',
  'email-customization.settings.bar.options.verificationCode': '확인 이메일(코드 포함)',
  'email-customization.settings.bar.options.verificationLinkCode': '확인 이메일(링크 및 코드 포함)',
  'email-customization.settings.bar.options.mfaCode': 'MFA 코드 이메일',
  'email-customization.settings.bar.options.mfaSettingsChange': 'MFA 설정 변경 이메일',
  'email-customization.settings.bar.options.welcome': '환영 이메일',
  'email-customization.settings.bar.options.passwordChange': '암호 변경 이메일',
  'email-customization.settings.bar.options.blockedAccount': '계정 차단 이메일',
  'email-customization.settings.bar.options.registrationConfirm': '등록 확인 이메일',
  'email-customization.settings.bar.options.emailChange': '이메일 주소 변경 이메일',
  'email-customization.settings.bar.options.newsSubscribe': '뉴스 구독 이메일',
  'email-customization.settings.bar.options.custom': '사용자 정의 이메일',
  'email-customization.title': '이메일 사용자 정의',
  'email-customization.subtitle': '사용자에게 보내는 이메일을 사용자 정의합니다.',
  'email-customization.settings.label': '이메일 설정',
  'email-customization.settings.send-from.label': '발신자 이름',
  'email-customization.settings.send-from.footer': '귀하로부터 이메일을 받는 수신자에게 이 이름이 표시됩니다.',
  'email-customization.settings.send-from.placeholder': 'no-reply@xsolla.com',
  'email-customization.settings.send-from.notification': '이메일을 사용자 정의하지 않으면 기본 엑솔라 템플릿을 사용하게 됩니다.',
  'passkey.settings.title': '패스키',
  'passkey.settings.subtitle': "패스키는 사용자의 장치에 저장되며 지문, 얼굴 또는 기기 PIN으로 잠금을 해제합니다. 패스키는 추가 로그인 방식이며 기존에 사용하던 로그인 방식을 대체하지 않습니다.",
  'passkey.settings.usage.title': '패스키 사용',
  'passkey.settings.usage.subtitle': '활성화하면 사용자가 로그인한 후 패스키를 생성하고 다음 방문 시 사용할 수 있습니다.',
  'passkey.settings.toggle.title': '패스키 허용',
  'passkey.settings.toggle.description': '다른 로그인 방식을 하나 이상 활성화해 두세요. 패스키를 프로젝트에 로그인하는 유일한 수단으로 사용할 수 없습니다.'
};

module.exports = localizations;
